import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createSlots as o, createTextVNode as s, createVNode as c, defineComponent as l, mergeModels as u, normalizeClass as d, openBlock as f, reactive as p, ref as m, renderList as h, renderSlot as g, resolveDynamicComponent as _, toDisplayString as v, unref as y, useAttrs as b, useModel as ee, useTemplateRef as te, watch as ne, withCtx as x } from "vue";
import { Notification as S, useNotification as re } from "@myparcel-frontend/notifications";
import { ActionButton as ie, ActionButtonWrapper as C, Badge as ae, Button as oe, ButtonWithSpinner as se, CarrierLogo as ce, CarrierTruck48 as le, ClipboardText as ue, Date as de, EcommercePlatformLogo as fe, Edit as pe, ExternalLinkAnchor as me, FormRow as he, Heading as ge, IconBase as _e, IconSize as ve, LoadMoreSection as ye, Modal as be, MyParcelShopLogo as xe, Notification as Se, PackageTypeIcon as Ce, PopOver as we, RadioGroup as Te, SidePanel as Ee, Spinner as De, TabLink as Oe, TrackAndTraceTimeline as ke, Trash as Ae } from "@myparcel-frontend/ui";
import { useAsyncState as je } from "@vueuse/core";
import { useI18n as Me } from "vue-i18n";
import * as w from "zod";
import Ne from "zod";
import { useSdk as Pe } from "@myparcel-frontend/sdk";
import { isValidPostalCode as Fe } from "@myparcel-frontend/address-service";
import { Form as Ie, TextInputField as Le, utils as Re } from "@myparcel-frontend/forms";
import { useForm as ze } from "vee-validate";
import { IconBase as Be, IconSize as Ve } from "@myparcel-frontend/icons";
import { useTrackAndTrace as He } from "@myparcel-frontend/composables";
//#region ../../libs/types/dist/index.js
var T = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, E = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
T.Dhl, T.Instabox, T.PostNl, E.PostNl, T.Bpost, E.Bpost, T.CheapCargo, E.CheapCargo, T.Dpd, E.Dpd, T.Instabox, E.Instabox, T.Dhl, E.Dhl, T.Bol, E.Bol, T.Ups, E.Ups, T.DhlForYou, E.DhlForYou, T.DhlParcelConnect, E.DhlParcelConnect, T.DhlEuroPlus, E.DhlEuroPlus, T.UpsStandard, E.UpsStandard, T.UpsExpressSaver, E.UpsExpressSaver, T.Gls, E.Gls, T.Brt, E.Brt, T.Trunkrs, E.Trunkrs, T.InPost, E.InPost, T.PosteItaliane, E.PosteItaliane, T.Spring, E.Spring, T.ViaTim, E.ViaTim;
var Ue = {
	[T.PostNl]: E.POSTNL,
	[T.Bpost]: E.BPOST,
	[T.CheapCargo]: E.CHEAP_CARGO,
	[T.Dpd]: E.DPD,
	[T.Instabox]: E.INSTABOX,
	[T.Dhl]: E.DHL,
	[T.Bol]: E.BOL,
	[T.Ups]: E.UPS,
	[T.DhlForYou]: E.DHL_FOR_YOU,
	[T.DhlParcelConnect]: E.DHL_PARCEL_CONNECT,
	[T.DhlEuroPlus]: E.DHL_EUROPLUS,
	[T.UpsStandard]: E.UPS_STANDARD,
	[T.UpsExpressSaver]: E.UPS_EXPRESS_SAVER,
	[T.Gls]: E.GLS,
	[T.Brt]: E.BRT,
	[T.Trunkrs]: E.TRUNKRS,
	[T.InPost]: E.INPOST,
	[T.PosteItaliane]: E.POSTE_ITALIANE,
	[T.Spring]: E.SPRING,
	[T.ViaTim]: E.VIA_TIM
}, We = (e) => Ue[e], Ge = {
	[E.PostNl]: T.PostNl,
	[E.POSTNL]: T.PostNl,
	[E.Bpost]: T.Bpost,
	[E.BPOST]: T.Bpost,
	[E.CheapCargo]: T.CheapCargo,
	[E.CHEAP_CARGO]: T.CheapCargo,
	[E.Dpd]: T.Dpd,
	[E.DPD]: T.Dpd,
	[E.Instabox]: T.Instabox,
	[E.Dhl]: T.Dhl,
	[E.BolCom]: T.Bol,
	[E.Bol]: T.Bol,
	[E.BOL]: T.Bol,
	[E.Ups]: T.Ups,
	[E.DhlForYou]: T.DhlForYou,
	[E.DHL_FOR_YOU]: T.DhlForYou,
	[E.DhlParcelConnect]: T.DhlParcelConnect,
	[E.DHL_PARCEL_CONNECT]: T.DhlParcelConnect,
	[E.DhlEuroPlus]: T.DhlEuroPlus,
	[E.DHL_EUROPLUS]: T.DhlEuroPlus,
	[E.UpsStandard]: T.UpsStandard,
	[E.UPS_STANDARD]: T.UpsStandard,
	[E.UpsExpressSaver]: T.UpsExpressSaver,
	[E.UPS_EXPRESS_SAVER]: T.UpsExpressSaver,
	[E.Gls]: T.Gls,
	[E.GLS]: T.Gls,
	[E.Brt]: T.Brt,
	[E.BRT]: T.Brt,
	[E.Trunkrs]: T.Trunkrs,
	[E.TRUNKRS]: T.Trunkrs,
	[E.InPost]: T.InPost,
	[E.INPOST]: T.InPost,
	[E.PosteItaliane]: T.PosteItaliane,
	[E.POSTE_ITALIANE]: T.PosteItaliane,
	[E.Spring]: T.Spring,
	[E.SPRING]: T.Spring,
	[E.ViaTim]: T.ViaTim,
	[E.VIA_TIM]: T.ViaTim
}, Ke = (e) => Ge[e], qe = {
	[T.PostNl]: "postnl",
	[T.Bpost]: "bpost",
	[T.CheapCargo]: "cheapCargo",
	[T.Dpd]: "dpd",
	[T.Instabox]: "instabox",
	[T.Dhl]: "dhl",
	[T.Bol]: "bol",
	[T.Ups]: "ups",
	[T.DhlForYou]: "dhlForYou",
	[T.DhlParcelConnect]: "dhlParcelConnect",
	[T.DhlEuroPlus]: "dhlEuroplus",
	[T.UpsStandard]: "upsStandard",
	[T.UpsExpressSaver]: "upsExpressSaver",
	[T.Gls]: "gls",
	[T.Brt]: "brt",
	[T.Trunkrs]: "trunkrs",
	[T.InPost]: "inPost",
	[T.PosteItaliane]: "posteItaliane",
	[T.ViaTim]: "viaTim"
}, Je = (e) => {
	if (e == null || e === "") return "";
	let t = typeof e == "number" ? e : Ge[e];
	return t != null && qe[t] || String(e);
}, D = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
}, Ye = [
	D.Austria,
	D.Belgium,
	D.Bulgaria,
	D.Croatia,
	D.Cyprus,
	D.CzechRepublic,
	D.Denmark,
	D.Estonia,
	D.Finland,
	D.France,
	D.Germany,
	D.Greece,
	D.Hungary,
	D.Ireland,
	D.Italy,
	D.Latvia,
	D.Lithuania,
	D.Luxembourg,
	D.Malta,
	D.Netherlands,
	D.Poland,
	D.Portugal,
	D.Romania,
	D.Slovakia,
	D.Slovenia,
	D.Spain,
	D.Sweden
];
Object.values(D), D.Angola, D.AntiguaAndBarbuda, D.Aruba, D.Bahamas, D.Belize, D.Benin, D.Bermuda, D.BonaireSintEustatiusAndSaba, D.Botswana, D.BurkinaFaso, D.Burundi, D.Cameroon, D.CanaryIslands, D.CentralAfricanRepublic, D.Comoros, D.CongoBrazzaville, D.CongoKinshasa, D.CoteDIvoire, D.Curacao, D.Djibouti, D.Dominica, D.DutchAntilles, D.EquatorialGuinea, D.Eritrea, D.Fiji, D.Gabon, D.Gambia, D.Ghana, D.Grenada, D.Guyana, D.HongKong, D.Kiribati, D.KoreaPeoplesDemocraticRepublic, D.Macao, D.Malawi, D.Mali, D.Mauritania, D.Nauru, D.Qatar, D.Rwanda, D.SaintKittsAndNevis, D.SaoTomeAndPrincipe, D.Seychelles, D.SierraLeone, D.SintMaarten, D.Suriname, D.SyrianArabRepublic, D.TimorLeste, D.Togo, D.Tonga, D.Tuvalu, D.Uganda, D.UnitedArabEmirates, D.Vanuatu, D.Yemen, D.Zimbabwe, D.Austria, D.Belgium, D.Bulgaria, D.Croatia, D.CzechRepublic, D.Estonia, D.Finland, D.France, D.Germany, D.Greece, D.Hungary, D.Ireland, D.Italy, D.Latvia, D.Lithuania, D.Luxembourg, D.Malta, D.Netherlands, D.Portugal, D.Romania, D.Slovakia, D.Slovenia, D.Spain, D.UnitedKingdom;
var Xe = [
	D.Denmark,
	D.Germany,
	D.Sweden
], Ze = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, Qe = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, $e = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
Ze.EarlyMorning, Qe.EarlyMorning, Ze.Morning, Qe.Morning, Ze.Standard, Qe.Standard, Ze.Evening, Qe.Evening, Ze.Pickup, Qe.Pickup, Ze.PickupExpress, Qe.PickupExpress, Ze.SameDayDelivery, Qe.SameDayDelivery, Ze.Express, Qe.Express;
var et = {
	[Qe.EarlyMorning]: Ze.EarlyMorning,
	[Qe.Morning]: Ze.Morning,
	[Qe.Standard]: Ze.Standard,
	[Qe.Evening]: Ze.Evening,
	[Qe.Pickup]: Ze.Pickup,
	[Qe.PickupExpress]: Ze.PickupExpress,
	[Qe.SameDayDelivery]: Ze.SameDayDelivery,
	[Qe.Express]: Ze.Express
};
Ze.EarlyMorning, $e.EarlyMorning, Ze.Morning, $e.Morning, Ze.Standard, $e.Standard, Ze.Evening, $e.Evening, Ze.Pickup, $e.Pickup, Ze.PickupExpress, $e.PickupExpress, Ze.SameDayDelivery, $e.SameDayDelivery, Ze.Express, $e.Express;
var tt = {
	[$e.EarlyMorning]: Qe.EarlyMorning,
	[$e.Morning]: Qe.Morning,
	[$e.Standard]: Qe.Standard,
	[$e.Evening]: Qe.Evening,
	[$e.Pickup]: Qe.Pickup,
	[$e.PickupExpress]: Qe.PickupExpress,
	[$e.SameDayDelivery]: Qe.SameDayDelivery,
	[$e.Express]: Qe.Express
}, nt = {
	[Ze.EarlyMorning]: "earlyMorning",
	[Ze.Morning]: "morning",
	[Ze.Standard]: "standard",
	[Ze.Evening]: "evening",
	[Ze.Pickup]: "pickup",
	[Ze.PickupExpress]: "pickupExpress",
	[Ze.SameDayDelivery]: "sameDay",
	[Ze.Express]: "express"
}, rt = (e) => {
	if (e == null || e === "") return "";
	let t;
	if (typeof e == "number") t = e;
	else if (t = et[e], t == null) {
		let n = tt[e];
		t = n == null ? void 0 : et[n];
	}
	return t != null && nt[t] || String(e);
};
({ Vasco: 1 }).Vasco, { Vasco: "vasco" }.Vasco;
var it = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, at = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
at.Sunday, it.Sunday, at.Monday, it.Monday, at.Tuesday, it.Tuesday, at.Wednesday, it.Wednesday, at.Thursday, it.Thursday, at.Friday, it.Friday, at.Saturday, it.Saturday, it.Sunday, at.Sunday, it.Monday, at.Monday, it.Tuesday, at.Tuesday, it.Wednesday, at.Wednesday, it.Thursday, at.Thursday, it.Friday, at.Friday, it.Saturday, at.Saturday;
var ot = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
ot.Bytes, ot.Kilobytes, ot.Megabytes, ot.Gigabytes, ot.Terabytes;
var st = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, ct = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
st.Bol, ct.Bol, st.Exact, ct.Exact, st.Amazon, ct.Amazon, st.Wix, ct.Wix, st.ExactDe, ct.ExactDe, st.Etsy, ct.Etsy, ct.Bol, st.Bol, ct.Exact, st.Exact, ct.Amazon, st.Amazon, ct.Wix, st.Wix, ct.ExactDe, st.ExactDe, ct.Etsy, st.Etsy;
var O = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, lt = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
O.Unpaid, lt.Unpaid, O.Due, lt.Due, O.DuePrepayment, lt.DuePrepayment, O.Reminder1, lt.Reminder1, O.Reminder2, lt.Reminder2, O.Dun, lt.Dun, O.Collection, lt.Collection, O.Instalments, lt.Instalments, O.PaymentArrangement, lt.PaymentArrangement, O.Dispute, lt.Dispute, O.LegalProcedure, lt.LegalProcedure, O.Insolvency, lt.Insolvency, O.WriteOff, lt.WriteOff, O.Pending, lt.Pending, O.Cancelled, lt.Cancelled, O.Paid, lt.Paid, O.PaidOnline, lt.PaidOnline, O.PaidAutomatic, lt.PaidAutomatic, O.PaidCredit, lt.PaidCredit, O.PaidZeroItems, lt.PaidZeroItems, O.InvoiceWith0InvoiceItemsPaidZeroBalance, lt.PaidZeroBalance, O.Due, O.Reminder1, O.Reminder2, O.Dun, O.Collection, O.Instalments, O.PaymentArrangement, O.Dispute, O.Paid, O.PaidOnline, O.PaidAutomatic, O.PaidCredit, O.PaidZeroItems;
var ut = {
	Gram: "g",
	Kilogram: "kg"
};
ut.Gram, ut.Kilogram;
var dt = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
dt.Millimeter, dt.Centimeter, dt.Meter;
var ft = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, pt = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
pt.PendingConcept, pt.PendingRegistered, pt.EnRouteHandedToCarrier, pt.EnRouteSorting, pt.EnRouteDistribution, pt.EnRouteCustoms, pt.DeliveredReadyForPickup, pt.DeliveredAtRecipient, pt.DeliveredPackagePickedUp;
var mt = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, ht = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
ht.Light, mt.Light, ht.Start, mt.Start, ht.Plus, mt.Plus, ht.Premium, mt.Premium, ht.Max, mt.Max, mt.Light, ht.Light, mt.Start, ht.Start, mt.Plus, ht.Plus, mt.Premium, ht.Premium, mt.Max, ht.Max;
var gt = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, _t = {
	Start: mt.Start,
	Plus: mt.Plus,
	Premium: mt.Premium,
	Max: mt.Max
};
gt.Start, _t.Start, gt.Plus, _t.Plus, gt.Premium, _t.Premium, gt.Max, _t.Max, _t.Start, gt.Start, _t.Plus, gt.Plus, _t.Premium, gt.Premium, _t.Max, gt.Max;
var vt = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, yt = {
	Start: mt.Start,
	Plus: mt.Plus,
	Premium: mt.Premium,
	Max: mt.Max
};
vt.Start, yt.Start, vt.Plus, yt.Plus, vt.Premium, yt.Premium, vt.Max, yt.Max, yt.Start, vt.Start, yt.Plus, vt.Plus, yt.Premium, vt.Premium, yt.Max, vt.Max;
var bt = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, xt = {
	Light: mt.Light,
	Start: mt.Start,
	Plus: mt.Plus,
	Premium: mt.Premium,
	Max: mt.Max
};
bt.Light, xt.Light, bt.Start, xt.Start, bt.Plus, xt.Plus, bt.Premium, xt.Premium, bt.Max, xt.Max, xt.Light, bt.Light, xt.Start, bt.Start, xt.Plus, bt.Plus, xt.Premium, bt.Premium, xt.Max, bt.Max;
var St = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Ct = {
	Start: mt.Start,
	Plus: mt.Plus,
	Premium: mt.Premium,
	Max: mt.Max
};
St.Start, Ct.Start, St.Plus, Ct.Plus, St.Premium, Ct.Premium, St.Max, Ct.Max, Ct.Start, St.Start, Ct.Plus, St.Plus, Ct.Premium, St.Premium, Ct.Max, St.Max;
var wt = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Tt = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Et = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
wt.MyParcel, Tt.MyParcel, wt.Flespakket, Tt.Flespakket, wt.SendMyParcel, Tt.SendMyParcel, wt.MyParcelIt, Tt.MyParcelIt, wt.DeliverDutch, Tt.DeliverDutch, wt.PostNlPlugin, Tt.PostNlPlugin, wt.MyParcel, Et.MyParcelNl, wt.Flespakket, Et.MyParcelNl, wt.SendMyParcel, Et.MyParcelBe, wt.MyParcelIt, Et.MyParcelIt, wt.DeliverDutch, Et.DeliverDutch, wt.PostNlPlugin, Et.PostNlPlugin, Et.MyParcelNl, wt.MyParcel, Et.MyParcelBe, wt.SendMyParcel, Et.MyParcelIt, wt.MyParcelIt, Et.MyParcelNl, ft.HomeCountry, D.Netherlands, ft.Eu, ft.Row, D.Belgium, Et.MyParcelBe, ft.HomeCountry, D.Belgium, D.Netherlands, ft.Eu, ft.Row, Et.MyParcelBe, ft.HomeCountry, D.Belgium, ft.Eu, ft.Row, Et.MyParcelNl, ft.HomeCountry, D.Netherlands, ft.Eu, ft.Row, Et.MyParcelNl, ft.HomeCountry, D.Netherlands, D.Belgium, D.Luxembourg, T.Bpost, T.PostNl, T.DhlForYou, T.DhlParcelConnect, T.DhlEuroPlus, T.Ups, T.UpsStandard, T.UpsExpressSaver;
var k = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Dt = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
k.Package, Dt.Package, k.Mailbox, Dt.Mailbox, k.Letter, Dt.Letter, k.DigitalStamp, Dt.DigitalStamp, k.Pallet, Dt.Pallet, k.PackageSmall, Dt.PackageSmall, k.Envelope, Dt.Envelope, Dt.Package, k.Package, Dt.Mailbox, k.Mailbox, Dt.Letter, k.Letter, Dt.DigitalStamp, k.DigitalStamp, Dt.Pallet, k.Pallet, Dt.PackageSmall, k.PackageSmall, Dt.Envelope, k.Envelope;
var Ot = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
k.Package, Ot.PACKAGE, k.Mailbox, Ot.MAILBOX, k.Letter, Ot.UNFRANKED, k.DigitalStamp, Ot.DIGITAL_STAMP, k.Pallet, Ot.PALLET, k.PackageSmall, Ot.SMALL_PACKAGE, k.Envelope, Ot.ENVELOPE, Ot.PACKAGE, k.Package, Ot.MAILBOX, k.Mailbox, Ot.UNFRANKED, k.Letter, Ot.DIGITAL_STAMP, k.DigitalStamp, Ot.PALLET, k.Pallet, Ot.SMALL_PACKAGE, k.PackageSmall, Ot.ENVELOPE, k.Envelope, k.Package, k.Mailbox, k.Letter, k.DigitalStamp, k.Pallet, k.PackageSmall, k.Envelope;
var kt = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
kt.PendingConcept, kt.PendingRegistered, kt.EnrouteHandedToCarrier, kt.EnrouteSorting, kt.EnrouteDistribution, kt.DeliveredAtCustoms, kt.DeliveredAtRecipient, kt.DeliveredPackagePickedUp, kt.DeliveredReturnShipmentPackagePickedUp, kt.DeliveredAtAgreedLocation, kt.PrintedLetter, kt.PrintedDigitalStamp, kt.InactiveConcept, kt.InactiveRegistered, kt.InactiveEnrouteHandedToCarrier, kt.InactiveEnrouteSorting, kt.InactiveEnrouteDistribution, kt.InactiveEnrouteCustoms, kt.InactiveDeliveredAtRecipient, kt.InactiveDeliveredReadyForPickup, kt.InactiveDeliveredPackagePickedUp;
//#endregion
//#region ../../libs/utils/dist/index.js
var At = Object.create, jt = Object.defineProperty, Mt = Object.getOwnPropertyDescriptor, Nt = Object.getOwnPropertyNames, Pt = Object.getPrototypeOf, Ft = Object.prototype.hasOwnProperty, It = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), Lt = (e, t) => {
	let n = {};
	for (var r in e) jt(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || jt(n, Symbol.toStringTag, { value: "Module" }), n;
}, Rt = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Nt(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Ft.call(e, s) && s !== n && jt(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Mt(t, s)) || r.enumerable
	});
	return e;
}, zt = (e, t, n) => (n = e == null ? {} : At(Pt(e)), Rt(t || !e || !e.__esModule ? jt(n, "default", {
	value: e,
	enumerable: !0
}) : n, e));
function Bt(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = Bt(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function Vt() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Bt(e)) && (r && (r += " "), r += t);
	return r;
}
var Ht = "-";
function Ut(e) {
	let t = qt(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	function i(e) {
		let n = e.split(Ht);
		return n[0] === "" && n.length !== 1 && n.shift(), Wt(n, t) || Kt(e);
	}
	function a(e, t) {
		let i = n[e] || [];
		return t && r[e] ? [...i, ...r[e]] : i;
	}
	return {
		getClassGroupId: i,
		getConflictingClassGroupIds: a
	};
}
function Wt(e, t) {
	if (e.length === 0) return t.classGroupId;
	let n = e[0], r = t.nextPart.get(n), i = r ? Wt(e.slice(1), r) : void 0;
	if (i) return i;
	if (t.validators.length === 0) return;
	let a = e.join(Ht);
	return t.validators.find(({ validator: e }) => e(a))?.classGroupId;
}
var Gt = /^\[(.+)\]$/;
function Kt(e) {
	if (Gt.test(e)) {
		let t = Gt.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
		if (n) return "arbitrary.." + n;
	}
}
function qt(e) {
	let { theme: t, prefix: n } = e, r = {
		nextPart: /* @__PURE__ */ new Map(),
		validators: []
	};
	return Zt(Object.entries(e.classGroups), n).forEach(([e, n]) => {
		Jt(n, r, e, t);
	}), r;
}
function Jt(e, t, n, r) {
	e.forEach((e) => {
		if (typeof e == "string") {
			let r = e === "" ? t : Yt(t, e);
			r.classGroupId = n;
			return;
		}
		if (typeof e == "function") {
			if (Xt(e)) {
				Jt(e(r), t, n, r);
				return;
			}
			t.validators.push({
				validator: e,
				classGroupId: n
			});
			return;
		}
		Object.entries(e).forEach(([e, i]) => {
			Jt(i, Yt(t, e), n, r);
		});
	});
}
function Yt(e, t) {
	let n = e;
	return t.split(Ht).forEach((e) => {
		n.nextPart.has(e) || n.nextPart.set(e, {
			nextPart: /* @__PURE__ */ new Map(),
			validators: []
		}), n = n.nextPart.get(e);
	}), n;
}
function Xt(e) {
	return e.isThemeGetter;
}
function Zt(e, t) {
	return t ? e.map(([e, n]) => [e, n.map((e) => typeof e == "string" ? t + e : typeof e == "object" ? Object.fromEntries(Object.entries(e).map(([e, n]) => [t + e, n])) : e)]) : e;
}
function Qt(e) {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
	function i(i, a) {
		n.set(i, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
	}
	return {
		get(e) {
			let t = n.get(e);
			if (t !== void 0) return t;
			if ((t = r.get(e)) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			n.has(e) ? n.set(e, t) : i(e, t);
		}
	};
}
var $t = "!";
function en(e) {
	let t = e.separator, n = t.length === 1, r = t[0], i = t.length;
	return function(e) {
		let a = [], o = 0, s = 0, c;
		for (let l = 0; l < e.length; l++) {
			let u = e[l];
			if (o === 0) {
				if (u === r && (n || e.slice(l, l + i) === t)) {
					a.push(e.slice(s, l)), s = l + i;
					continue;
				}
				if (u === "/") {
					c = l;
					continue;
				}
			}
			u === "[" ? o++ : u === "]" && o--;
		}
		let l = a.length === 0 ? e : e.substring(s), u = l.startsWith($t);
		return {
			modifiers: a,
			hasImportantModifier: u,
			baseClassName: u ? l.substring(1) : l,
			maybePostfixModifierPosition: c && c > s ? c - s : void 0
		};
	};
}
function tn(e) {
	if (e.length <= 1) return e;
	let t = [], n = [];
	return e.forEach((e) => {
		e[0] === "[" ? (t.push(...n.sort(), e), n = []) : n.push(e);
	}), t.push(...n.sort()), t;
}
function nn(e) {
	return {
		cache: Qt(e.cacheSize),
		splitModifiers: en(e),
		...Ut(e)
	};
}
var rn = /\s+/;
function an(e, t) {
	let { splitModifiers: n, getClassGroupId: r, getConflictingClassGroupIds: i } = t, a = /* @__PURE__ */ new Set();
	return e.trim().split(rn).map((e) => {
		let { modifiers: t, hasImportantModifier: i, baseClassName: a, maybePostfixModifierPosition: o } = n(e), s = r(o ? a.substring(0, o) : a), c = !!o;
		if (!s) {
			if (!o || (s = r(a), !s)) return {
				isTailwindClass: !1,
				originalClassName: e
			};
			c = !1;
		}
		let l = tn(t).join(":");
		return {
			isTailwindClass: !0,
			modifierId: i ? l + $t : l,
			classGroupId: s,
			originalClassName: e,
			hasPostfixModifier: c
		};
	}).reverse().filter((e) => {
		if (!e.isTailwindClass) return !0;
		let { modifierId: t, classGroupId: n, hasPostfixModifier: r } = e, o = t + n;
		return a.has(o) ? !1 : (a.add(o), i(n, r).forEach((e) => a.add(t + e)), !0);
	}).reverse().map((e) => e.originalClassName).join(" ");
}
function on() {
	let e = 0, t, n, r = "";
	for (; e < arguments.length;) (t = arguments[e++]) && (n = sn(t)) && (r && (r += " "), r += n);
	return r;
}
function sn(e) {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = sn(e[r])) && (n && (n += " "), n += t);
	return n;
}
function cn(e, ...t) {
	let n, r, i, a = o;
	function o(o) {
		return n = nn(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o);
	}
	function s(e) {
		let t = r(e);
		if (t) return t;
		let a = an(e, n);
		return i(e, a), a;
	}
	return function() {
		return a(on.apply(null, arguments));
	};
}
function ln(e) {
	let t = (t) => t[e] || [];
	return t.isThemeGetter = !0, t;
}
var un = /^\[(?:([a-z-]+):)?(.+)\]$/i, dn = /^\d+\/\d+$/, fn = /*#__PURE__*/ new Set([
	"px",
	"full",
	"screen"
]), pn = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, mn = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, hn = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, gn = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, _n = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function vn(e) {
	return bn(e) || fn.has(e) || dn.test(e);
}
function yn(e) {
	return Mn(e, "length", Nn);
}
function bn(e) {
	return !!e && !Number.isNaN(Number(e));
}
function xn(e) {
	return Mn(e, "number", bn);
}
function Sn(e) {
	return !!e && Number.isInteger(Number(e));
}
function Cn(e) {
	return e.endsWith("%") && bn(e.slice(0, -1));
}
function A(e) {
	return un.test(e);
}
function wn(e) {
	return pn.test(e);
}
var Tn = /*#__PURE__*/ new Set([
	"length",
	"size",
	"percentage"
]);
function En(e) {
	return Mn(e, Tn, Pn);
}
function Dn(e) {
	return Mn(e, "position", Pn);
}
var On = /*#__PURE__*/ new Set(["image", "url"]);
function kn(e) {
	return Mn(e, On, In);
}
function An(e) {
	return Mn(e, "", Fn);
}
function jn() {
	return !0;
}
function Mn(e, t, n) {
	let r = un.exec(e);
	return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}
function Nn(e) {
	return mn.test(e) && !hn.test(e);
}
function Pn() {
	return !1;
}
function Fn(e) {
	return gn.test(e);
}
function In(e) {
	return _n.test(e);
}
function Ln() {
	let e = ln("colors"), t = ln("spacing"), n = ln("blur"), r = ln("brightness"), i = ln("borderColor"), a = ln("borderRadius"), o = ln("borderSpacing"), s = ln("borderWidth"), c = ln("contrast"), l = ln("grayscale"), u = ln("hueRotate"), d = ln("invert"), f = ln("gap"), p = ln("gradientColorStops"), m = ln("gradientColorStopPositions"), h = ln("inset"), g = ln("margin"), _ = ln("opacity"), v = ln("padding"), y = ln("saturate"), b = ln("scale"), ee = ln("sepia"), te = ln("skew"), ne = ln("space"), x = ln("translate"), S = () => [
		"auto",
		"contain",
		"none"
	], re = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], ie = () => [
		"auto",
		A,
		t
	], C = () => [A, t], ae = () => [
		"",
		vn,
		yn
	], oe = () => [
		"auto",
		bn,
		A
	], se = () => [
		"bottom",
		"center",
		"left",
		"left-bottom",
		"left-top",
		"right",
		"right-bottom",
		"right-top",
		"top"
	], ce = () => [
		"solid",
		"dashed",
		"dotted",
		"double",
		"none"
	], le = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], ue = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch"
	], de = () => [
		"",
		"0",
		A
	], fe = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], pe = () => [bn, xn], me = () => [bn, A];
	return {
		cacheSize: 500,
		separator: ":",
		theme: {
			colors: [jn],
			spacing: [vn, yn],
			blur: [
				"none",
				"",
				wn,
				A
			],
			brightness: pe(),
			borderColor: [e],
			borderRadius: [
				"none",
				"",
				"full",
				wn,
				A
			],
			borderSpacing: C(),
			borderWidth: ae(),
			contrast: pe(),
			grayscale: de(),
			hueRotate: me(),
			invert: de(),
			gap: C(),
			gradientColorStops: [e],
			gradientColorStopPositions: [Cn, yn],
			inset: ie(),
			margin: ie(),
			opacity: pe(),
			padding: C(),
			saturate: pe(),
			scale: pe(),
			sepia: de(),
			skew: me(),
			space: C(),
			translate: C()
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				"video",
				A
			] }],
			container: ["container"],
			columns: [{ columns: [wn] }],
			"break-after": [{ "break-after": fe() }],
			"break-before": [{ "break-before": fe() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: [...se(), A] }],
			overflow: [{ overflow: re() }],
			"overflow-x": [{ "overflow-x": re() }],
			"overflow-y": [{ "overflow-y": re() }],
			overscroll: [{ overscroll: S() }],
			"overscroll-x": [{ "overscroll-x": S() }],
			"overscroll-y": [{ "overscroll-y": S() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: [h] }],
			"inset-x": [{ "inset-x": [h] }],
			"inset-y": [{ "inset-y": [h] }],
			start: [{ start: [h] }],
			end: [{ end: [h] }],
			top: [{ top: [h] }],
			right: [{ right: [h] }],
			bottom: [{ bottom: [h] }],
			left: [{ left: [h] }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				"auto",
				Sn,
				A
			] }],
			basis: [{ basis: ie() }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"wrap",
				"wrap-reverse",
				"nowrap"
			] }],
			flex: [{ flex: [
				"1",
				"auto",
				"initial",
				"none",
				A
			] }],
			grow: [{ grow: de() }],
			shrink: [{ shrink: de() }],
			order: [{ order: [
				"first",
				"last",
				"none",
				Sn,
				A
			] }],
			"grid-cols": [{ "grid-cols": [jn] }],
			"col-start-end": [{ col: [
				"auto",
				{ span: [
					"full",
					Sn,
					A
				] },
				A
			] }],
			"col-start": [{ "col-start": oe() }],
			"col-end": [{ "col-end": oe() }],
			"grid-rows": [{ "grid-rows": [jn] }],
			"row-start-end": [{ row: [
				"auto",
				{ span: [Sn, A] },
				A
			] }],
			"row-start": [{ "row-start": oe() }],
			"row-end": [{ "row-end": oe() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": [
				"auto",
				"min",
				"max",
				"fr",
				A
			] }],
			"auto-rows": [{ "auto-rows": [
				"auto",
				"min",
				"max",
				"fr",
				A
			] }],
			gap: [{ gap: [f] }],
			"gap-x": [{ "gap-x": [f] }],
			"gap-y": [{ "gap-y": [f] }],
			"justify-content": [{ justify: ["normal", ...ue()] }],
			"justify-items": [{ "justify-items": [
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"justify-self": [{ "justify-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			"align-content": [{ content: [
				"normal",
				...ue(),
				"baseline"
			] }],
			"align-items": [{ items: [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"align-self": [{ self: [
				"auto",
				"start",
				"end",
				"center",
				"stretch",
				"baseline"
			] }],
			"place-content": [{ "place-content": [...ue(), "baseline"] }],
			"place-items": [{ "place-items": [
				"start",
				"end",
				"center",
				"baseline",
				"stretch"
			] }],
			"place-self": [{ "place-self": [
				"auto",
				"start",
				"end",
				"center",
				"stretch"
			] }],
			p: [{ p: [v] }],
			px: [{ px: [v] }],
			py: [{ py: [v] }],
			ps: [{ ps: [v] }],
			pe: [{ pe: [v] }],
			pt: [{ pt: [v] }],
			pr: [{ pr: [v] }],
			pb: [{ pb: [v] }],
			pl: [{ pl: [v] }],
			m: [{ m: [g] }],
			mx: [{ mx: [g] }],
			my: [{ my: [g] }],
			ms: [{ ms: [g] }],
			me: [{ me: [g] }],
			mt: [{ mt: [g] }],
			mr: [{ mr: [g] }],
			mb: [{ mb: [g] }],
			ml: [{ ml: [g] }],
			"space-x": [{ "space-x": [ne] }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": [ne] }],
			"space-y-reverse": ["space-y-reverse"],
			w: [{ w: [
				"auto",
				"min",
				"max",
				"fit",
				"svw",
				"lvw",
				"dvw",
				A,
				t
			] }],
			"min-w": [{ "min-w": [
				A,
				t,
				"min",
				"max",
				"fit"
			] }],
			"max-w": [{ "max-w": [
				A,
				t,
				"none",
				"full",
				"min",
				"max",
				"fit",
				"prose",
				{ screen: [wn] },
				wn
			] }],
			h: [{ h: [
				A,
				t,
				"auto",
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"min-h": [{ "min-h": [
				A,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			"max-h": [{ "max-h": [
				A,
				t,
				"min",
				"max",
				"fit",
				"svh",
				"lvh",
				"dvh"
			] }],
			size: [{ size: [
				A,
				t,
				"auto",
				"min",
				"max",
				"fit"
			] }],
			"font-size": [{ text: [
				"base",
				wn,
				yn
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black",
				xn
			] }],
			"font-family": [{ font: [jn] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
			tracking: [{ tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest",
				A
			] }],
			"line-clamp": [{ "line-clamp": [
				"none",
				bn,
				xn
			] }],
			leading: [{ leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose",
				vn,
				A
			] }],
			"list-image": [{ "list-image": ["none", A] }],
			"list-style-type": [{ list: [
				"none",
				"disc",
				"decimal",
				A
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"placeholder-color": [{ placeholder: [e] }],
			"placeholder-opacity": [{ "placeholder-opacity": [_] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"text-color": [{ text: [e] }],
			"text-opacity": [{ "text-opacity": [_] }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...ce(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				"auto",
				"from-font",
				vn,
				yn
			] }],
			"underline-offset": [{ "underline-offset": [
				"auto",
				vn,
				A
			] }],
			"text-decoration-color": [{ decoration: [e] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: C() }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				A
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: ["none", A] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-opacity": [{ "bg-opacity": [_] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: [...se(), Dn] }],
			"bg-repeat": [{ bg: ["no-repeat", { repeat: [
				"",
				"x",
				"y",
				"round",
				"space"
			] }] }],
			"bg-size": [{ bg: [
				"auto",
				"cover",
				"contain",
				En
			] }],
			"bg-image": [{ bg: [
				"none",
				{ "gradient-to": [
					"t",
					"tr",
					"r",
					"br",
					"b",
					"bl",
					"l",
					"tl"
				] },
				kn
			] }],
			"bg-color": [{ bg: [e] }],
			"gradient-from-pos": [{ from: [m] }],
			"gradient-via-pos": [{ via: [m] }],
			"gradient-to-pos": [{ to: [m] }],
			"gradient-from": [{ from: [p] }],
			"gradient-via": [{ via: [p] }],
			"gradient-to": [{ to: [p] }],
			rounded: [{ rounded: [a] }],
			"rounded-s": [{ "rounded-s": [a] }],
			"rounded-e": [{ "rounded-e": [a] }],
			"rounded-t": [{ "rounded-t": [a] }],
			"rounded-r": [{ "rounded-r": [a] }],
			"rounded-b": [{ "rounded-b": [a] }],
			"rounded-l": [{ "rounded-l": [a] }],
			"rounded-ss": [{ "rounded-ss": [a] }],
			"rounded-se": [{ "rounded-se": [a] }],
			"rounded-ee": [{ "rounded-ee": [a] }],
			"rounded-es": [{ "rounded-es": [a] }],
			"rounded-tl": [{ "rounded-tl": [a] }],
			"rounded-tr": [{ "rounded-tr": [a] }],
			"rounded-br": [{ "rounded-br": [a] }],
			"rounded-bl": [{ "rounded-bl": [a] }],
			"border-w": [{ border: [s] }],
			"border-w-x": [{ "border-x": [s] }],
			"border-w-y": [{ "border-y": [s] }],
			"border-w-s": [{ "border-s": [s] }],
			"border-w-e": [{ "border-e": [s] }],
			"border-w-t": [{ "border-t": [s] }],
			"border-w-r": [{ "border-r": [s] }],
			"border-w-b": [{ "border-b": [s] }],
			"border-w-l": [{ "border-l": [s] }],
			"border-opacity": [{ "border-opacity": [_] }],
			"border-style": [{ border: [...ce(), "hidden"] }],
			"divide-x": [{ "divide-x": [s] }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": [s] }],
			"divide-y-reverse": ["divide-y-reverse"],
			"divide-opacity": [{ "divide-opacity": [_] }],
			"divide-style": [{ divide: ce() }],
			"border-color": [{ border: [i] }],
			"border-color-x": [{ "border-x": [i] }],
			"border-color-y": [{ "border-y": [i] }],
			"border-color-t": [{ "border-t": [i] }],
			"border-color-r": [{ "border-r": [i] }],
			"border-color-b": [{ "border-b": [i] }],
			"border-color-l": [{ "border-l": [i] }],
			"divide-color": [{ divide: [i] }],
			"outline-style": [{ outline: ["", ...ce()] }],
			"outline-offset": [{ "outline-offset": [vn, A] }],
			"outline-w": [{ outline: [vn, yn] }],
			"outline-color": [{ outline: [e] }],
			"ring-w": [{ ring: ae() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: [e] }],
			"ring-opacity": [{ "ring-opacity": [_] }],
			"ring-offset-w": [{ "ring-offset": [vn, yn] }],
			"ring-offset-color": [{ "ring-offset": [e] }],
			shadow: [{ shadow: [
				"",
				"inner",
				"none",
				wn,
				An
			] }],
			"shadow-color": [{ shadow: [jn] }],
			opacity: [{ opacity: [_] }],
			"mix-blend": [{ "mix-blend": [
				...le(),
				"plus-lighter",
				"plus-darker"
			] }],
			"bg-blend": [{ "bg-blend": le() }],
			filter: [{ filter: ["", "none"] }],
			blur: [{ blur: [n] }],
			brightness: [{ brightness: [r] }],
			contrast: [{ contrast: [c] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				wn,
				A
			] }],
			grayscale: [{ grayscale: [l] }],
			"hue-rotate": [{ "hue-rotate": [u] }],
			invert: [{ invert: [d] }],
			saturate: [{ saturate: [y] }],
			sepia: [{ sepia: [ee] }],
			"backdrop-filter": [{ "backdrop-filter": ["", "none"] }],
			"backdrop-blur": [{ "backdrop-blur": [n] }],
			"backdrop-brightness": [{ "backdrop-brightness": [r] }],
			"backdrop-contrast": [{ "backdrop-contrast": [c] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [l] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [u] }],
			"backdrop-invert": [{ "backdrop-invert": [d] }],
			"backdrop-opacity": [{ "backdrop-opacity": [_] }],
			"backdrop-saturate": [{ "backdrop-saturate": [y] }],
			"backdrop-sepia": [{ "backdrop-sepia": [ee] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": [o] }],
			"border-spacing-x": [{ "border-spacing-x": [o] }],
			"border-spacing-y": [{ "border-spacing-y": [o] }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"none",
				"all",
				"",
				"colors",
				"opacity",
				"shadow",
				"transform",
				A
			] }],
			duration: [{ duration: me() }],
			ease: [{ ease: [
				"linear",
				"in",
				"out",
				"in-out",
				A
			] }],
			delay: [{ delay: me() }],
			animate: [{ animate: [
				"none",
				"spin",
				"ping",
				"pulse",
				"bounce",
				A
			] }],
			transform: [{ transform: [
				"",
				"gpu",
				"none"
			] }],
			scale: [{ scale: [b] }],
			"scale-x": [{ "scale-x": [b] }],
			"scale-y": [{ "scale-y": [b] }],
			rotate: [{ rotate: [Sn, A] }],
			"translate-x": [{ "translate-x": [x] }],
			"translate-y": [{ "translate-y": [x] }],
			"skew-x": [{ "skew-x": [te] }],
			"skew-y": [{ "skew-y": [te] }],
			"transform-origin": [{ origin: [
				"center",
				"top",
				"top-right",
				"right",
				"bottom-right",
				"bottom",
				"bottom-left",
				"left",
				"top-left",
				A
			] }],
			accent: [{ accent: ["auto", e] }],
			appearance: [{ appearance: ["none", "auto"] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				A
			] }],
			"caret-color": [{ caret: [e] }],
			"pointer-events": [{ "pointer-events": ["none", "auto"] }],
			resize: [{ resize: [
				"none",
				"y",
				"x",
				""
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scroll-m": [{ "scroll-m": C() }],
			"scroll-mx": [{ "scroll-mx": C() }],
			"scroll-my": [{ "scroll-my": C() }],
			"scroll-ms": [{ "scroll-ms": C() }],
			"scroll-me": [{ "scroll-me": C() }],
			"scroll-mt": [{ "scroll-mt": C() }],
			"scroll-mr": [{ "scroll-mr": C() }],
			"scroll-mb": [{ "scroll-mb": C() }],
			"scroll-ml": [{ "scroll-ml": C() }],
			"scroll-p": [{ "scroll-p": C() }],
			"scroll-px": [{ "scroll-px": C() }],
			"scroll-py": [{ "scroll-py": C() }],
			"scroll-ps": [{ "scroll-ps": C() }],
			"scroll-pe": [{ "scroll-pe": C() }],
			"scroll-pt": [{ "scroll-pt": C() }],
			"scroll-pr": [{ "scroll-pr": C() }],
			"scroll-pb": [{ "scroll-pb": C() }],
			"scroll-pl": [{ "scroll-pl": C() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				A
			] }],
			fill: [{ fill: [e, "none"] }],
			"stroke-w": [{ stroke: [
				vn,
				yn,
				xn
			] }],
			stroke: [{ stroke: [e, "none"] }],
			sr: ["sr-only", "not-sr-only"],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-s",
				"border-w-e",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] }
	};
}
var Rn = /*#__PURE__*/ cn(Ln);
function zn(...e) {
	return Rn(Vt(e));
}
var j = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, M = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
j.Dhl, j.Instabox, j.PostNl, M.PostNl, j.Bpost, M.Bpost, j.CheapCargo, M.CheapCargo, j.Dpd, M.Dpd, j.Instabox, M.Instabox, j.Dhl, M.Dhl, j.Bol, M.Bol, j.Ups, M.Ups, j.DhlForYou, M.DhlForYou, j.DhlParcelConnect, M.DhlParcelConnect, j.DhlEuroPlus, M.DhlEuroPlus, j.UpsStandard, M.UpsStandard, j.UpsExpressSaver, M.UpsExpressSaver, j.Gls, M.Gls, j.Brt, M.Brt, j.Trunkrs, M.Trunkrs, j.InPost, M.InPost, j.PosteItaliane, M.PosteItaliane, j.Spring, M.Spring, j.ViaTim, M.ViaTim, j.PostNl, M.POSTNL, j.Bpost, M.BPOST, j.CheapCargo, M.CHEAP_CARGO, j.Dpd, M.DPD, j.Instabox, M.INSTABOX, j.Dhl, M.DHL, j.Bol, M.BOL, j.Ups, M.UPS, j.DhlForYou, M.DHL_FOR_YOU, j.DhlParcelConnect, M.DHL_PARCEL_CONNECT, j.DhlEuroPlus, M.DHL_EUROPLUS, j.UpsStandard, M.UPS_STANDARD, j.UpsExpressSaver, M.UPS_EXPRESS_SAVER, j.Gls, M.GLS, j.Brt, M.BRT, j.Trunkrs, M.TRUNKRS, j.InPost, M.INPOST, j.PosteItaliane, M.POSTE_ITALIANE, j.Spring, M.SPRING, j.ViaTim, M.VIA_TIM, M.PostNl, j.PostNl, M.POSTNL, j.PostNl, M.Bpost, j.Bpost, M.BPOST, j.Bpost, M.CheapCargo, j.CheapCargo, M.CHEAP_CARGO, j.CheapCargo, M.Dpd, j.Dpd, M.DPD, j.Dpd, M.Instabox, j.Instabox, M.Dhl, j.Dhl, M.BolCom, j.Bol, M.Bol, j.Bol, M.BOL, j.Bol, M.Ups, j.Ups, M.DhlForYou, j.DhlForYou, M.DHL_FOR_YOU, j.DhlForYou, M.DhlParcelConnect, j.DhlParcelConnect, M.DHL_PARCEL_CONNECT, j.DhlParcelConnect, M.DhlEuroPlus, j.DhlEuroPlus, M.DHL_EUROPLUS, j.DhlEuroPlus, M.UpsStandard, j.UpsStandard, M.UPS_STANDARD, j.UpsStandard, M.UpsExpressSaver, j.UpsExpressSaver, M.UPS_EXPRESS_SAVER, j.UpsExpressSaver, M.Gls, j.Gls, M.GLS, j.Gls, M.Brt, j.Brt, M.BRT, j.Brt, M.Trunkrs, j.Trunkrs, M.TRUNKRS, j.Trunkrs, M.InPost, j.InPost, M.INPOST, j.InPost, M.PosteItaliane, j.PosteItaliane, M.POSTE_ITALIANE, j.PosteItaliane, M.Spring, j.Spring, M.SPRING, j.Spring, M.ViaTim, j.ViaTim, M.VIA_TIM, j.ViaTim, j.PostNl, j.Bpost, j.CheapCargo, j.Dpd, j.Instabox, j.Dhl, j.Bol, j.Ups, j.DhlForYou, j.DhlParcelConnect, j.DhlEuroPlus, j.UpsStandard, j.UpsExpressSaver, j.Gls, j.Brt, j.Trunkrs, j.InPost, j.PosteItaliane, j.ViaTim;
var N = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
N.Austria, N.Belgium, N.Bulgaria, N.Croatia, N.Cyprus, N.CzechRepublic, N.Denmark, N.Estonia, N.Finland, N.France, N.Germany, N.Greece, N.Hungary, N.Ireland, N.Italy, N.Latvia, N.Lithuania, N.Luxembourg, N.Malta, N.Netherlands, N.Poland, N.Portugal, N.Romania, N.Slovakia, N.Slovenia, N.Spain, N.Sweden, Object.values(N), N.Angola, N.AntiguaAndBarbuda, N.Aruba, N.Bahamas, N.Belize, N.Benin, N.Bermuda, N.BonaireSintEustatiusAndSaba, N.Botswana, N.BurkinaFaso, N.Burundi, N.Cameroon, N.CanaryIslands, N.CentralAfricanRepublic, N.Comoros, N.CongoBrazzaville, N.CongoKinshasa, N.CoteDIvoire, N.Curacao, N.Djibouti, N.Dominica, N.DutchAntilles, N.EquatorialGuinea, N.Eritrea, N.Fiji, N.Gabon, N.Gambia, N.Ghana, N.Grenada, N.Guyana, N.HongKong, N.Kiribati, N.KoreaPeoplesDemocraticRepublic, N.Macao, N.Malawi, N.Mali, N.Mauritania, N.Nauru, N.Qatar, N.Rwanda, N.SaintKittsAndNevis, N.SaoTomeAndPrincipe, N.Seychelles, N.SierraLeone, N.SintMaarten, N.Suriname, N.SyrianArabRepublic, N.TimorLeste, N.Togo, N.Tonga, N.Tuvalu, N.Uganda, N.UnitedArabEmirates, N.Vanuatu, N.Yemen, N.Zimbabwe, N.Austria, N.Belgium, N.Bulgaria, N.Croatia, N.CzechRepublic, N.Estonia, N.Finland, N.France, N.Germany, N.Greece, N.Hungary, N.Ireland, N.Italy, N.Latvia, N.Lithuania, N.Luxembourg, N.Malta, N.Netherlands, N.Portugal, N.Romania, N.Slovakia, N.Slovenia, N.Spain, N.UnitedKingdom, N.Denmark, N.Germany, N.Sweden;
var Bn = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, P = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, Vn = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
Bn.EarlyMorning, P.EarlyMorning, Bn.Morning, P.Morning, Bn.Standard, P.Standard, Bn.Evening, P.Evening, Bn.Pickup, P.Pickup, Bn.PickupExpress, P.PickupExpress, Bn.SameDayDelivery, P.SameDayDelivery, Bn.Express, P.Express, P.EarlyMorning, Bn.EarlyMorning, P.Morning, Bn.Morning, P.Standard, Bn.Standard, P.Evening, Bn.Evening, P.Pickup, Bn.Pickup, P.PickupExpress, Bn.PickupExpress, P.SameDayDelivery, Bn.SameDayDelivery, P.Express, Bn.Express, Bn.EarlyMorning, Vn.EarlyMorning, Bn.Morning, Vn.Morning, Bn.Standard, Vn.Standard, Bn.Evening, Vn.Evening, Bn.Pickup, Vn.Pickup, Bn.PickupExpress, Vn.PickupExpress, Bn.SameDayDelivery, Vn.SameDayDelivery, Bn.Express, Vn.Express, Vn.EarlyMorning, P.EarlyMorning, Vn.Morning, P.Morning, Vn.Standard, P.Standard, Vn.Evening, P.Evening, Vn.Pickup, P.Pickup, Vn.PickupExpress, P.PickupExpress, Vn.SameDayDelivery, P.SameDayDelivery, Vn.Express, P.Express, Bn.EarlyMorning, Bn.Morning, Bn.Standard, Bn.Evening, Bn.Pickup, Bn.PickupExpress, Bn.SameDayDelivery, Bn.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var Hn = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, Un = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
Un.Sunday, Hn.Sunday, Un.Monday, Hn.Monday, Un.Tuesday, Hn.Tuesday, Un.Wednesday, Hn.Wednesday, Un.Thursday, Hn.Thursday, Un.Friday, Hn.Friday, Un.Saturday, Hn.Saturday, Hn.Sunday, Un.Sunday, Hn.Monday, Un.Monday, Hn.Tuesday, Un.Tuesday, Hn.Wednesday, Un.Wednesday, Hn.Thursday, Un.Thursday, Hn.Friday, Un.Friday, Hn.Saturday, Un.Saturday;
var Wn = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
Wn.Bytes, Wn.Kilobytes, Wn.Megabytes, Wn.Gigabytes, Wn.Terabytes;
var Gn = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, Kn = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
Gn.Bol, Kn.Bol, Gn.Exact, Kn.Exact, Gn.Amazon, Kn.Amazon, Gn.Wix, Kn.Wix, Gn.ExactDe, Kn.ExactDe, Gn.Etsy, Kn.Etsy, Kn.Bol, Gn.Bol, Kn.Exact, Gn.Exact, Kn.Amazon, Gn.Amazon, Kn.Wix, Gn.Wix, Kn.ExactDe, Gn.ExactDe, Kn.Etsy, Gn.Etsy;
var F = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, qn = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
F.Unpaid, qn.Unpaid, F.Due, qn.Due, F.DuePrepayment, qn.DuePrepayment, F.Reminder1, qn.Reminder1, F.Reminder2, qn.Reminder2, F.Dun, qn.Dun, F.Collection, qn.Collection, F.Instalments, qn.Instalments, F.PaymentArrangement, qn.PaymentArrangement, F.Dispute, qn.Dispute, F.LegalProcedure, qn.LegalProcedure, F.Insolvency, qn.Insolvency, F.WriteOff, qn.WriteOff, F.Pending, qn.Pending, F.Cancelled, qn.Cancelled, F.Paid, qn.Paid, F.PaidOnline, qn.PaidOnline, F.PaidAutomatic, qn.PaidAutomatic, F.PaidCredit, qn.PaidCredit, F.PaidZeroItems, qn.PaidZeroItems, F.InvoiceWith0InvoiceItemsPaidZeroBalance, qn.PaidZeroBalance, F.Due, F.Reminder1, F.Reminder2, F.Dun, F.Collection, F.Instalments, F.PaymentArrangement, F.Dispute, F.Paid, F.PaidOnline, F.PaidAutomatic, F.PaidCredit, F.PaidZeroItems;
var Jn = {
	Gram: "gram",
	Kilogram: "kilogram"
}, Yn = {
	Gram: "g",
	Kilogram: "kg"
}, Xn = {
	[Yn.Gram]: 1,
	[Yn.Kilogram]: 1e3
}, Zn = {
	Millimeter: "millimeter",
	Centimeter: "centimeter",
	Meter: "meter"
}, Qn = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
}, $n = {
	[Qn.Millimeter]: .1,
	[Qn.Centimeter]: 1,
	[Qn.Meter]: 100
}, er = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, tr = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
tr.PendingConcept, tr.PendingRegistered, tr.EnRouteHandedToCarrier, tr.EnRouteSorting, tr.EnRouteDistribution, tr.EnRouteCustoms, tr.DeliveredReadyForPickup, tr.DeliveredAtRecipient, tr.DeliveredPackagePickedUp;
var nr = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, rr = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
rr.Light, nr.Light, rr.Start, nr.Start, rr.Plus, nr.Plus, rr.Premium, nr.Premium, rr.Max, nr.Max, nr.Light, rr.Light, nr.Start, rr.Start, nr.Plus, rr.Plus, nr.Premium, rr.Premium, nr.Max, rr.Max;
var ir = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, ar = {
	Start: nr.Start,
	Plus: nr.Plus,
	Premium: nr.Premium,
	Max: nr.Max
};
ir.Start, ar.Start, ir.Plus, ar.Plus, ir.Premium, ar.Premium, ir.Max, ar.Max, ar.Start, ir.Start, ar.Plus, ir.Plus, ar.Premium, ir.Premium, ar.Max, ir.Max;
var or = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, sr = {
	Start: nr.Start,
	Plus: nr.Plus,
	Premium: nr.Premium,
	Max: nr.Max
};
or.Start, sr.Start, or.Plus, sr.Plus, or.Premium, sr.Premium, or.Max, sr.Max, sr.Start, or.Start, sr.Plus, or.Plus, sr.Premium, or.Premium, sr.Max, or.Max;
var cr = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, lr = {
	Light: nr.Light,
	Start: nr.Start,
	Plus: nr.Plus,
	Premium: nr.Premium,
	Max: nr.Max
};
cr.Light, lr.Light, cr.Start, lr.Start, cr.Plus, lr.Plus, cr.Premium, lr.Premium, cr.Max, lr.Max, lr.Light, cr.Light, lr.Start, cr.Start, lr.Plus, cr.Plus, lr.Premium, cr.Premium, lr.Max, cr.Max;
var ur = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, dr = {
	Start: nr.Start,
	Plus: nr.Plus,
	Premium: nr.Premium,
	Max: nr.Max
};
ur.Start, dr.Start, ur.Plus, dr.Plus, ur.Premium, dr.Premium, ur.Max, dr.Max, dr.Start, ur.Start, dr.Plus, ur.Plus, dr.Premium, ur.Premium, dr.Max, ur.Max;
var fr = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, pr = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, mr = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
fr.MyParcel, pr.MyParcel, fr.Flespakket, pr.Flespakket, fr.SendMyParcel, pr.SendMyParcel, fr.MyParcelIt, pr.MyParcelIt, fr.DeliverDutch, pr.DeliverDutch, fr.PostNlPlugin, pr.PostNlPlugin, fr.MyParcel, mr.MyParcelNl, fr.Flespakket, mr.MyParcelNl, fr.SendMyParcel, mr.MyParcelBe, fr.MyParcelIt, mr.MyParcelIt, fr.DeliverDutch, mr.DeliverDutch, fr.PostNlPlugin, mr.PostNlPlugin, mr.MyParcelNl, fr.MyParcel, mr.MyParcelBe, fr.SendMyParcel, mr.MyParcelIt, fr.MyParcelIt, mr.MyParcelNl, er.HomeCountry, N.Netherlands, er.Eu, er.Row, N.Belgium, mr.MyParcelBe, er.HomeCountry, N.Belgium, N.Netherlands, er.Eu, er.Row, mr.MyParcelBe, er.HomeCountry, N.Belgium, er.Eu, er.Row, mr.MyParcelNl, er.HomeCountry, N.Netherlands, er.Eu, er.Row, mr.MyParcelNl, er.HomeCountry, N.Netherlands, N.Belgium, N.Luxembourg, j.Bpost, j.PostNl, j.DhlForYou, j.DhlParcelConnect, j.DhlEuroPlus, j.Ups, j.UpsStandard, j.UpsExpressSaver;
var I = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, hr = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
I.Package, hr.Package, I.Mailbox, hr.Mailbox, I.Letter, hr.Letter, I.DigitalStamp, hr.DigitalStamp, I.Pallet, hr.Pallet, I.PackageSmall, hr.PackageSmall, I.Envelope, hr.Envelope, hr.Package, I.Package, hr.Mailbox, I.Mailbox, hr.Letter, I.Letter, hr.DigitalStamp, I.DigitalStamp, hr.Pallet, I.Pallet, hr.PackageSmall, I.PackageSmall, hr.Envelope, I.Envelope;
var gr = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
I.Package, gr.PACKAGE, I.Mailbox, gr.MAILBOX, I.Letter, gr.UNFRANKED, I.DigitalStamp, gr.DIGITAL_STAMP, I.Pallet, gr.PALLET, I.PackageSmall, gr.SMALL_PACKAGE, I.Envelope, gr.ENVELOPE, gr.PACKAGE, I.Package, gr.MAILBOX, I.Mailbox, gr.UNFRANKED, I.Letter, gr.DIGITAL_STAMP, I.DigitalStamp, gr.PALLET, I.Pallet, gr.SMALL_PACKAGE, I.PackageSmall, gr.ENVELOPE, I.Envelope, I.Package, I.Mailbox, I.Letter, I.DigitalStamp, I.Pallet, I.PackageSmall, I.Envelope;
var _r = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
_r.PendingConcept, _r.PendingRegistered, _r.EnrouteHandedToCarrier, _r.EnrouteSorting, _r.EnrouteDistribution, _r.DeliveredAtCustoms, _r.DeliveredAtRecipient, _r.DeliveredPackagePickedUp, _r.DeliveredReturnShipmentPackagePickedUp, _r.DeliveredAtAgreedLocation, _r.PrintedLetter, _r.PrintedDigitalStamp, _r.InactiveConcept, _r.InactiveRegistered, _r.InactiveEnrouteHandedToCarrier, _r.InactiveEnrouteSorting, _r.InactiveEnrouteDistribution, _r.InactiveEnrouteCustoms, _r.InactiveDeliveredAtRecipient, _r.InactiveDeliveredReadyForPickup, _r.InactiveDeliveredPackagePickedUp;
var vr = (e) => e === N.UnitedKingdom, yr = (e) => e === N.Netherlands, br = (e) => e === N.Belgium, xr = (e) => e === N.Germany, Sr = (e) => e === N.France, Cr = (e) => e === N.Ireland, wr = (e) => e === N.UnitedStatesOfAmerica, Tr = (e) => e === N.PuertoRico, Er = { countryCode: /* @__PURE__ */ Lt({
	isBelgium: () => br,
	isFrance: () => Sr,
	isGermany: () => xr,
	isIreland: () => Cr,
	isNetherlands: () => yr,
	isPuertoRico: () => Tr,
	isUnitedKingdom: () => vr,
	isUnitedStatesOfAmerica: () => wr
}) }, Dr = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var ee = "$isDayjsObject", te = function(e) {
			return e instanceof re || !(!e || !e[ee]);
		}, ne = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, x = function(e, t) {
			if (te(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new re(n);
		}, S = v;
		S.l = ne, S.i = te, S.w = function(e, t) {
			return x(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var re = function() {
			function g(e) {
				this.$L = ne(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[ee] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (S.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return S;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = x(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return x(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < x(e);
			}, _.$g = function(e, t, n) {
				return S.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!S.u(t) || t, u = S.p(e), p = function(e, t) {
					var i = S.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return S.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = S.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[S.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = S.p(u), h = function(e) {
					var t = x(p);
					return S.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return S.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return S.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return S.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return S.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return S.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return S.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return S.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return S.s(t.$s, 2, "0");
							case "SSS": return S.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = S.p(f), _ = x(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return S.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : S.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = ne(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return S.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), ie = re.prototype;
		return x.prototype = ie, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			ie[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), x.extend = function(e, t) {
			return e.$i ||= (e(t, re, x), !0), x;
		}, x.locale = ne, x.isDayjs = te, x.unix = function(e) {
			return x(1e3 * e);
		}, x.en = b[y], x.Ls = b, x.p = {}, x;
	}));
})), Or = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Dr()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), kr = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Dr()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_it = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Ar = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Dr()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), jr = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), Mr = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, v = c || 0, y = l || 0, b = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, v, y, b + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, v, y, b)) : new Date(h, g, m, _, v, y, b);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), Nr = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), Pr = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), Fr = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), Ir = /* @__PURE__ */ It(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
Or(), kr(), Ar();
var Lr = /* @__PURE__ */ zt(Dr(), 1), Rr = /* @__PURE__ */ zt(jr(), 1), zr = /* @__PURE__ */ zt(Mr(), 1), Br = /* @__PURE__ */ zt(Nr(), 1), Vr = /* @__PURE__ */ zt(Pr(), 1), Hr = /* @__PURE__ */ zt(Fr(), 1), Ur = /* @__PURE__ */ zt(Ir(), 1);
Lr.default.extend(zr.default), Lr.default.extend(Vr.default), Lr.default.extend(Rr.default), Lr.default.extend(Ur.default), Lr.default.extend(Br.default), Lr.default.extend(Hr.default), Lr.default.locale("nl"), Lr.default.tz.setDefault("Europe/Amsterdam");
var Wr = Lr.default, Gr = (e) => e === P.Morning, Kr = (e) => e === P.Evening, qr = (e) => [P.Pickup, P.PickupExpress].includes(e), Jr = (e) => [
	P.EarlyMorning,
	P.Morning,
	P.Standard,
	P.Evening,
	P.SameDayDelivery,
	P.Express
].includes(e), Yr = (e, { locale: t = "nl-NL", currency: n = "EUR", ...r } = {}) => new Intl.NumberFormat(t, {
	style: "currency",
	currency: n,
	...r
}).format(e / 100), Xr = {
	format: Yr,
	fromMoney: (e) => e ? typeof e.micros == "number" ? e.micros / 1e4 : (e.integral ?? 0) * 100 + (e.fractional ?? 0) : 0,
	rounded: (e) => `${Yr(e, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0
	})},-`,
	toCents: (e) => Math.round(e * 100),
	toMoney: (e, t) => {
		let n = Math.round(e * 1e4), r = Math.floor(n / 1e4);
		return {
			currency: t ?? "EUR",
			integral: Math.floor(r / 100),
			fractional: r % 100,
			micros: n
		};
	},
	toNumberFromSegments: (e) => {
		if (!e) return 0;
		let t = e?.integral ?? 0, n = e?.fractional ?? 0;
		return t * 100 + n;
	},
	toNumberFromString: (e) => {
		let t = e?.trim() ?? "", n = Math.max(t.lastIndexOf("."), t.lastIndexOf(","));
		if (n >= 0) {
			let e = t.substring(0, n), r = t.substring(n + 1);
			return e = e.replace(/[.,]/g, ""), r.length < 2 ? r = r.padEnd(2, "0") : r.length > 2 && (r = r.substring(0, 2)), parseInt(e + r, 10);
		}
		return parseInt(t.replace(/[.,]/g, ""), 10);
	},
	toSegments: (e) => ({
		integral: Math.floor(e / 100),
		fractional: e % 100
	})
}, Zr = { toCentimeters: (e, t) => {
	switch (t) {
		case Qn.Millimeter:
		case Zn.Millimeter: return e * $n[Qn.Millimeter];
		case Qn.Centimeter:
		case Zn.Centimeter: return e;
		case Qn.Meter:
		case Zn.Meter: return e * $n[Qn.Meter];
		default: throw Error(`Unknown unit ${t}`);
	}
} }, Qr = { toBytes: (e) => {
	if (!e) return "0 b";
	let t = 1024, n = [
		"b",
		"kb",
		"mb",
		"gb"
	], r = Math.floor(Math.log(e) / Math.log(t));
	return `${Math.round(e / t ** r * 100) / 100} ${n[r]}`.replace(".", ",");
} }, $r = {
	toCeiledDecimal: (e, t = 1) => {
		let n = 10 ** t;
		return Math.ceil(e * n) / n;
	},
	formatCompactNumber: (e) => {
		if (e < 1e3) return String(e);
		let t = e / 1e3;
		return t % 1 == 0 ? `${t}k` : `${t.toFixed(1).replace(/\.0$/, "")}k`;
	}
}, ei = { toTime: (e, t) => Wr(e, "HH:mm:ss").format(t) }, ti = { parseUrlFromDoubleSlashes: (e) => e.replace(/([^:]\/)\/+/g, "$1") }, ni = (e, t) => {
	switch (t) {
		case Yn.Gram:
		case Jn.Gram: return e;
		case Yn.Kilogram:
		case Jn.Kilogram: return e * Xn[Yn.Kilogram];
		default: throw Error(`Unknown unit ${t}`);
	}
}, ri = (e, t) => {
	switch (t) {
		case Jn.Gram:
		case Yn.Gram: return e / Xn[Yn.Kilogram];
		case Yn.Kilogram:
		case Jn.Kilogram: return e;
		default: throw Error(`Unknown unit ${t}`);
	}
}, ii = (e, t, n = { round: !0 }) => {
	if (t === Jn.Gram) return `${e}g`;
	if (t === Jn.Kilogram) return `${n.round ? Math.round(e) : e}kg`;
	throw Error(`Unknown unit ${t}`);
}, ai = {
	currency: Xr,
	dimensions: Zr,
	weight: {
		toGrams: ni,
		toKilograms: ri,
		toString: ii,
		toMinMaxString: (e, t, n) => (n === Jn.Kilogram && (e = ri(e, Jn.Gram), t = ri(t, Jn.Gram)), `${ii(e, n)} - ${ii(t, n)}`)
	},
	time: ei,
	url: ti,
	fileSize: Qr,
	number: $r
}, oi = {
	getWeightFactor: (e) => {
		switch (e) {
			case "g":
			case Yn.Gram:
			case Jn.Gram: return Xn[Yn.Gram];
			case Yn.Kilogram:
			case Jn.Kilogram: return Xn[Yn.Kilogram];
			default: throw Error(`Unknown weight unit: ${e}`);
		}
	},
	transformMetersToKilometers: (e) => {
		let t = e / 1e3;
		return t % 1 == 0 ? t : parseFloat(t.toFixed(1));
	}
}, si = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
var ci = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, li = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, ui = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, di = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, fi = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(ui(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let a = li(r), o = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : pi({
		allowReserved: e,
		name: n,
		value: t
	})).join(a);
	return r === "label" || r === "matrix" ? a + o : o;
}, pi = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, mi = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = di(r), s = Object.entries(i).map(([t, i]) => pi({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + s : s;
}, hi = /\{[^{}]+\}/g, gi = ({ path: e, url: t }) => {
	let n = t, r = t.match(hi);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, fi({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, mi({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${pi({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, _i = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = gi({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function vi(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
var yi = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, bi = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = fi({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = mi({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = pi({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, xi = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, Si = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, Ci = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (Si(t, n.name)) continue;
		let e = await yi(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, wi = (e) => _i({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : bi(e.querySerializer),
	url: e.url
}), Ti = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = Di(e.headers, t.headers), n;
}, Ei = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, Di = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? Ei(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, Oi = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, ki = () => ({
	error: new Oi(),
	request: new Oi(),
	response: new Oi()
}), Ai = bi({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), ji = { "Content-Type": "application/json" }, Mi = (e = {}) => ({
	...si,
	headers: ji,
	parseAs: "auto",
	querySerializer: Ai,
	...e
});
((e = {}) => {
	let t = Ti(Mi(), e), n = () => ({ ...t }), r = (e) => (t = Ti(t, e), n()), i = ki(), a = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: Di(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await Ci({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: wi(n)
		};
	}, o = async (e) => {
		let { opts: t, url: n } = await a(e), r = {
			redirect: "follow",
			...t,
			body: vi(t)
		}, o = new Request(n, r);
		for (let e of i.request.fns) e && (o = await e(o, t));
		let s = t.fetch, c;
		try {
			c = await s(o);
		} catch (e) {
			let n = e;
			for (let r of i.error.fns) r && (n = await r(e, void 0, o, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: o,
				response: void 0
			};
		}
		for (let e of i.response.fns) e && (c = await e(c, o, t));
		let l = {
			request: o,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? xi(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of i.error.fns) e && (p = await e(f, c, o, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, s = (e) => (t) => o({
		...t,
		method: e
	}), c = (e) => async (t) => {
		let { opts: n, url: r } = await a(t);
		return ci({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of i.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: vi(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => wi({
			...t,
			...e
		}),
		connect: s("CONNECT"),
		delete: s("DELETE"),
		get: s("GET"),
		getConfig: n,
		head: s("HEAD"),
		interceptors: i,
		options: s("OPTIONS"),
		patch: s("PATCH"),
		post: s("POST"),
		put: s("PUT"),
		request: o,
		setConfig: r,
		sse: {
			connect: c("CONNECT"),
			delete: c("DELETE"),
			get: c("GET"),
			head: c("HEAD"),
			options: c("OPTIONS"),
			patch: c("PATCH"),
			post: c("POST"),
			put: c("PUT"),
			trace: c("TRACE")
		},
		trace: s("TRACE")
	};
})(Mi({ throwOnError: !0 }));
var Ni = w.string().length(2).regex(/[A-Z]{2}/).register(w.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), Pi = w.object({
	city: w.string().min(1).max(100).register(w.globalRegistry, { description: "The city of the address." }),
	countryCode: Ni,
	street: w.string().min(1).max(100).register(w.globalRegistry, { description: "The street of the address." }),
	additionalInformation: w.string().min(1).max(100).register(w.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: w.string().min(1).max(20).register(w.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: w.string().min(1).max(25).register(w.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: w.string().min(1).max(25).register(w.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: w.string().min(1).max(15).register(w.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: w.string().min(1).max(100).register(w.globalRegistry, { description: "The region of the address." }).optional(),
	state: w.string().min(1).max(100).register(w.globalRegistry, { description: "The state of the address." }).optional()
}).register(w.globalRegistry, { description: "A physical address." }), Fi = w.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM",
	"BOL"
]).register(w.globalRegistry, { description: "The carrier of the package." }), Ii = w.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]).register(w.globalRegistry, { description: "The carrier to select to ship a package with." }), Li = w.object({
	groups: w.array(w.object({
		description: w.string().min(1).max(50).register(w.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: w.string().min(6).max(12).register(w.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: w.int().gte(1).lte(99999).register(w.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: w.object({
			currency: w.string().length(3).register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(w.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: w.object({
			unit: w.enum(["g", "kg"]).register(w.globalRegistry, { description: "The unit of weight." }),
			value: w.int().gte(1).lte(999999999)
		}).register(w.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: Ni.and(w.unknown().register(w.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(w.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).min(1).max(100).register(w.globalRegistry, { description: "The list of item groups." }),
	purpose: w.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]).register(w.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: w.object({
		unit: w.enum(["g", "kg"]).register(w.globalRegistry, { description: "The unit of weight." }),
		value: w.int().gte(1).lte(999999999)
	}).register(w.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: w.string().min(1).max(150).register(w.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(w.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), Ri = w.object({
	groups: w.array(w.object({
		description: w.string().min(1).max(100).register(w.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: w.string().min(6).max(12).register(w.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: w.int().gte(1).lte(99999).register(w.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: w.object({
			currency: w.string().length(3).register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(w.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: w.object({
			unit: w.enum(["g", "kg"]).register(w.globalRegistry, { description: "The total weight of all items within this specific group." }),
			value: w.int().gte(1).lte(999999999)
		}).register(w.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: Ni.and(w.unknown().register(w.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(w.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).min(1).max(100).register(w.globalRegistry, { description: "The list of item groups." }),
	purpose: w.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]).register(w.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: w.object({
		unit: w.enum(["g", "kg"]).register(w.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		value: w.int().gte(1).lte(999999999)
	}).register(w.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: w.string().min(1).max(150).register(w.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(w.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), zi = w.string().min(1).max(100).register(w.globalRegistry, { description: "The customer reference of the order." }), Bi = w.enum([
	"EARLY_MORNING_DELIVERY",
	"EVENING_DELIVERY",
	"EXPRESS_DELIVERY",
	"MORNING_DELIVERY",
	"PICKUP_EXPRESS_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"STANDARD_DELIVERY"
]).register(w.globalRegistry, { description: "The delivery type of the shipment." }), Vi = w.object({
	notifyOnDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: w.object({ date: w.iso.date().register(w.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(w.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}).register(w.globalRegistry, { description: "Options regarding delivery timing and notifications." }), Hi = w.object({
	options: Vi.optional(),
	type: Bi.optional()
}).register(w.globalRegistry, { description: "The delivery details of the shipment." }), Ui = w.object({ date: w.iso.date().register(w.globalRegistry, { description: "The date at which to drop off the package." }).optional() }).register(w.globalRegistry, { description: "The drop-off details." }), Wi = w.object({
	currency: w.string().length(3).register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
}).register(w.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), Gi = w.enum(["EU", "NON_EU"]).register(w.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), Ki = w.enum([
	"CANCELED",
	"COMPLETED",
	"DISCOVERED",
	"IMPORT_REQUESTED",
	"OPEN",
	"PROCESSING",
	"RETURNING"
]).register(w.globalRegistry, { description: "The status of the order." }), qi = w.enum([
	"DIGITAL_STAMP",
	"ENVELOPE",
	"MAILBOX",
	"PACKAGE",
	"PALLET",
	"SMALL_PACKAGE",
	"UNFRANKED"
]).register(w.globalRegistry, { description: "The type of the package." }), Ji = w.union([
	w.object({
		group: w.enum(["PICKING_AND_PACKING"]),
		name: w.enum(["PACKED"])
	}),
	w.object({
		group: w.enum(["DISPATCHING"]),
		name: w.enum(["READY_TO_SHIP"])
	}),
	w.object({
		group: w.enum(["DISPATCHING"]),
		name: w.enum(["LABELED"])
	}),
	w.object({
		group: w.enum(["DISPATCHING"]),
		name: w.enum(["HANDED_OVER"])
	}),
	w.object({
		group: w.enum(["UNTRACEABLE"]),
		name: w.enum(["LABELED"])
	}),
	w.object({
		group: w.enum(["SORTING"]),
		name: w.enum(["IN_SORTING_PROCESS"])
	}),
	w.object({
		group: w.enum(["DISTRIBUTING"]),
		name: w.enum(["OUT_FOR_DELIVERY"])
	}),
	w.object({
		group: w.enum(["DISTRIBUTING"]),
		name: w.enum(["AT_CUSTOMS"])
	}),
	w.object({
		group: w.enum(["DISTRIBUTING"]),
		name: w.enum(["AT_PICKUP_POINT"])
	}),
	w.object({
		group: w.enum(["DELIVERED"]),
		name: w.enum(["AT_AGREED_LOCATION"])
	}),
	w.object({
		group: w.enum(["DELIVERED"]),
		name: w.enum(["AT_RECIPIENT"])
	}),
	w.object({
		group: w.enum(["DELIVERED"]),
		name: w.enum(["AT_SENDER"])
	}),
	w.object({
		group: w.enum(["DELIVERED"]),
		name: w.enum(["MARKED_AS"])
	}),
	w.object({
		group: w.enum(["DELIVERED"]),
		name: w.enum(["PICKED_UP"])
	})
]), Yi = w.enum([
	"PAID",
	"PENDING",
	"UNPAID"
]).register(w.globalRegistry, { description: "The current payment status." }), Xi = w.object({
	height: w.object({
		unit: w.enum([
			"mm",
			"cm",
			"m"
		]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The height." }).optional(),
	length: w.object({
		unit: w.enum([
			"mm",
			"cm",
			"m"
		]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The length." }).optional(),
	weight: w.object({
		unit: w.enum(["g", "kg"]).register(w.globalRegistry, { description: "The unit of weight." }),
		value: w.int().gte(1).lte(999999999)
	}).register(w.globalRegistry, { description: "The weight." }).optional(),
	width: w.object({
		unit: w.enum([
			"mm",
			"cm",
			"m"
		]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The width." }).optional()
}), Zi = w.object({
	height: w.object({
		unit: w.enum([
			"mm",
			"cm",
			"m"
		]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The height." }).optional(),
	length: w.object({
		unit: w.enum([
			"mm",
			"cm",
			"m"
		]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The length." }).optional(),
	weight: w.object({
		unit: w.enum(["g", "kg"]).register(w.globalRegistry, { description: "The unit of weight." }),
		value: w.int().gte(1).lte(999999999)
	}).register(w.globalRegistry, { description: "The physical weight." }),
	width: w.object({
		unit: w.enum([
			"mm",
			"cm",
			"m"
		]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The width." }).optional()
}).register(w.globalRegistry, { description: "The physical dimensions." }), Qi = w.union([Ni, Gi]), $i = w.enum(["OUTBOUND", "INBOUND"]).register(w.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }), ea = w.object({
	additionalInsurance: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: w.object({ amount: w.object({
		currency: w.string().length(3).register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(w.globalRegistry, { description: "The amount to insure." }) }).register(w.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: w.object({ amount: w.object({
		currency: w.string().length(3).register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(w.globalRegistry, { description: "The amount of the contribution." }) }).register(w.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional()
}).register(w.globalRegistry, { description: "Options applicable to shipments." }), ta = w.object({ customLabelText: w.object({ text: w.string().min(1).max(45).register(w.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(w.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional() }).register(w.globalRegistry, { description: "Options applicable to individual packages of a shipment." }), na = ea.and(ta), ra = w.enum(["ASC", "DESC"]).register(w.globalRegistry, { description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)." }), ia = w.object({
	emailAddress: w.string().min(1).max(320).register(w.globalRegistry, { description: "An email address." }).optional(),
	locale: w.union([w.string().length(5).register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().length(2).register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: w.string().min(1).max(50).register(w.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: w.enum(["BUSINESS"]).register(w.globalRegistry, { description: "Discriminator for business contacts." }),
	company: w.string().min(1).max(100).register(w.globalRegistry, { description: "The name of the company." }),
	attention: w.string().min(1).max(100).register(w.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: w.record(w.string(), w.string().min(1).max(20).register(w.globalRegistry, { description: "The VAT registration number for the given country." })).register(w.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: w.string().min(1).max(20).register(w.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: w.string().min(1).max(20).register(w.globalRegistry, { description: "The EORI number of the company." }).optional()
}), aa = w.object({
	emailAddress: w.string().min(1).max(320).register(w.globalRegistry, { description: "An email address." }).optional(),
	locale: w.union([w.string().length(5).register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().length(2).register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: w.string().min(1).max(50).register(w.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: w.enum(["PRIVATE"]).register(w.globalRegistry, { description: "Discriminator for private contacts." }),
	name: w.string().min(1).max(200).register(w.globalRegistry, { description: "The name of the contact person." })
}), oa = w.union([w.object({ type: w.literal("BUSINESS") }).and(ia), w.object({ type: w.literal("PRIVATE") }).and(aa)]), sa = w.object({
	locale: w.union([w.string().length(5).register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().length(2).register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: w.string().min(1).max(50).register(w.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: w.enum(["BUSINESS"]).register(w.globalRegistry, { description: "Discriminator for business contacts." }),
	company: w.string().min(1).max(100).register(w.globalRegistry, { description: "The name of the company." }),
	attention: w.string().min(1).max(100).register(w.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: w.record(w.string(), w.string().min(1).max(20).register(w.globalRegistry, { description: "The VAT registration number for the given country." })).register(w.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: w.string().min(1).max(20).register(w.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: w.string().min(1).max(20).register(w.globalRegistry, { description: "The EORI number of the company." }).optional(),
	emailAddresses: w.array(w.string().min(1).max(320).register(w.globalRegistry, { description: "An email address." })).min(1).max(5).register(w.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(w.globalRegistry, { description: "A business contact that supports multiple email addresses." }), ca = w.object({
	locale: w.union([w.string().length(5).register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().length(2).register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: w.string().min(1).max(50).register(w.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: w.enum(["PRIVATE"]).register(w.globalRegistry, { description: "Discriminator for private contacts." }),
	name: w.string().min(1).max(200).register(w.globalRegistry, { description: "The name of the contact person." }),
	emailAddresses: w.array(w.string().min(1).max(320).register(w.globalRegistry, { description: "An email address." })).min(1).max(5).register(w.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(w.globalRegistry, { description: "A private contact that supports multiple email addresses." }), la = w.union([w.object({ type: w.literal("BUSINESS") }).and(sa), w.object({ type: w.literal("PRIVATE") }).and(ca)]), ua = w.object({
	address: Pi.optional(),
	contact: oa.optional()
}).register(w.globalRegistry, { description: "The billing details of an order." }), da = w.object({
	name: w.enum([
		"BOL",
		"CSCART",
		"LIGHTSPEED",
		"MAGENTO",
		"PRESTA",
		"SHOPIFY",
		"WOOCOMMERCE"
	]).register(w.globalRegistry, { description: "The identifier of the external e-commerce platform." }),
	sourceId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(w.globalRegistry, { description: "The external reference of the ecommerce platform." }), fa = w.object({
	id: w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the sales channel." }),
	name: w.string().min(3).max(50).register(w.globalRegistry, { description: "The name of the sales channel at the time of import." })
}).register(w.globalRegistry, { description: "The external reference of the sales channel." }), pa = w.object({
	source: w.enum(["SALES_CHANNEL"]),
	salesChannel: fa,
	ecommercePlatform: da
}), ma = w.object({ source: w.enum(["MYPARCEL_SHOP"]) }).register(w.globalRegistry, { description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel" }), ha = w.object({
	source: w.enum(["IMPORT"]),
	sourceId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(w.globalRegistry, { description: "This external reference is set when the order originates from a generic ecommerce order import" }), ga = w.union([
	w.object({ source: w.literal("SALES_CHANNEL") }).and(pa),
	w.object({ source: w.literal("MYPARCEL_SHOP") }).and(ma),
	w.object({ source: w.literal("IMPORT") }).and(ha)
]), _a = w.object({ sourceId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The order line ID as defined in the source system." }) }).register(w.globalRegistry, { description: "The external reference of the order line." }), va = w.object({
	credited: w.boolean().register(w.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: w.union([w.string().regex(/^shop\/.{1,250}$/).register(w.globalRegistry, { description: "A shop principal identifier." }), w.string().regex(/^user\/.{1,250}$/).register(w.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: Yi.optional(),
	barcode: w.string().min(1).max(50).register(w.globalRegistry, { description: "The barcode of the label." }),
	delayed: w.boolean().register(w.globalRegistry, { description: "Whether the shipment is delayed." }),
	partnerBarcodes: w.array(w.string().min(1).max(50).register(w.globalRegistry, { description: "The barcode identifier associated with the shipment label." })).min(1).max(5).register(w.globalRegistry, { description: "The partner barcodes when the parcel is taken over by a partner carrier." }).optional()
}), ya = w.object({
	credited: w.boolean().register(w.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: w.union([w.string().regex(/^shop\/.{1,250}$/).register(w.globalRegistry, { description: "A shop principal identifier." }), w.string().regex(/^user\/.{1,250}$/).register(w.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: Yi.optional()
}), ba = w.object({
	type: w.enum(["IMPORTED"]),
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	origin: w.enum(["SALES_CHANNEL"]).register(w.globalRegistry, { description: "The origin of the note." }),
	text: w.string().min(1).max(2500).register(w.globalRegistry, { description: "The text of the note." }),
	author: w.string().min(1).max(200).register(w.globalRegistry, { description: "The author of the note." }).optional(),
	locale: w.union([w.string().length(5).register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().length(2).register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), xa = w.object({
	type: w.enum(["PRINCIPAL"]),
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	principal: w.string().min(1).max(100).register(w.globalRegistry, { description: "The principal who crated the note." }),
	text: w.string().min(1).max(2500).register(w.globalRegistry, { description: "The text of the note." }),
	locale: w.union([w.string().length(5).register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().length(2).register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), Sa = w.union([w.object({ type: w.literal("IMPORTED") }).and(ba), w.object({ type: w.literal("PRINCIPAL") }).and(xa)]), Ca = w.union([
	w.object({
		address: Pi,
		location: w.object({
			name: w.string().min(1).max(200).register(w.globalRegistry, { description: "The name of the pickup location." }),
			code: w.string().min(1).max(64).register(w.globalRegistry, { description: "The location code of the pickup location." }).optional(),
			type: w.enum([
				"CLICK_COLLECT",
				"PARCEL_LOCKER",
				"PARCEL_POINT",
				"POST_OFFICE",
				"POST_POINT"
			]).register(w.globalRegistry, { description: "The bpost pickup location type." })
		}).register(w.globalRegistry, { description: "The pickup location details." })
	}).register(w.globalRegistry, { description: "The bpost pickup details." }),
	w.object({
		address: Pi,
		location: w.object({
			name: w.string().min(1).max(200).register(w.globalRegistry, { description: "The name of the pickup location." }),
			code: w.string().min(1).max(64).register(w.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(w.globalRegistry, { description: "The pickup location details." }),
		retailNetworkId: w.enum(["PNPNL-01", "PNPBE-01"]).register(w.globalRegistry, { description: "PostNL Retail network ID." })
	}).register(w.globalRegistry, { description: "The PostNL pickup details." }),
	w.object({
		address: Pi,
		location: w.object({
			name: w.string().min(1).max(200).register(w.globalRegistry, { description: "The name of the pickup location." }),
			code: w.string().min(1).max(64).register(w.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(w.globalRegistry, { description: "The pickup location details." })
	}).register(w.globalRegistry, { description: "The general pickup details." })
]), wa = w.object({
	carrier: Fi,
	direction: $i,
	disableAutoDetectPickup: w.boolean().register(w.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
	packageType: qi,
	recipient: w.object({
		address: Pi,
		contact: la
	}).register(w.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: Hi.optional(),
	options: ea.optional(),
	pickup: Ca.optional(),
	sender: w.object({
		address: Pi,
		contact: oa
	}).register(w.globalRegistry, { description: "The sender of the shipment." }).optional(),
	saveRecipientAddress: w.boolean().register(w.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
}), Ta = w.object({
	id: w.string().min(1).register(w.globalRegistry, { description: "The unique identifier of the shipment." }),
	carrier: Fi,
	createdAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	direction: $i,
	hidden: w.boolean().register(w.globalRegistry, { description: "Whether the shipment is hidden." }),
	packageType: qi,
	recipient: w.object({
		address: Pi.optional(),
		contact: la.optional()
	}).register(w.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: Ri.optional(),
	delivery: Hi.optional(),
	dropOff: Ui.optional(),
	label: w.union([va, ya]).optional(),
	multicollo: w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier for a multicollo shipment group." }),
		totalPackages: w.int().gte(2).lte(20).register(w.globalRegistry, { description: "The total number of individual packages included within this specific multicollo shipment group." })
	}).register(w.globalRegistry, { description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group." }).optional(),
	options: na.optional(),
	pickup: Ca.optional(),
	price: Wi.optional(),
	sender: w.object({
		address: Pi,
		contact: oa
	}).register(w.globalRegistry, { description: "The sender of the shipment." }).optional()
}).register(w.globalRegistry, { description: "The shipment properties of a package." }), Ea = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a line of an order." }),
	product: w.object({
		name: w.string().min(1).max(250).register(w.globalRegistry, { description: "The name of the product." }),
		ean: w.string().min(1).max(13).register(w.globalRegistry, { description: "The EAN of the product." }).optional(),
		sku: w.string().min(1).max(200).register(w.globalRegistry, { description: "The SKU of the product." }).optional(),
		id: w.uuid().register(w.globalRegistry, { description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined." }).optional()
	}).register(w.globalRegistry, { description: "The product of an order line." }),
	quantity: w.int().gte(1).register(w.globalRegistry, { description: "The quantity of the product of the order line." }),
	externalReference: _a.optional(),
	price: Wi.and(w.unknown().register(w.globalRegistry, { description: "The price of the product of the order line." })).optional()
}).register(w.globalRegistry, { description: "The line of the order" }), Da = w.object({
	customsDeclaration: Li.optional(),
	options: ta.optional(),
	physicalProperties: Zi.optional()
}), Oa = w.object({
	lines: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: w.int().gte(1).register(w.globalRegistry, { description: "The quantity of the product of the order line." })
	})).min(1).max(100).optional(),
	physicalProperties: Zi.optional()
}), ka = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the package." }),
	status: Ji,
	physicalProperties: Xi.optional(),
	lines: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: w.int().gte(1).register(w.globalRegistry, { description: "The quantity that the package contains" })
	})).min(1).max(100).register(w.globalRegistry, { description: "The order lines related to the package." }).optional(),
	shipment: Ta.optional()
}), Aa = w.object({
	customsDeclaration: Li.optional(),
	options: ta.optional(),
	physicalProperties: Zi.optional(),
	shipment: w.object({
		carrier: Ii,
		direction: $i,
		disableAutoDetectPickup: w.boolean().register(w.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
		packageType: qi,
		recipient: w.object({
			address: Pi,
			contact: la
		}).register(w.globalRegistry, { description: "The recipient of the shipment." }),
		customContractId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
		delivery: Hi.optional(),
		options: ea.optional(),
		pickup: Ca.optional(),
		sender: w.object({
			address: Pi,
			contact: oa
		}).register(w.globalRegistry, { description: "The sender of the shipment." }).optional(),
		saveRecipientAddress: w.boolean().register(w.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
	})
}), ja = w.object({
	carrier: Fi.optional(),
	customContractId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: Ri.optional(),
	delivery: Hi.optional(),
	direction: $i.optional(),
	disableAutoDetectPickup: w.boolean().register(w.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: w.int().gte(1).lte(20).optional(),
	options: na.optional(),
	packageType: qi.optional(),
	pickup: Ca.optional(),
	recipient: w.object({
		address: Pi.optional(),
		contact: la.optional()
	}).register(w.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(w.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), Ma = w.union([w.object({
	shopId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: zi.optional(),
	package: Aa
}), w.object({
	shopId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: zi.optional(),
	multicollo: w.object({
		packages: w.array(Da).min(2).max(20),
		shipment: w.object({
			carrier: Ii,
			direction: $i,
			disableAutoDetectPickup: w.boolean().register(w.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
			packageType: qi,
			recipient: w.object({
				address: Pi,
				contact: la
			}).register(w.globalRegistry, { description: "The recipient of the shipment." }),
			customContractId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
			delivery: Hi.optional(),
			options: ea.optional(),
			pickup: Ca.optional(),
			sender: w.object({
				address: Pi,
				contact: oa
			}).register(w.globalRegistry, { description: "The sender of the shipment." }).optional(),
			saveRecipientAddress: w.boolean().register(w.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
		})
	})
})]), Na = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
	packages: w.array(Oa).min(1).max(25)
}), Pa = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the package." }),
	customsDeclaration: Li.optional(),
	options: ta.optional(),
	physicalProperties: Zi.optional()
}), Fa = w.union([w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: wa,
	packages: w.array(Pa).min(1).max(25)
}), w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: wa,
	multicollo: w.array(Pa).min(2).max(25)
})]), Ia = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
	orderedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	price: Wi,
	shopId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the shop." }),
	shortId: w.string().length(9).register(w.globalRegistry, { description: "The short ID of the order." }),
	status: Ki,
	assignedUserId: w.string().min(1).max(50).register(w.globalRegistry, { description: "The user ID assigned to the order." }).optional(),
	billingDetails: ua.optional(),
	customerReference: zi.optional(),
	externalReferences: ga.and(w.unknown().register(w.globalRegistry, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." })).optional(),
	lines: w.array(Ea).min(1).max(100).register(w.globalRegistry, { description: "The lines of the order" }).optional(),
	notes: w.array(Sa).min(1).max(100).register(w.globalRegistry, { description: "The notes of the order." }).optional(),
	packages: w.array(ka).min(1).max(25).register(w.globalRegistry, { description: "The packages of the order." }).optional(),
	rules: w.object({ setShippingPreferences: w.object({
		path: w.array(w.union([w.object({
			id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the rule." }),
			name: w.string().register(w.globalRegistry, { description: "The name of the rule." })
		}), w.object({
			id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the rule group." }),
			condition: w.union([w.object({ countryCode: Ni }), w.object({ geoAreaCode: Gi })])
		})])).min(1).register(w.globalRegistry, { description: "The path of the rule." }),
		appliedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
		result: w.enum(["PRESERVE", "REPLACE"]).register(w.globalRegistry, { description: "How the rule was applied." })
	}).optional() }).register(w.globalRegistry, { description: "The rules that have been applied to the order." }).optional(),
	shipping: ja.optional()
}), La = w.object({
	type: w.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(w.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: w.union([
		w.literal(400),
		w.literal(401),
		w.literal(404),
		w.literal(415),
		w.literal(500)
	]).register(w.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: w.string().min(1).max(100).register(w.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: w.string().min(1).max(5e3).register(w.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: w.url().register(w.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: w.unknown().register(w.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), Ra = La.and(w.object({
	type: w.enum(["urn:problem:client"]).register(w.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: w.literal(400).register(w.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: w.array(w.object({
		detail: w.string().min(1).max(5e3),
		pointer: w.string().min(1).max(200).register(w.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(w.globalRegistry, { description: "Detailed information regarding the violations." })
})), za = La.and(w.object({
	type: w.enum(["urn:problem:server"]).register(w.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: w.literal(500).register(w.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
}));
La.and(w.object({
	type: w.enum(["urn:problem:invalid-request-syntax"]).register(w.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: w.literal(400).register(w.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: w.array(w.object({
		detail: w.string().min(1).max(5e3),
		pointer: w.string().min(1).max(200).register(w.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(w.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		text: w.string().min(1).max(2500).register(w.globalRegistry, { description: "The text of the note." }),
		locale: w.union([w.string().length(5).register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().length(2).register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional()
	})).min(1).max(50).register(w.globalRegistry, { description: "Body for adding an order note." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({
		status: w.literal(200),
		ids: w.array(w.uuid()).min(1)
	}),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		userId: w.string().min(1).max(50).register(w.globalRegistry, { description: "User to assign to these orders." })
	})).min(1).max(50).register(w.globalRegistry, { description: "Body for assigning orders to an user." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({ id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(w.globalRegistry, { description: "Body for canceling orders." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(Ma).min(1).max(50).register(w.globalRegistry, { description: "Body for creating an order with shippable packages." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({
		status: w.literal(201),
		id: w.uuid()
	}),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per item." }), w.object({
	body: w.array(Na).min(1).max(50).register(w.globalRegistry, { description: "Body adding packages to orders" }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({
		status: w.literal(200),
		ids: w.array(w.uuid()).min(1)
	}),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(Fa).min(1).max(50).register(w.globalRegistry, { description: "Body preparing packages for shipment" }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		packageIds: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(25)
	})).min(1).max(50).register(w.globalRegistry, { description: "Body for unpreparing packages for shipment" }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		noteId: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a note of an order." }),
		text: w.string().min(1).max(2500).register(w.globalRegistry, { description: "The text of the note." })
	})).min(1).max(50).register(w.globalRegistry, { description: "Body for editing an order note." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({ id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(w.globalRegistry, { description: "Body for importing an order." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.never().optional(),
	path: w.never().optional(),
	query: w.object({
		aggregations: w.array(Ki).min(1).max(7).register(w.globalRegistry, { description: "The statuses to retrieve counts for." }).optional(),
		filter: w.object({
			assignedUserId: w.array(w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the user." })).min(1).max(100).optional(),
			carrier: w.array(Fi).min(1).max(16).optional(),
			hasAssignedUser: w.enum(["true", "false"]).register(w.globalRegistry, { description: "Whether the order has an assigned user or not." }).optional(),
			hasNotes: w.enum(["true", "false"]).register(w.globalRegistry, { description: "Whether the order has notes or not." }).optional(),
			orderId: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(100).optional(),
			orderedAt: w.array(w.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<datetime>((\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\d|3[01])|(0[469]|11)-(0[1-9]|[12]\d|30)|(02)-(0[1-9]|1\d|2[0-8])))T([01]\d|2[0-3]):[0-5]\d(:[0-5]\d(\.\d+)?)?(Z|([+-]\d{2}:?\d{2})))$/).register(w.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).min(1).max(2).optional(),
			packageStatusGroup: w.array(w.enum([
				"PICKING_AND_PACKING",
				"DISPATCHING",
				"UNTRACEABLE",
				"SORTING",
				"DISTRIBUTING",
				"DELIVERED"
			])).min(1).max(6).optional(),
			packageType: w.array(qi).min(1).max(7).optional(),
			price: w.array(w.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<number>\d{1,15}(?:.\d{0,2})?)$/).register(w.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a number with a maximum precision of 2." })).min(1).max(2).optional(),
			regionCode: w.array(Qi).min(1).max(100).optional(),
			salesChannelId: w.array(w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the sales channel." })).min(1).max(100).optional(),
			shipmentDelayed: w.enum(["true", "false"]).register(w.globalRegistry, { description: "Whether the order has a package with a delayed shipment or not." }).optional(),
			shipmentDirection: w.array($i).min(1).max(2).optional(),
			shipmentPaymentStatus: w.array(Yi).min(1).max(3).optional(),
			shopId: w.array(w.string().min(1).max(50).register(w.globalRegistry, { description: "The unique identifier of the shop." })).min(1).max(100).optional(),
			status: w.array(Ki).min(1).max(7).optional()
		}).optional(),
		limit: w.int().gte(0).lte(50).nullish().default(50),
		pageToken: w.string().min(4).max(500).register(w.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		query: w.string().min(1).max(500).register(w.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: w.object({
			customerReference: ra.optional(),
			orderedAt: ra.optional(),
			price: ra.optional(),
			sourceId: ra.optional()
		}).register(w.globalRegistry, { description: "When no `query` is provided the default sort is by `orderedAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
}), w.object({
	results: w.array(Ia).min(0).max(50).register(w.globalRegistry, { description: "The list of orders." }),
	total: w.object({
		relation: w.enum(["eq", "gte"]).register(w.globalRegistry, { description: "The relation of the total number of orders." }),
		value: w.int().gte(0).register(w.globalRegistry, { description: "The total number of orders." })
	}),
	aggregations: w.object({ status: w.array(w.object({
		key: Ki,
		count: w.int().gte(0)
	})).optional() }).register(w.globalRegistry, { description: "Count of orders per status, scoped to the active search query and all active filters except the status filter." }).optional(),
	nextPageToken: w.string().min(1).max(500).register(w.globalRegistry, { description: "The next page token to retrieve the next page of orders." }).optional()
}).register(w.globalRegistry, { description: "The found orders." }), w.object({
	body: w.never().optional(),
	path: w.never().optional(),
	query: w.object({
		shipmentLabelsLayout: w.enum(["INTERLEAVED"]).register(w.globalRegistry, { description: "How shipment labels are included alongside the packing slips in the resulting PDF. `INTERLEAVED` outputs each packing slip immediately followed by its shipment label. When the parameter is omitted, no shipment labels are included and only packing slips are rendered." }).optional(),
		orderId: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(50).register(w.globalRegistry, { description: "The orderId of the order to include in the packing slips. A maximum of 50 orders can be included in the request. When packageId is provided, exactly one orderId is allowed." }),
		packageId: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(20).register(w.globalRegistry, { description: "The packageId of the package to include in the packing slips. The packageIds must belong to the single orderId in the request and a maximum of 20 packageIds can be included." }).optional()
	}),
	headers: w.object({ Accept: w.enum(["application/pdf", "application/pdf+print"]).register(w.globalRegistry, { description: "Use `application/pdf` to download the packing slip. Use `application/pdf+print; printer-group-id=<uuid>` to send the packing slip directly to a printer group." }) })
}), w.union([w.string().register(w.globalRegistry, { description: "Packing slips PDF. Returned when `Accept: application/pdf`." }), w.void().register(w.globalRegistry, { description: "The packing slip has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), w.object({
	body: w.never().optional(),
	path: w.never().optional(),
	query: w.object({ orderId: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(50).register(w.globalRegistry, { description: "The orderId of the order to include in the picklist. A maximum of 50 orders can be included in the request." }) }),
	headers: w.object({ Accept: w.enum(["application/pdf", "application/pdf+print"]).register(w.globalRegistry, { description: "Use `application/pdf` to download the picklist. Use `application/pdf+print; printer-group-id=<uuid>` to send the picklist directly to a printer group." }) })
}), w.union([w.string().register(w.globalRegistry, { description: "Picklist PDF. Returned when `Accept: application/pdf`." }), w.void().register(w.globalRegistry, { description: "The picklist has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		noteIds: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of a note of an order." })).min(1).max(150).register(w.globalRegistry, { description: "Note IDs to remove from the order." })
	})).min(1).max(50).register(w.globalRegistry, { description: "Body for removing order notes." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({ id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(w.globalRegistry, { description: "Body for unassigning orders from an user." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({ id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(w.globalRegistry, { description: "Body for evaluating order rules." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ra,
	za
])).min(1).max(50).register(w.globalRegistry, { description: "The result per ID." });
var Ba = w.string().register(w.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), Va = w.object({
	city: w.string().register(w.globalRegistry, { description: "The city of the address." }),
	countryCode: Ba,
	street: w.string().register(w.globalRegistry, { description: "The street of the address." }),
	additionalInformation: w.string().register(w.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: w.string().register(w.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: w.string().register(w.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: w.string().register(w.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: w.string().register(w.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: w.string().register(w.globalRegistry, { description: "The region of the address." }).optional(),
	state: w.string().register(w.globalRegistry, { description: "The state of the address." }).optional()
}).register(w.globalRegistry, { description: "A physical address." }), Ha = w.union([w.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM",
	"BOL"
]), w.string()]).register(w.globalRegistry, { description: "The carrier of the package." }), Ua = w.union([w.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]), w.string()]).register(w.globalRegistry, { description: "The carrier to select to ship a package with." }), Wa = w.object({
	groups: w.array(w.object({
		description: w.string().register(w.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: w.string().register(w.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: w.int().gte(1).lte(99999).register(w.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: w.object({
			currency: w.string().register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(w.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: w.object({
			unit: w.union([w.enum(["g", "kg"]), w.string()]).register(w.globalRegistry, { description: "The unit of weight." }),
			value: w.int().gte(1).lte(999999999)
		}).register(w.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: Ba.and(w.unknown().register(w.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(w.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).register(w.globalRegistry, { description: "The list of item groups." }),
	purpose: w.union([w.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]), w.string()]).register(w.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: w.object({
		unit: w.union([w.enum(["g", "kg"]), w.string()]).register(w.globalRegistry, { description: "The unit of weight." }),
		value: w.int().gte(1).lte(999999999)
	}).register(w.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: w.string().register(w.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(w.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), Ga = w.object({
	groups: w.array(w.object({
		description: w.string().register(w.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: w.string().register(w.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: w.int().gte(1).lte(99999).register(w.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: w.object({
			currency: w.string().register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
		}).register(w.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: w.object({
			unit: w.union([w.enum(["g", "kg"]), w.string()]).register(w.globalRegistry, { description: "The total weight of all items within this specific group." }),
			value: w.int().gte(1).lte(999999999)
		}).register(w.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: Ba.and(w.unknown().register(w.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." })).optional()
	}).register(w.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).register(w.globalRegistry, { description: "The list of item groups." }),
	purpose: w.union([w.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]), w.string()]).register(w.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: w.object({
		unit: w.union([w.enum(["g", "kg"]), w.string()]).register(w.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		value: w.int().gte(1).lte(999999999)
	}).register(w.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: w.string().register(w.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(w.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), Ka = w.string().register(w.globalRegistry, { description: "The customer reference of the order." }), qa = w.union([w.enum([
	"EARLY_MORNING_DELIVERY",
	"EVENING_DELIVERY",
	"EXPRESS_DELIVERY",
	"MORNING_DELIVERY",
	"PICKUP_EXPRESS_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"STANDARD_DELIVERY"
]), w.string()]).register(w.globalRegistry, { description: "The delivery type of the shipment." }), Ja = w.object({
	notifyOnDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: w.object({ date: w.iso.date().register(w.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(w.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}).register(w.globalRegistry, { description: "Options regarding delivery timing and notifications." }), Ya = w.object({
	options: Ja.optional(),
	type: qa.optional()
}).register(w.globalRegistry, { description: "The delivery details of the shipment." }), Xa = w.object({ date: w.iso.date().register(w.globalRegistry, { description: "The date at which to drop off the package." }).optional() }).register(w.globalRegistry, { description: "The drop-off details." }), Za = w.object({
	currency: w.string().register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
}).register(w.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), Qa = w.union([w.enum(["EU", "NON_EU"]), w.string()]).register(w.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), $a = w.union([w.enum([
	"CANCELED",
	"COMPLETED",
	"DISCOVERED",
	"IMPORT_REQUESTED",
	"OPEN",
	"PROCESSING",
	"RETURNING"
]), w.string()]).register(w.globalRegistry, { description: "The status of the order." }), eo = w.union([w.enum([
	"DIGITAL_STAMP",
	"ENVELOPE",
	"MAILBOX",
	"PACKAGE",
	"PALLET",
	"SMALL_PACKAGE",
	"UNFRANKED"
]), w.string()]).register(w.globalRegistry, { description: "The type of the package." }), to = w.union([
	w.object({
		group: w.union([w.enum(["PICKING_AND_PACKING"]), w.string()]),
		name: w.union([w.enum(["PACKED"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DISPATCHING"]), w.string()]),
		name: w.union([w.enum(["READY_TO_SHIP"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DISPATCHING"]), w.string()]),
		name: w.union([w.enum(["LABELED"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DISPATCHING"]), w.string()]),
		name: w.union([w.enum(["HANDED_OVER"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["UNTRACEABLE"]), w.string()]),
		name: w.union([w.enum(["LABELED"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["SORTING"]), w.string()]),
		name: w.union([w.enum(["IN_SORTING_PROCESS"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DISTRIBUTING"]), w.string()]),
		name: w.union([w.enum(["OUT_FOR_DELIVERY"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DISTRIBUTING"]), w.string()]),
		name: w.union([w.enum(["AT_CUSTOMS"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DISTRIBUTING"]), w.string()]),
		name: w.union([w.enum(["AT_PICKUP_POINT"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DELIVERED"]), w.string()]),
		name: w.union([w.enum(["AT_AGREED_LOCATION"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DELIVERED"]), w.string()]),
		name: w.union([w.enum(["AT_RECIPIENT"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DELIVERED"]), w.string()]),
		name: w.union([w.enum(["AT_SENDER"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DELIVERED"]), w.string()]),
		name: w.union([w.enum(["MARKED_AS"]), w.string()])
	}),
	w.object({
		group: w.union([w.enum(["DELIVERED"]), w.string()]),
		name: w.union([w.enum(["PICKED_UP"]), w.string()])
	})
]), no = w.union([w.enum([
	"PAID",
	"PENDING",
	"UNPAID"
]), w.string()]).register(w.globalRegistry, { description: "The current payment status." }), ro = w.object({
	height: w.object({
		unit: w.union([w.enum([
			"mm",
			"cm",
			"m"
		]), w.string()]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The height." }).optional(),
	length: w.object({
		unit: w.union([w.enum([
			"mm",
			"cm",
			"m"
		]), w.string()]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The length." }).optional(),
	weight: w.object({
		unit: w.union([w.enum(["g", "kg"]), w.string()]).register(w.globalRegistry, { description: "The unit of weight." }),
		value: w.int().gte(1).lte(999999999)
	}).register(w.globalRegistry, { description: "The weight." }).optional(),
	width: w.object({
		unit: w.union([w.enum([
			"mm",
			"cm",
			"m"
		]), w.string()]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The width." }).optional()
}), io = w.object({
	height: w.object({
		unit: w.union([w.enum([
			"mm",
			"cm",
			"m"
		]), w.string()]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The height." }).optional(),
	length: w.object({
		unit: w.union([w.enum([
			"mm",
			"cm",
			"m"
		]), w.string()]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The length." }).optional(),
	weight: w.object({
		unit: w.union([w.enum(["g", "kg"]), w.string()]).register(w.globalRegistry, { description: "The unit of weight." }),
		value: w.int().gte(1).lte(999999999)
	}).register(w.globalRegistry, { description: "The physical weight." }),
	width: w.object({
		unit: w.union([w.enum([
			"mm",
			"cm",
			"m"
		]), w.string()]).register(w.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: w.int().gte(1).lte(1e6).register(w.globalRegistry, { description: "The dimension value." })
	}).register(w.globalRegistry, { description: "The width." }).optional()
}).register(w.globalRegistry, { description: "The physical dimensions." }), ao = w.union([Ba, Qa]), oo = w.union([w.enum(["OUTBOUND", "INBOUND"]), w.string()]).register(w.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }), so = w.object({
	additionalInsurance: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: w.object({ amount: w.object({
		currency: w.string().register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(w.globalRegistry, { description: "The amount to insure." }) }).register(w.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: w.object({ amount: w.object({
		currency: w.string().register(w.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		micros: w.int().gte(0).lte(9007199254740991).register(w.globalRegistry, { description: "The amount of money in integer micros." })
	}).register(w.globalRegistry, { description: "The amount of the contribution." }) }).register(w.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: w.record(w.string(), w.never()).register(w.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional()
}).register(w.globalRegistry, { description: "Options applicable to shipments." }), co = w.object({ customLabelText: w.object({ text: w.string().register(w.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(w.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional() }).register(w.globalRegistry, { description: "Options applicable to individual packages of a shipment." }), lo = so.and(co), uo = w.union([w.enum(["ASC", "DESC"]), w.string()]).register(w.globalRegistry, { description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)." }), fo = w.object({
	emailAddress: w.string().register(w.globalRegistry, { description: "An email address." }).optional(),
	locale: w.union([w.string().register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: w.string().register(w.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: w.union([w.enum(["BUSINESS"]), w.string()]).register(w.globalRegistry, { description: "Discriminator for business contacts." }),
	company: w.string().register(w.globalRegistry, { description: "The name of the company." }),
	attention: w.string().register(w.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: w.record(w.string(), w.string().register(w.globalRegistry, { description: "The VAT registration number for the given country." })).register(w.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: w.string().register(w.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: w.string().register(w.globalRegistry, { description: "The EORI number of the company." }).optional()
}), po = w.object({
	emailAddress: w.string().register(w.globalRegistry, { description: "An email address." }).optional(),
	locale: w.union([w.string().register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: w.string().register(w.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: w.union([w.enum(["PRIVATE"]), w.string()]).register(w.globalRegistry, { description: "Discriminator for private contacts." }),
	name: w.string().register(w.globalRegistry, { description: "The name of the contact person." })
}), mo = w.union([w.object({ type: w.literal("BUSINESS") }).and(fo), w.object({ type: w.literal("PRIVATE") }).and(po)]), ho = w.object({
	locale: w.union([w.string().register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: w.string().register(w.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: w.union([w.enum(["BUSINESS"]), w.string()]).register(w.globalRegistry, { description: "Discriminator for business contacts." }),
	company: w.string().register(w.globalRegistry, { description: "The name of the company." }),
	attention: w.string().register(w.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: w.record(w.string(), w.string().register(w.globalRegistry, { description: "The VAT registration number for the given country." })).register(w.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: w.string().register(w.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: w.string().register(w.globalRegistry, { description: "The EORI number of the company." }).optional(),
	emailAddresses: w.array(w.string().register(w.globalRegistry, { description: "An email address." })).register(w.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(w.globalRegistry, { description: "A business contact that supports multiple email addresses." }), go = w.object({
	locale: w.union([w.string().register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: w.string().register(w.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: w.union([w.enum(["PRIVATE"]), w.string()]).register(w.globalRegistry, { description: "Discriminator for private contacts." }),
	name: w.string().register(w.globalRegistry, { description: "The name of the contact person." }),
	emailAddresses: w.array(w.string().register(w.globalRegistry, { description: "An email address." })).register(w.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(w.globalRegistry, { description: "A private contact that supports multiple email addresses." }), _o = w.union([w.object({ type: w.literal("BUSINESS") }).and(ho), w.object({ type: w.literal("PRIVATE") }).and(go)]), vo = w.object({
	address: Va.optional(),
	contact: mo.optional()
}).register(w.globalRegistry, { description: "The billing details of an order." }), yo = w.object({
	name: w.union([w.enum([
		"BOL",
		"CSCART",
		"LIGHTSPEED",
		"MAGENTO",
		"PRESTA",
		"SHOPIFY",
		"WOOCOMMERCE"
	]), w.string()]).register(w.globalRegistry, { description: "The identifier of the external e-commerce platform." }),
	sourceId: w.string().register(w.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(w.globalRegistry, { description: "The external reference of the ecommerce platform." }), bo = w.object({
	id: w.string().register(w.globalRegistry, { description: "The unique identifier of the sales channel." }),
	name: w.string().register(w.globalRegistry, { description: "The name of the sales channel at the time of import." })
}).register(w.globalRegistry, { description: "The external reference of the sales channel." }), xo = w.object({
	source: w.union([w.enum(["SALES_CHANNEL"]), w.string()]),
	salesChannel: bo,
	ecommercePlatform: yo
}), So = w.object({ source: w.union([w.enum(["MYPARCEL_SHOP"]), w.string()]) }).register(w.globalRegistry, { description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel" }), Co = w.object({
	source: w.union([w.enum(["IMPORT"]), w.string()]),
	sourceId: w.string().register(w.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(w.globalRegistry, { description: "This external reference is set when the order originates from a generic ecommerce order import" }), wo = w.union([
	w.object({ source: w.literal("SALES_CHANNEL") }).and(xo),
	w.object({ source: w.literal("MYPARCEL_SHOP") }).and(So),
	w.object({ source: w.literal("IMPORT") }).and(Co)
]), To = w.object({ sourceId: w.string().register(w.globalRegistry, { description: "The order line ID as defined in the source system." }) }).register(w.globalRegistry, { description: "The external reference of the order line." }), Eo = w.object({
	credited: w.boolean().register(w.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: w.union([w.string().register(w.globalRegistry, { description: "A shop principal identifier." }), w.string().register(w.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: no.optional(),
	barcode: w.string().register(w.globalRegistry, { description: "The barcode of the label." }),
	delayed: w.boolean().register(w.globalRegistry, { description: "Whether the shipment is delayed." }),
	partnerBarcodes: w.array(w.string().register(w.globalRegistry, { description: "The barcode identifier associated with the shipment label." })).register(w.globalRegistry, { description: "The partner barcodes when the parcel is taken over by a partner carrier." }).optional()
}), Do = w.object({
	credited: w.boolean().register(w.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: w.union([w.string().register(w.globalRegistry, { description: "A shop principal identifier." }), w.string().register(w.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: no.optional()
}), Oo = w.object({
	type: w.union([w.enum(["IMPORTED"]), w.string()]),
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	origin: w.union([w.enum(["SALES_CHANNEL"]), w.string()]).register(w.globalRegistry, { description: "The origin of the note." }),
	text: w.string().register(w.globalRegistry, { description: "The text of the note." }),
	author: w.string().register(w.globalRegistry, { description: "The author of the note." }).optional(),
	locale: w.union([w.string().register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), ko = w.object({
	type: w.union([w.enum(["PRINCIPAL"]), w.string()]),
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	principal: w.string().register(w.globalRegistry, { description: "The principal who crated the note." }),
	text: w.string().register(w.globalRegistry, { description: "The text of the note." }),
	locale: w.union([w.string().register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), Ao = w.union([w.object({ type: w.literal("IMPORTED") }).and(Oo), w.object({ type: w.literal("PRINCIPAL") }).and(ko)]), jo = w.union([
	w.object({
		address: Va,
		location: w.object({
			name: w.string().register(w.globalRegistry, { description: "The name of the pickup location." }),
			code: w.string().register(w.globalRegistry, { description: "The location code of the pickup location." }).optional(),
			type: w.union([w.enum([
				"CLICK_COLLECT",
				"PARCEL_LOCKER",
				"PARCEL_POINT",
				"POST_OFFICE",
				"POST_POINT"
			]), w.string()]).register(w.globalRegistry, { description: "The bpost pickup location type." })
		}).register(w.globalRegistry, { description: "The pickup location details." })
	}).register(w.globalRegistry, { description: "The bpost pickup details." }),
	w.object({
		address: Va,
		location: w.object({
			name: w.string().register(w.globalRegistry, { description: "The name of the pickup location." }),
			code: w.string().register(w.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(w.globalRegistry, { description: "The pickup location details." }),
		retailNetworkId: w.union([w.enum(["PNPNL-01", "PNPBE-01"]), w.string()]).register(w.globalRegistry, { description: "PostNL Retail network ID." })
	}).register(w.globalRegistry, { description: "The PostNL pickup details." }),
	w.object({
		address: Va,
		location: w.object({
			name: w.string().register(w.globalRegistry, { description: "The name of the pickup location." }),
			code: w.string().register(w.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(w.globalRegistry, { description: "The pickup location details." })
	}).register(w.globalRegistry, { description: "The general pickup details." })
]), Mo = w.object({
	carrier: Ha,
	direction: oo,
	disableAutoDetectPickup: w.boolean().register(w.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
	packageType: eo,
	recipient: w.object({
		address: Va,
		contact: _o
	}).register(w.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: w.string().register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: Ya.optional(),
	options: so.optional(),
	pickup: jo.optional(),
	sender: w.object({
		address: Va,
		contact: mo
	}).register(w.globalRegistry, { description: "The sender of the shipment." }).optional(),
	saveRecipientAddress: w.boolean().register(w.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
}), No = w.object({
	id: w.string().register(w.globalRegistry, { description: "The unique identifier of the shipment." }),
	carrier: Ha,
	createdAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	direction: oo,
	hidden: w.boolean().register(w.globalRegistry, { description: "Whether the shipment is hidden." }),
	packageType: eo,
	recipient: w.object({
		address: Va.optional(),
		contact: _o.optional()
	}).register(w.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: w.string().register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: Ga.optional(),
	delivery: Ya.optional(),
	dropOff: Xa.optional(),
	label: w.union([Eo, Do]).optional(),
	multicollo: w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier for a multicollo shipment group." }),
		totalPackages: w.int().gte(2).lte(20).register(w.globalRegistry, { description: "The total number of individual packages included within this specific multicollo shipment group." })
	}).register(w.globalRegistry, { description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group." }).optional(),
	options: lo.optional(),
	pickup: jo.optional(),
	price: Za.optional(),
	sender: w.object({
		address: Va,
		contact: mo
	}).register(w.globalRegistry, { description: "The sender of the shipment." }).optional()
}).register(w.globalRegistry, { description: "The shipment properties of a package." }), Po = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a line of an order." }),
	product: w.object({
		name: w.string().register(w.globalRegistry, { description: "The name of the product." }),
		ean: w.string().register(w.globalRegistry, { description: "The EAN of the product." }).optional(),
		sku: w.string().register(w.globalRegistry, { description: "The SKU of the product." }).optional(),
		id: w.uuid().register(w.globalRegistry, { description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined." }).optional()
	}).register(w.globalRegistry, { description: "The product of an order line." }),
	quantity: w.int().gte(1).register(w.globalRegistry, { description: "The quantity of the product of the order line." }),
	externalReference: To.optional(),
	price: Za.and(w.unknown().register(w.globalRegistry, { description: "The price of the product of the order line." })).optional()
}).register(w.globalRegistry, { description: "The line of the order" }), Fo = w.object({
	customsDeclaration: Wa.optional(),
	options: co.optional(),
	physicalProperties: io.optional()
}), Io = w.object({
	lines: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: w.int().gte(1).register(w.globalRegistry, { description: "The quantity of the product of the order line." })
	})).optional(),
	physicalProperties: io.optional()
}), Lo = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the package." }),
	status: to,
	physicalProperties: ro.optional(),
	lines: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: w.int().gte(1).register(w.globalRegistry, { description: "The quantity that the package contains" })
	})).register(w.globalRegistry, { description: "The order lines related to the package." }).optional(),
	shipment: No.optional()
}), Ro = w.object({
	customsDeclaration: Wa.optional(),
	options: co.optional(),
	physicalProperties: io.optional(),
	shipment: w.object({
		carrier: Ua,
		direction: oo,
		disableAutoDetectPickup: w.boolean().register(w.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
		packageType: eo,
		recipient: w.object({
			address: Va,
			contact: _o
		}).register(w.globalRegistry, { description: "The recipient of the shipment." }),
		customContractId: w.string().register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
		delivery: Ya.optional(),
		options: so.optional(),
		pickup: jo.optional(),
		sender: w.object({
			address: Va,
			contact: mo
		}).register(w.globalRegistry, { description: "The sender of the shipment." }).optional(),
		saveRecipientAddress: w.boolean().register(w.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
	})
}), zo = w.object({
	carrier: Ha.optional(),
	customContractId: w.string().register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: Ga.optional(),
	delivery: Ya.optional(),
	direction: oo.optional(),
	disableAutoDetectPickup: w.boolean().register(w.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: w.int().gte(1).lte(20).optional(),
	options: lo.optional(),
	packageType: eo.optional(),
	pickup: jo.optional(),
	recipient: w.object({
		address: Va.optional(),
		contact: _o.optional()
	}).register(w.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(w.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), Bo = w.union([w.object({
	shopId: w.string().register(w.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: Ka.optional(),
	package: Ro
}), w.object({
	shopId: w.string().register(w.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: Ka.optional(),
	multicollo: w.object({
		packages: w.array(Fo),
		shipment: w.object({
			carrier: Ua,
			direction: oo,
			disableAutoDetectPickup: w.boolean().register(w.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
			packageType: eo,
			recipient: w.object({
				address: Va,
				contact: _o
			}).register(w.globalRegistry, { description: "The recipient of the shipment." }),
			customContractId: w.string().register(w.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
			delivery: Ya.optional(),
			options: so.optional(),
			pickup: jo.optional(),
			sender: w.object({
				address: Va,
				contact: mo
			}).register(w.globalRegistry, { description: "The sender of the shipment." }).optional(),
			saveRecipientAddress: w.boolean().register(w.globalRegistry, { description: "When set to true, the recipient address is saved to the user's address book." }).optional()
		})
	})
})]), Vo = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
	packages: w.array(Io)
}), Ho = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the package." }),
	customsDeclaration: Wa.optional(),
	options: co.optional(),
	physicalProperties: io.optional()
}), Uo = w.union([w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: Mo,
	packages: w.array(Ho)
}), w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: Mo,
	multicollo: w.array(Ho)
})]), Wo = w.object({
	id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
	orderedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	price: Za,
	shopId: w.string().register(w.globalRegistry, { description: "The unique identifier of the shop." }),
	shortId: w.string().register(w.globalRegistry, { description: "The short ID of the order." }),
	status: $a,
	assignedUserId: w.string().register(w.globalRegistry, { description: "The user ID assigned to the order." }).optional(),
	billingDetails: vo.optional(),
	customerReference: Ka.optional(),
	externalReferences: wo.and(w.unknown().register(w.globalRegistry, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." })).optional(),
	lines: w.array(Po).register(w.globalRegistry, { description: "The lines of the order" }).optional(),
	notes: w.array(Ao).register(w.globalRegistry, { description: "The notes of the order." }).optional(),
	packages: w.array(Lo).register(w.globalRegistry, { description: "The packages of the order." }).optional(),
	rules: w.object({ setShippingPreferences: w.object({
		path: w.array(w.union([w.object({
			id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the rule." }),
			name: w.string().register(w.globalRegistry, { description: "The name of the rule." })
		}), w.object({
			id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the rule group." }),
			condition: w.union([w.object({ countryCode: Ba }), w.object({ geoAreaCode: Qa })])
		})])).register(w.globalRegistry, { description: "The path of the rule." }),
		appliedAt: w.union([w.string(), w.iso.datetime().register(w.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
		result: w.union([w.enum(["PRESERVE", "REPLACE"]), w.string()]).register(w.globalRegistry, { description: "How the rule was applied." })
	}).optional() }).register(w.globalRegistry, { description: "The rules that have been applied to the order." }).optional(),
	shipping: zo.optional()
}), Go = w.object({
	type: w.union([w.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), w.string()]).register(w.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: w.union([
		w.literal(400),
		w.literal(401),
		w.literal(404),
		w.literal(415),
		w.literal(500)
	]).register(w.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: w.string().register(w.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: w.string().register(w.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: w.url().register(w.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: w.unknown().register(w.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), Ko = Go.and(w.object({
	type: w.union([w.enum(["urn:problem:client"]), w.string()]).register(w.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: w.literal(400).register(w.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: w.array(w.object({
		detail: w.string(),
		pointer: w.string().register(w.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(w.globalRegistry, { description: "Detailed information regarding the violations." })
})), qo = Go.and(w.object({
	type: w.union([w.enum(["urn:problem:server"]), w.string()]).register(w.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: w.literal(500).register(w.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
}));
Go.and(w.object({
	type: w.union([w.enum(["urn:problem:invalid-request-syntax"]), w.string()]).register(w.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: w.literal(400).register(w.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: w.array(w.object({
		detail: w.string(),
		pointer: w.string().register(w.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(w.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		text: w.string().register(w.globalRegistry, { description: "The text of the note." }),
		locale: w.union([w.string().register(w.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), w.string().register(w.globalRegistry, { description: "ISO 639-1 language code." })]).optional()
	})).register(w.globalRegistry, { description: "Body for adding an order note." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({
		status: w.literal(200),
		ids: w.array(w.uuid()).min(1)
	}),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		userId: w.string().register(w.globalRegistry, { description: "User to assign to these orders." })
	})).register(w.globalRegistry, { description: "Body for assigning orders to an user." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({ id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }) })).register(w.globalRegistry, { description: "Body for canceling orders." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(Bo).register(w.globalRegistry, { description: "Body for creating an order with shippable packages." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({
		status: w.literal(201),
		id: w.uuid()
	}),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per item." }), w.object({
	body: w.array(Vo).register(w.globalRegistry, { description: "Body adding packages to orders" }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({
		status: w.literal(200),
		ids: w.array(w.uuid()).min(1)
	}),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(Uo).register(w.globalRegistry, { description: "Body preparing packages for shipment" }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		packageIds: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(25)
	})).register(w.globalRegistry, { description: "Body for unpreparing packages for shipment" }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		noteId: w.uuid().register(w.globalRegistry, { description: "The unique identifier of a note of an order." }),
		text: w.string().register(w.globalRegistry, { description: "The text of the note." })
	})).register(w.globalRegistry, { description: "Body for editing an order note." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({ id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }) })).register(w.globalRegistry, { description: "Body for importing an order." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.never().optional(),
	path: w.never().optional(),
	query: w.object({
		aggregations: w.array($a).register(w.globalRegistry, { description: "The statuses to retrieve counts for." }).optional(),
		filter: w.object({
			assignedUserId: w.array(w.string().register(w.globalRegistry, { description: "The unique identifier of the user." })).optional(),
			carrier: w.array(Ha).optional(),
			hasAssignedUser: w.union([w.enum(["true", "false"]), w.string()]).register(w.globalRegistry, { description: "Whether the order has an assigned user or not." }).optional(),
			hasNotes: w.union([w.enum(["true", "false"]), w.string()]).register(w.globalRegistry, { description: "Whether the order has notes or not." }).optional(),
			orderId: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." })).optional(),
			orderedAt: w.array(w.string().register(w.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).optional(),
			packageStatusGroup: w.array(w.union([w.enum([
				"PICKING_AND_PACKING",
				"DISPATCHING",
				"UNTRACEABLE",
				"SORTING",
				"DISTRIBUTING",
				"DELIVERED"
			]), w.string()])).optional(),
			packageType: w.array(eo).optional(),
			price: w.array(w.string().register(w.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a number with a maximum precision of 2." })).optional(),
			regionCode: w.array(ao).optional(),
			salesChannelId: w.array(w.string().register(w.globalRegistry, { description: "The unique identifier of the sales channel." })).optional(),
			shipmentDelayed: w.union([w.enum(["true", "false"]), w.string()]).register(w.globalRegistry, { description: "Whether the order has a package with a delayed shipment or not." }).optional(),
			shipmentDirection: w.array(oo).optional(),
			shipmentPaymentStatus: w.array(no).optional(),
			shopId: w.array(w.string().register(w.globalRegistry, { description: "The unique identifier of the shop." })).optional(),
			status: w.array($a).optional()
		}).optional(),
		limit: w.int().gte(0).lte(50).nullish().default(50),
		pageToken: w.string().register(w.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		query: w.string().register(w.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: w.object({
			customerReference: uo.optional(),
			orderedAt: uo.optional(),
			price: uo.optional(),
			sourceId: uo.optional()
		}).register(w.globalRegistry, { description: "When no `query` is provided the default sort is by `orderedAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
}), w.object({
	results: w.array(Wo).register(w.globalRegistry, { description: "The list of orders." }),
	total: w.object({
		relation: w.union([w.enum(["eq", "gte"]), w.string()]).register(w.globalRegistry, { description: "The relation of the total number of orders." }),
		value: w.int().gte(0).register(w.globalRegistry, { description: "The total number of orders." })
	}),
	aggregations: w.object({ status: w.array(w.object({
		key: $a,
		count: w.int().gte(0)
	})).optional() }).register(w.globalRegistry, { description: "Count of orders per status, scoped to the active search query and all active filters except the status filter." }).optional(),
	nextPageToken: w.string().register(w.globalRegistry, { description: "The next page token to retrieve the next page of orders." }).optional()
}).register(w.globalRegistry, { description: "The found orders." }), w.object({
	body: w.never().optional(),
	path: w.never().optional(),
	query: w.object({
		shipmentLabelsLayout: w.union([w.enum(["INTERLEAVED"]), w.string()]).register(w.globalRegistry, { description: "How shipment labels are included alongside the packing slips in the resulting PDF. `INTERLEAVED` outputs each packing slip immediately followed by its shipment label. When the parameter is omitted, no shipment labels are included and only packing slips are rendered." }).optional(),
		orderId: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." })).register(w.globalRegistry, { description: "The orderId of the order to include in the packing slips. A maximum of 50 orders can be included in the request. When packageId is provided, exactly one orderId is allowed." }),
		packageId: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the package." })).register(w.globalRegistry, { description: "The packageId of the package to include in the packing slips. The packageIds must belong to the single orderId in the request and a maximum of 20 packageIds can be included." }).optional()
	}),
	headers: w.object({ Accept: w.union([w.enum(["application/pdf", "application/pdf+print"]), w.string()]).register(w.globalRegistry, { description: "Use `application/pdf` to download the packing slip. Use `application/pdf+print; printer-group-id=<uuid>` to send the packing slip directly to a printer group." }) })
}), w.union([w.string().register(w.globalRegistry, { description: "Packing slips PDF. Returned when `Accept: application/pdf`." }), w.void().register(w.globalRegistry, { description: "The packing slip has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), w.object({
	body: w.never().optional(),
	path: w.never().optional(),
	query: w.object({ orderId: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." })).register(w.globalRegistry, { description: "The orderId of the order to include in the picklist. A maximum of 50 orders can be included in the request." }) }),
	headers: w.object({ Accept: w.union([w.enum(["application/pdf", "application/pdf+print"]), w.string()]).register(w.globalRegistry, { description: "Use `application/pdf` to download the picklist. Use `application/pdf+print; printer-group-id=<uuid>` to send the picklist directly to a printer group." }) })
}), w.union([w.string().register(w.globalRegistry, { description: "Picklist PDF. Returned when `Accept: application/pdf`." }), w.void().register(w.globalRegistry, { description: "The picklist has been sent to the printer. Returned when `Accept: application/pdf+print; printer-group-id=<uuid>`." })]), w.object({
	body: w.array(w.object({
		id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }),
		noteIds: w.array(w.uuid().register(w.globalRegistry, { description: "The unique identifier of a note of an order." })).min(1).max(150).register(w.globalRegistry, { description: "Note IDs to remove from the order." })
	})).register(w.globalRegistry, { description: "Body for removing order notes." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({ id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }) })).register(w.globalRegistry, { description: "Body for unassigning orders from an user." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." }), w.object({
	body: w.array(w.object({ id: w.uuid().register(w.globalRegistry, { description: "The unique identifier of the order." }) })).register(w.globalRegistry, { description: "Body for evaluating order rules." }),
	path: w.never().optional(),
	query: w.never().optional()
}), w.array(w.union([
	w.object({ status: w.literal(200) }),
	Ko,
	qo
])).register(w.globalRegistry, { description: "The result per ID." });
//#endregion
//#region ../../services/order-service/dist/shippablePackages-Bu2bHzjL.js
var Jo = {
	type: "object",
	properties: {
		city: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The city of the address."
		},
		countryCode: { $ref: "#/components/schemas/CountryCode" },
		street: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The street of the address."
		},
		additionalInformation: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "Additional information about the address."
		},
		boxNumber: {
			type: "string",
			minLength: 1,
			maxLength: 20,
			description: "The box number of the address, only applicable for specific country codes."
		},
		houseNumber: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number of the address."
		},
		houseNumberSuffix: {
			type: "string",
			minLength: 1,
			maxLength: 25,
			description: "The house number suffix of the address."
		},
		postalCode: {
			type: "string",
			minLength: 1,
			maxLength: 15,
			description: "The postal code of the address."
		},
		region: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The region of the address."
		},
		state: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "The state of the address."
		}
	},
	required: [
		"city",
		"countryCode",
		"street"
	],
	description: "A physical address."
}, Yo = {
	type: "object",
	properties: {
		groups: {
			type: "array",
			items: {
				type: "object",
				properties: {
					description: {
						type: "string",
						minLength: 1,
						maxLength: 50,
						description: "A clear and detailed description of the goods within this group."
					},
					hsCode: {
						type: "string",
						minLength: 6,
						maxLength: 12,
						description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products."
					},
					numberOfItems: {
						type: "integer",
						minimum: 1,
						maximum: 99999,
						description: "The total quantity of individual items within this specific group."
					},
					totalValue: {
						type: "object",
						properties: {
							currency: {
								type: "string",
								minLength: 3,
								maxLength: 3,
								description: "ISO 4217 three-letter currency code."
							},
							micros: {
								type: "integer",
								minimum: 0,
								maximum: 9007199254740991,
								description: "The amount of money in integer micros."
							}
						},
						required: ["currency", "micros"],
						description: "The total declared value of all items within this group."
					},
					totalWeight: {
						type: "object",
						properties: {
							unit: {
								type: "string",
								enum: ["g", "kg"],
								description: "The unit of weight."
							},
							value: {
								type: "integer",
								minimum: 1,
								maximum: 999999999
							}
						},
						required: ["unit", "value"],
						description: "The total weight of all items within this specific group."
					},
					countryCodeOfOrigin: { allOf: [{ $ref: "#/components/schemas/CountryCode" }, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }] }
				},
				required: [
					"description",
					"hsCode",
					"numberOfItems",
					"totalValue",
					"totalWeight"
				],
				description: "A consolidated group of items within a customs declaration that share common customs attributes."
			},
			minItems: 1,
			maxItems: 100,
			description: "The list of item groups."
		},
		purpose: {
			type: "string",
			enum: [
				"COMMERCIAL_GOODS",
				"COMMERCIAL_SAMPLE",
				"DOCUMENTS",
				"GIFT",
				"RETURNED_GOODS"
			],
			description: "The primary reason or purpose for the international shipment."
		},
		totalWeight: {
			type: "object",
			properties: {
				unit: {
					type: "string",
					enum: ["g", "kg"],
					description: "The unit of weight."
				},
				value: {
					type: "integer",
					minimum: 1,
					maximum: 999999999
				}
			},
			required: ["unit", "value"],
			description: "The total weight of all items declared within this customs declaration."
		},
		invoiceNumber: {
			type: "string",
			minLength: 1,
			maxLength: 150,
			description: "The identifying number of the commercial invoice associated with this shipment."
		}
	},
	required: [
		"groups",
		"purpose",
		"totalWeight"
	],
	description: "The official declaration of goods for customs clearance purposes during international shipment."
}, L = {
	BPOST: "BPOST",
	BRT: "BRT",
	CHEAP_CARGO: "CHEAP_CARGO",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DPD: "DPD",
	GLS: "GLS",
	INPOST: "INPOST",
	POSTNL: "POSTNL",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	TRUNKRS: "TRUNKRS",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	UPS_STANDARD: "UPS_STANDARD",
	VIA_TIM: "VIA_TIM",
	BOL: "BOL"
}, Xo = {
	EARLY_MORNING_DELIVERY: "EARLY_MORNING_DELIVERY",
	EVENING_DELIVERY: "EVENING_DELIVERY",
	EXPRESS_DELIVERY: "EXPRESS_DELIVERY",
	MORNING_DELIVERY: "MORNING_DELIVERY",
	PICKUP_EXPRESS_DELIVERY: "PICKUP_EXPRESS_DELIVERY",
	PICKUP_DELIVERY: "PICKUP_DELIVERY",
	SAME_DAY_DELIVERY: "SAME_DAY_DELIVERY",
	STANDARD_DELIVERY: "STANDARD_DELIVERY"
}, Zo = {
	CANCELED: "CANCELED",
	COMPLETED: "COMPLETED",
	DISCOVERED: "DISCOVERED",
	IMPORT_REQUESTED: "IMPORT_REQUESTED",
	OPEN: "OPEN",
	PROCESSING: "PROCESSING",
	RETURNING: "RETURNING"
}, Qo = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
}, $o = {
	OUTBOUND: "OUTBOUND",
	INBOUND: "INBOUND"
};
// @__NO_SIDE_EFFECTS__
function es(e) {
	let t = /* @__PURE__ */ Object.create(null);
	for (let n of e.split(",")) t[n] = 1;
	return (e) => e in t;
}
var ts = process.env.NODE_ENV === "production" ? {} : Object.freeze({});
process.env.NODE_ENV === "production" || Object.freeze([]);
var ns = () => {}, rs = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && (e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), is = (e) => e.startsWith("onUpdate:"), as = Object.assign, os = (e, t) => {
	let n = e.indexOf(t);
	n > -1 && e.splice(n, 1);
}, ss = Object.prototype.hasOwnProperty, cs = (e, t) => ss.call(e, t), ls = Array.isArray, us = (e) => vs(e) === "[object Map]", ds = (e) => vs(e) === "[object Set]", fs = (e) => typeof e == "function", ps = (e) => typeof e == "string", ms = (e) => typeof e == "symbol", hs = (e) => typeof e == "object" && !!e, gs = (e) => (hs(e) || fs(e)) && fs(e.then) && fs(e.catch), _s = Object.prototype.toString, vs = (e) => _s.call(e), ys = (e) => vs(e).slice(8, -1), bs = (e) => vs(e) === "[object Object]", xs = (e) => ps(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Ss = ((e) => {
	let t = /* @__PURE__ */ Object.create(null);
	return ((n) => t[n] || (t[n] = e(n)));
})((e) => e.charAt(0).toUpperCase() + e.slice(1)), Cs = (e, t) => !Object.is(e, t), ws = (e, t, n, r = !1) => {
	Object.defineProperty(e, t, {
		configurable: !0,
		enumerable: !1,
		writable: r,
		value: n
	});
}, Ts, Es = () => Ts ||= typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
function Ds(e) {
	if (ls(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) {
			let r = e[n], i = ps(r) ? js(r) : Ds(r);
			if (i) for (let e in i) t[e] = i[e];
		}
		return t;
	} else if (ps(e) || hs(e)) return e;
}
var Os = /;(?![^(]*\))/g, ks = /:([^]+)/, As = /\/\*[^]*?\*\//g;
function js(e) {
	let t = {};
	return e.replace(As, "").split(Os).forEach((e) => {
		if (e) {
			let n = e.split(ks);
			n.length > 1 && (t[n[0].trim()] = n[1].trim());
		}
	}), t;
}
function Ms(e) {
	let t = "";
	if (ps(e)) t = e;
	else if (ls(e)) for (let n = 0; n < e.length; n++) {
		let r = Ms(e[n]);
		r && (t += r + " ");
	}
	else if (hs(e)) for (let n in e) e[n] && (t += n + " ");
	return t.trim();
}
function Ns(e, ...t) {
	console.warn(`[Vue warn] ${e}`, ...t);
}
var Ps;
function Fs() {
	return Ps;
}
var Is, Ls = /* @__PURE__ */ new WeakSet(), Rs = class {
	constructor(e) {
		this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Ps && (Ps.active ? Ps.effects.push(this) : this.flags &= -2);
	}
	pause() {
		this.flags |= 64;
	}
	resume() {
		this.flags & 64 && (this.flags &= -65, Ls.has(this) && (Ls.delete(this), this.trigger()));
	}
	notify() {
		this.flags & 2 && !(this.flags & 32) || this.flags & 8 || Hs(this);
	}
	run() {
		if (!(this.flags & 1)) return this.fn();
		this.flags |= 2, tc(this), Gs(this);
		let e = Is, t = Zs;
		Is = this, Zs = !0;
		try {
			return this.fn();
		} finally {
			process.env.NODE_ENV !== "production" && Is !== this && Ns("Active effect was not restored correctly - this is likely a Vue internal bug."), Ks(this), Is = e, Zs = t, this.flags &= -3;
		}
	}
	stop() {
		if (this.flags & 1) {
			for (let e = this.deps; e; e = e.nextDep) Ys(e);
			this.deps = this.depsTail = void 0, tc(this), this.onStop && this.onStop(), this.flags &= -2;
		}
	}
	trigger() {
		this.flags & 64 ? Ls.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
	}
	runIfDirty() {
		qs(this) && this.run();
	}
	get dirty() {
		return qs(this);
	}
}, zs = 0, Bs, Vs;
function Hs(e, t = !1) {
	if (e.flags |= 8, t) {
		e.next = Vs, Vs = e;
		return;
	}
	e.next = Bs, Bs = e;
}
function Us() {
	zs++;
}
function Ws() {
	if (--zs > 0) return;
	if (Vs) {
		let e = Vs;
		for (Vs = void 0; e;) {
			let t = e.next;
			e.next = void 0, e.flags &= -9, e = t;
		}
	}
	let e;
	for (; Bs;) {
		let t = Bs;
		for (Bs = void 0; t;) {
			let n = t.next;
			if (t.next = void 0, t.flags &= -9, t.flags & 1) try {
				t.trigger();
			} catch (t) {
				e ||= t;
			}
			t = n;
		}
	}
	if (e) throw e;
}
function Gs(e) {
	for (let t = e.deps; t; t = t.nextDep) t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function Ks(e) {
	let t, n = e.depsTail, r = n;
	for (; r;) {
		let e = r.prevDep;
		r.version === -1 ? (r === n && (n = e), Ys(r), Xs(r)) : t = r, r.dep.activeLink = r.prevActiveLink, r.prevActiveLink = void 0, r = e;
	}
	e.deps = t, e.depsTail = n;
}
function qs(e) {
	for (let t = e.deps; t; t = t.nextDep) if (t.dep.version !== t.version || t.dep.computed && (Js(t.dep.computed) || t.dep.version !== t.version)) return !0;
	return !!e._dirty;
}
function Js(e) {
	if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === nc) || (e.globalVersion = nc, !e.isSSR && e.flags & 128 && (!e.deps && !e._dirty || !qs(e)))) return;
	e.flags |= 2;
	let t = e.dep, n = Is, r = Zs;
	Is = e, Zs = !0;
	try {
		Gs(e);
		let n = e.fn(e._value);
		(t.version === 0 || Cs(n, e._value)) && (e.flags |= 128, e._value = n, t.version++);
	} catch (e) {
		throw t.version++, e;
	} finally {
		Is = n, Zs = r, Ks(e), e.flags &= -3;
	}
}
function Ys(e, t = !1) {
	let { dep: n, prevSub: r, nextSub: i } = e;
	if (r && (r.nextSub = i, e.prevSub = void 0), i && (i.prevSub = r, e.nextSub = void 0), process.env.NODE_ENV !== "production" && n.subsHead === e && (n.subsHead = i), n.subs === e && (n.subs = r, !r && n.computed)) {
		n.computed.flags &= -5;
		for (let e = n.computed.deps; e; e = e.nextDep) Ys(e, !0);
	}
	!t && !--n.sc && n.map && n.map.delete(n.key);
}
function Xs(e) {
	let { prevDep: t, nextDep: n } = e;
	t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
var Zs = !0, Qs = [];
function $s() {
	Qs.push(Zs), Zs = !1;
}
function ec() {
	let e = Qs.pop();
	Zs = e === void 0 || e;
}
function tc(e) {
	let { cleanup: t } = e;
	if (e.cleanup = void 0, t) {
		let e = Is;
		Is = void 0;
		try {
			t();
		} finally {
			Is = e;
		}
	}
}
var nc = 0, rc = class {
	constructor(e, t) {
		this.sub = e, this.dep = t, this.version = t.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
	}
}, ic = class {
	constructor(e) {
		this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
	}
	track(e) {
		if (!Is || !Zs || Is === this.computed) return;
		let t = this.activeLink;
		if (t === void 0 || t.sub !== Is) t = this.activeLink = new rc(Is, this), Is.deps ? (t.prevDep = Is.depsTail, Is.depsTail.nextDep = t, Is.depsTail = t) : Is.deps = Is.depsTail = t, ac(t);
		else if (t.version === -1 && (t.version = this.version, t.nextDep)) {
			let e = t.nextDep;
			e.prevDep = t.prevDep, t.prevDep && (t.prevDep.nextDep = e), t.prevDep = Is.depsTail, t.nextDep = void 0, Is.depsTail.nextDep = t, Is.depsTail = t, Is.deps === t && (Is.deps = e);
		}
		return process.env.NODE_ENV !== "production" && Is.onTrack && Is.onTrack(as({ effect: Is }, e)), t;
	}
	trigger(e) {
		this.version++, nc++, this.notify(e);
	}
	notify(e) {
		Us();
		try {
			if (process.env.NODE_ENV !== "production") for (let t = this.subsHead; t; t = t.nextSub) t.sub.onTrigger && !(t.sub.flags & 8) && t.sub.onTrigger(as({ effect: t.sub }, e));
			for (let e = this.subs; e; e = e.prevSub) e.sub.notify() && e.sub.dep.notify();
		} finally {
			Ws();
		}
	}
};
function ac(e) {
	if (e.dep.sc++, e.sub.flags & 4) {
		let t = e.dep.computed;
		if (t && !e.dep.subs) {
			t.flags |= 20;
			for (let e = t.deps; e; e = e.nextDep) ac(e);
		}
		let n = e.dep.subs;
		n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
	}
}
var oc = /* @__PURE__ */ new WeakMap(), sc = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Object iterate"), cc = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Map keys iterate"), lc = /* @__PURE__ */ Symbol(process.env.NODE_ENV === "production" ? "" : "Array iterate");
function uc(e, t, n) {
	if (Zs && Is) {
		let r = oc.get(e);
		r || oc.set(e, r = /* @__PURE__ */ new Map());
		let i = r.get(n);
		i || (r.set(n, i = new ic()), i.map = r, i.key = n), process.env.NODE_ENV === "production" ? i.track() : i.track({
			target: e,
			type: t,
			key: n
		});
	}
}
function dc(e, t, n, r, i, a) {
	let o = oc.get(e);
	if (!o) {
		nc++;
		return;
	}
	let s = (o) => {
		o && (process.env.NODE_ENV === "production" ? o.trigger() : o.trigger({
			target: e,
			type: t,
			key: n,
			newValue: r,
			oldValue: i,
			oldTarget: a
		}));
	};
	if (Us(), t === "clear") o.forEach(s);
	else {
		let i = ls(e), a = i && xs(n);
		if (i && n === "length") {
			let e = Number(r);
			o.forEach((t, n) => {
				(n === "length" || n === lc || !ms(n) && n >= e) && s(t);
			});
		} else switch ((n !== void 0 || o.has(void 0)) && s(o.get(n)), a && s(o.get(lc)), t) {
			case "add":
				i ? a && s(o.get("length")) : (s(o.get(sc)), us(e) && s(o.get(cc)));
				break;
			case "delete":
				i || (s(o.get(sc)), us(e) && s(o.get(cc)));
				break;
			case "set":
				us(e) && s(o.get(sc));
				break;
		}
	}
	Ws();
}
function fc(e) {
	let t = /* @__PURE__ */ el(e);
	return t === e ? t : (uc(t, "iterate", lc), /* @__PURE__ */ Qc(e) ? t : t.map(nl));
}
function pc(e) {
	return uc(e = /* @__PURE__ */ el(e), "iterate", lc), e;
}
function mc(e, t) {
	return /* @__PURE__ */ Zc(e) ? rl(/* @__PURE__ */ Xc(e) ? nl(t) : t) : nl(t);
}
var hc = {
	__proto__: null,
	[Symbol.iterator]() {
		return gc(this, Symbol.iterator, (e) => mc(this, e));
	},
	concat(...e) {
		return fc(this).concat(...e.map((e) => ls(e) ? fc(e) : e));
	},
	entries() {
		return gc(this, "entries", (e) => (e[1] = mc(this, e[1]), e));
	},
	every(e, t) {
		return vc(this, "every", e, t, void 0, arguments);
	},
	filter(e, t) {
		return vc(this, "filter", e, t, (e) => e.map((e) => mc(this, e)), arguments);
	},
	find(e, t) {
		return vc(this, "find", e, t, (e) => mc(this, e), arguments);
	},
	findIndex(e, t) {
		return vc(this, "findIndex", e, t, void 0, arguments);
	},
	findLast(e, t) {
		return vc(this, "findLast", e, t, (e) => mc(this, e), arguments);
	},
	findLastIndex(e, t) {
		return vc(this, "findLastIndex", e, t, void 0, arguments);
	},
	forEach(e, t) {
		return vc(this, "forEach", e, t, void 0, arguments);
	},
	includes(...e) {
		return bc(this, "includes", e);
	},
	indexOf(...e) {
		return bc(this, "indexOf", e);
	},
	join(e) {
		return fc(this).join(e);
	},
	lastIndexOf(...e) {
		return bc(this, "lastIndexOf", e);
	},
	map(e, t) {
		return vc(this, "map", e, t, void 0, arguments);
	},
	pop() {
		return xc(this, "pop");
	},
	push(...e) {
		return xc(this, "push", e);
	},
	reduce(e, ...t) {
		return yc(this, "reduce", e, t);
	},
	reduceRight(e, ...t) {
		return yc(this, "reduceRight", e, t);
	},
	shift() {
		return xc(this, "shift");
	},
	some(e, t) {
		return vc(this, "some", e, t, void 0, arguments);
	},
	splice(...e) {
		return xc(this, "splice", e);
	},
	toReversed() {
		return fc(this).toReversed();
	},
	toSorted(e) {
		return fc(this).toSorted(e);
	},
	toSpliced(...e) {
		return fc(this).toSpliced(...e);
	},
	unshift(...e) {
		return xc(this, "unshift", e);
	},
	values() {
		return gc(this, "values", (e) => mc(this, e));
	}
};
function gc(e, t, n) {
	let r = pc(e), i = r[t]();
	return r !== e && !/* @__PURE__ */ Qc(e) && (i._next = i.next, i.next = () => {
		let e = i._next();
		return e.done || (e.value = n(e.value)), e;
	}), i;
}
var _c = Array.prototype;
function vc(e, t, n, r, i, a) {
	let o = pc(e), s = o !== e && !/* @__PURE__ */ Qc(e), c = o[t];
	if (c !== _c[t]) {
		let t = c.apply(e, a);
		return s ? nl(t) : t;
	}
	let l = n;
	o !== e && (s ? l = function(t, r) {
		return n.call(this, mc(e, t), r, e);
	} : n.length > 2 && (l = function(t, r) {
		return n.call(this, t, r, e);
	}));
	let u = c.call(o, l, r);
	return s && i ? i(u) : u;
}
function yc(e, t, n, r) {
	let i = pc(e), a = i !== e && !/* @__PURE__ */ Qc(e), o = n, s = !1;
	i !== e && (a ? (s = r.length === 0, o = function(t, r, i) {
		return s && (s = !1, t = mc(e, t)), n.call(this, t, mc(e, r), i, e);
	}) : n.length > 3 && (o = function(t, r, i) {
		return n.call(this, t, r, i, e);
	}));
	let c = i[t](o, ...r);
	return s ? mc(e, c) : c;
}
function bc(e, t, n) {
	let r = /* @__PURE__ */ el(e);
	uc(r, "iterate", lc);
	let i = r[t](...n);
	return (i === -1 || i === !1) && /* @__PURE__ */ $c(n[0]) ? (n[0] = /* @__PURE__ */ el(n[0]), r[t](...n)) : i;
}
function xc(e, t, n = []) {
	$s(), Us();
	let r = (/* @__PURE__ */ el(e))[t].apply(e, n);
	return Ws(), ec(), r;
}
var Sc = /* @__PURE__ */ es("__proto__,__v_isRef,__isVue"), Cc = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(ms));
function wc(e) {
	ms(e) || (e = String(e));
	let t = /* @__PURE__ */ el(this);
	return uc(t, "has", e), t.hasOwnProperty(e);
}
var Tc = class {
	constructor(e = !1, t = !1) {
		this._isReadonly = e, this._isShallow = t;
	}
	get(e, t, n) {
		if (t === "__v_skip") return e.__v_skip;
		let r = this._isReadonly, i = this._isShallow;
		if (t === "__v_isReactive") return !r;
		if (t === "__v_isReadonly") return r;
		if (t === "__v_isShallow") return i;
		if (t === "__v_raw") return n === (r ? i ? Wc : Uc : i ? Hc : Vc).get(e) || Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
		let a = ls(e);
		if (!r) {
			let e;
			if (a && (e = hc[t])) return e;
			if (t === "hasOwnProperty") return wc;
		}
		let o = Reflect.get(e, t, /* @__PURE__ */ il(e) ? e : n);
		if ((ms(t) ? Cc.has(t) : Sc(t)) || (r || uc(e, "get", t), i)) return o;
		if (/* @__PURE__ */ il(o)) {
			let e = a && xs(t) ? o : o.value;
			return r && hs(e) ? /* @__PURE__ */ qc(e) : e;
		}
		return hs(o) ? r ? /* @__PURE__ */ qc(o) : /* @__PURE__ */ Kc(o) : o;
	}
}, Ec = class extends Tc {
	constructor(e = !1) {
		super(!1, e);
	}
	set(e, t, n, r) {
		let i = e[t], a = ls(e) && xs(t);
		if (!this._isShallow) {
			let r = /* @__PURE__ */ Zc(i);
			if (!/* @__PURE__ */ Qc(n) && !/* @__PURE__ */ Zc(n) && (i = /* @__PURE__ */ el(i), n = /* @__PURE__ */ el(n)), !a && /* @__PURE__ */ il(i) && !/* @__PURE__ */ il(n)) return r ? (process.env.NODE_ENV !== "production" && Ns(`Set operation on key "${String(t)}" failed: target is readonly.`, e[t]), !0) : (i.value = n, !0);
		}
		let o = a ? Number(t) < e.length : cs(e, t), s = Reflect.set(e, t, n, /* @__PURE__ */ il(e) ? e : r);
		return e === /* @__PURE__ */ el(r) && s && (o ? Cs(n, i) && dc(e, "set", t, n, i) : dc(e, "add", t, n)), s;
	}
	deleteProperty(e, t) {
		let n = cs(e, t), r = e[t], i = Reflect.deleteProperty(e, t);
		return i && n && dc(e, "delete", t, void 0, r), i;
	}
	has(e, t) {
		let n = Reflect.has(e, t);
		return (!ms(t) || !Cc.has(t)) && uc(e, "has", t), n;
	}
	ownKeys(e) {
		return uc(e, "iterate", ls(e) ? "length" : sc), Reflect.ownKeys(e);
	}
}, Dc = class extends Tc {
	constructor(e = !1) {
		super(!0, e);
	}
	set(e, t) {
		return process.env.NODE_ENV !== "production" && Ns(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
	deleteProperty(e, t) {
		return process.env.NODE_ENV !== "production" && Ns(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0;
	}
}, Oc = /* @__PURE__ */ new Ec(), kc = /* @__PURE__ */ new Dc(), Ac = /* @__PURE__ */ new Dc(!0), jc = (e) => e, Mc = (e) => Reflect.getPrototypeOf(e);
function Nc(e, t, n) {
	return function(...r) {
		let i = this.__v_raw, a = /* @__PURE__ */ el(i), o = us(a), s = e === "entries" || e === Symbol.iterator && o, c = e === "keys" && o, l = i[e](...r), u = n ? jc : t ? rl : nl;
		return !t && uc(a, "iterate", c ? cc : sc), as(Object.create(l), { next() {
			let { value: e, done: t } = l.next();
			return t ? {
				value: e,
				done: t
			} : {
				value: s ? [u(e[0]), u(e[1])] : u(e),
				done: t
			};
		} });
	};
}
function Pc(e) {
	return function(...t) {
		if (process.env.NODE_ENV !== "production") {
			let n = t[0] ? `on key "${t[0]}" ` : "";
			Ns(`${Ss(e)} operation ${n}failed: target is readonly.`, /* @__PURE__ */ el(this));
		}
		return e === "delete" ? !1 : e === "clear" ? void 0 : this;
	};
}
function Fc(e, t) {
	let n = {
		get(n) {
			let r = this.__v_raw, i = /* @__PURE__ */ el(r), a = /* @__PURE__ */ el(n);
			e || (Cs(n, a) && uc(i, "get", n), uc(i, "get", a));
			let { has: o } = Mc(i), s = t ? jc : e ? rl : nl;
			if (o.call(i, n)) return s(r.get(n));
			if (o.call(i, a)) return s(r.get(a));
			r !== i && r.get(n);
		},
		get size() {
			let t = this.__v_raw;
			return !e && uc(/* @__PURE__ */ el(t), "iterate", sc), t.size;
		},
		has(t) {
			let n = this.__v_raw, r = /* @__PURE__ */ el(n), i = /* @__PURE__ */ el(t);
			return e || (Cs(t, i) && uc(r, "has", t), uc(r, "has", i)), t === i ? n.has(t) : n.has(t) || n.has(i);
		},
		forEach(n, r) {
			let i = this, a = i.__v_raw, o = /* @__PURE__ */ el(a), s = t ? jc : e ? rl : nl;
			return !e && uc(o, "iterate", sc), a.forEach((e, t) => n.call(r, s(e), s(t), i));
		}
	};
	return as(n, e ? {
		add: Pc("add"),
		set: Pc("set"),
		delete: Pc("delete"),
		clear: Pc("clear")
	} : {
		add(e) {
			let n = /* @__PURE__ */ el(this), r = Mc(n), i = /* @__PURE__ */ el(e), a = !t && !/* @__PURE__ */ Qc(e) && !/* @__PURE__ */ Zc(e) ? i : e;
			return r.has.call(n, a) || Cs(e, a) && r.has.call(n, e) || Cs(i, a) && r.has.call(n, i) || (n.add(a), dc(n, "add", a, a)), this;
		},
		set(e, n) {
			!t && !/* @__PURE__ */ Qc(n) && !/* @__PURE__ */ Zc(n) && (n = /* @__PURE__ */ el(n));
			let r = /* @__PURE__ */ el(this), { has: i, get: a } = Mc(r), o = i.call(r, e);
			o ? process.env.NODE_ENV !== "production" && Bc(r, i, e) : (e = /* @__PURE__ */ el(e), o = i.call(r, e));
			let s = a.call(r, e);
			return r.set(e, n), o ? Cs(n, s) && dc(r, "set", e, n, s) : dc(r, "add", e, n), this;
		},
		delete(e) {
			let t = /* @__PURE__ */ el(this), { has: n, get: r } = Mc(t), i = n.call(t, e);
			i ? process.env.NODE_ENV !== "production" && Bc(t, n, e) : (e = /* @__PURE__ */ el(e), i = n.call(t, e));
			let a = r ? r.call(t, e) : void 0, o = t.delete(e);
			return i && dc(t, "delete", e, void 0, a), o;
		},
		clear() {
			let e = /* @__PURE__ */ el(this), t = e.size !== 0, n = process.env.NODE_ENV === "production" ? void 0 : us(e) ? new Map(e) : new Set(e), r = e.clear();
			return t && dc(e, "clear", void 0, void 0, n), r;
		}
	}), [
		"keys",
		"values",
		"entries",
		Symbol.iterator
	].forEach((r) => {
		n[r] = Nc(r, e, t);
	}), n;
}
function Ic(e, t) {
	let n = Fc(e, t);
	return (t, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? t : Reflect.get(cs(n, r) && r in t ? n : t, r, i);
}
var Lc = { get: /* @__PURE__ */ Ic(!1, !1) }, Rc = { get: /* @__PURE__ */ Ic(!0, !1) }, zc = { get: /* @__PURE__ */ Ic(!0, !0) };
function Bc(e, t, n) {
	let r = /* @__PURE__ */ el(n);
	if (r !== n && t.call(e, r)) {
		let t = ys(e);
		Ns(`Reactive ${t} contains both the raw and reactive versions of the same object${t === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
	}
}
var Vc = /* @__PURE__ */ new WeakMap(), Hc = /* @__PURE__ */ new WeakMap(), Uc = /* @__PURE__ */ new WeakMap(), Wc = /* @__PURE__ */ new WeakMap();
function Gc(e) {
	switch (e) {
		case "Object":
		case "Array": return 1;
		case "Map":
		case "Set":
		case "WeakMap":
		case "WeakSet": return 2;
		default: return 0;
	}
}
// @__NO_SIDE_EFFECTS__
function Kc(e) {
	return /* @__PURE__ */ Zc(e) ? e : Yc(e, !1, Oc, Lc, Vc);
}
// @__NO_SIDE_EFFECTS__
function qc(e) {
	return Yc(e, !0, kc, Rc, Uc);
}
// @__NO_SIDE_EFFECTS__
function Jc(e) {
	return Yc(e, !0, Ac, zc, Wc);
}
function Yc(e, t, n, r, i) {
	if (!hs(e)) return process.env.NODE_ENV !== "production" && Ns(`value cannot be made ${t ? "readonly" : "reactive"}: ${String(e)}`), e;
	if (e.__v_raw && !(t && e.__v_isReactive) || e.__v_skip || !Object.isExtensible(e)) return e;
	let a = i.get(e);
	if (a) return a;
	let o = Gc(ys(e));
	if (o === 0) return e;
	let s = new Proxy(e, o === 2 ? r : n);
	return i.set(e, s), s;
}
// @__NO_SIDE_EFFECTS__
function Xc(e) {
	return /* @__PURE__ */ Zc(e) ? /* @__PURE__ */ Xc(e.__v_raw) : !!(e && e.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function Zc(e) {
	return !!(e && e.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function Qc(e) {
	return !!(e && e.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function $c(e) {
	return e ? !!e.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function el(e) {
	let t = e && e.__v_raw;
	return t ? /* @__PURE__ */ el(t) : e;
}
function tl(e) {
	return !cs(e, "__v_skip") && Object.isExtensible(e) && ws(e, "__v_skip", !0), e;
}
var nl = (e) => hs(e) ? /* @__PURE__ */ Kc(e) : e, rl = (e) => hs(e) ? /* @__PURE__ */ qc(e) : e;
// @__NO_SIDE_EFFECTS__
function il(e) {
	return e ? e.__v_isRef === !0 : !1;
}
function al(e) {
	return /* @__PURE__ */ il(e) ? e.value : e;
}
var ol = {
	get: (e, t, n) => t === "__v_raw" ? e : al(Reflect.get(e, t, n)),
	set: (e, t, n, r) => {
		let i = e[t];
		return /* @__PURE__ */ il(i) && !/* @__PURE__ */ il(n) ? (i.value = n, !0) : Reflect.set(e, t, n, r);
	}
};
function sl(e) {
	return /* @__PURE__ */ Xc(e) ? e : new Proxy(e, ol);
}
var cl = {}, ll = /* @__PURE__ */ new WeakMap(), ul = void 0;
function dl(e, t = !1, n = ul) {
	if (n) {
		let t = ll.get(n);
		t || ll.set(n, t = []), t.push(e);
	} else process.env.NODE_ENV !== "production" && !t && Ns("onWatcherCleanup() was called when there was no active watcher to associate with.");
}
function fl(e, t, n = ts) {
	let { immediate: r, deep: i, once: a, scheduler: o, augmentJob: s, call: c } = n, l = (e) => {
		(n.onWarn || Ns)("Invalid watch source: ", e, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
	}, u = (e) => i ? e : /* @__PURE__ */ Qc(e) || i === !1 || i === 0 ? pl(e, 1) : pl(e), d, f, p, m, h = !1, g = !1;
	if (/* @__PURE__ */ il(e) ? (f = () => e.value, h = /* @__PURE__ */ Qc(e)) : /* @__PURE__ */ Xc(e) ? (f = () => u(e), h = !0) : ls(e) ? (g = !0, h = e.some((e) => /* @__PURE__ */ Xc(e) || /* @__PURE__ */ Qc(e)), f = () => e.map((e) => {
		if (/* @__PURE__ */ il(e)) return e.value;
		if (/* @__PURE__ */ Xc(e)) return u(e);
		if (fs(e)) return c ? c(e, 2) : e();
		process.env.NODE_ENV !== "production" && l(e);
	})) : fs(e) ? f = t ? c ? () => c(e, 2) : e : () => {
		if (p) {
			$s();
			try {
				p();
			} finally {
				ec();
			}
		}
		let t = ul;
		ul = d;
		try {
			return c ? c(e, 3, [m]) : e(m);
		} finally {
			ul = t;
		}
	} : (f = ns, process.env.NODE_ENV !== "production" && l(e)), t && i) {
		let e = f, t = i === !0 ? Infinity : i;
		f = () => pl(e(), t);
	}
	let _ = Fs(), v = () => {
		d.stop(), _ && _.active && os(_.effects, d);
	};
	if (a && t) {
		let e = t;
		t = (...t) => {
			let n = e(...t);
			return v(), n;
		};
	}
	let y = g ? Array(e.length).fill(cl) : cl, b = (e) => {
		if (!(!(d.flags & 1) || !d.dirty && !e)) if (t) {
			let n = d.run();
			if (e || i || h || (g ? n.some((e, t) => Cs(e, y[t])) : Cs(n, y))) {
				p && p();
				let e = ul;
				ul = d;
				try {
					let e = [
						n,
						y === cl ? void 0 : g && y[0] === cl ? [] : y,
						m
					];
					y = n, c ? c(t, 3, e) : t(...e);
				} finally {
					ul = e;
				}
			}
		} else d.run();
	};
	return s && s(b), d = new Rs(f), d.scheduler = o ? () => o(b, !1) : b, m = (e) => dl(e, !1, d), p = d.onStop = () => {
		let e = ll.get(d);
		if (e) {
			if (c) c(e, 4);
			else for (let t of e) t();
			ll.delete(d);
		}
	}, process.env.NODE_ENV !== "production" && (d.onTrack = n.onTrack, d.onTrigger = n.onTrigger), t ? r ? b(!0) : y = d.run() : o ? o(b.bind(null, !0), !0) : d.run(), v.pause = d.pause.bind(d), v.resume = d.resume.bind(d), v.stop = v, v;
}
function pl(e, t = Infinity, n) {
	if (t <= 0 || !hs(e) || e.__v_skip || (n ||= /* @__PURE__ */ new Map(), (n.get(e) || 0) >= t)) return e;
	if (n.set(e, t), t--, /* @__PURE__ */ il(e)) pl(e.value, t, n);
	else if (ls(e)) for (let r = 0; r < e.length; r++) pl(e[r], t, n);
	else if (ds(e) || us(e)) e.forEach((e) => {
		pl(e, t, n);
	});
	else if (bs(e)) {
		for (let r in e) pl(e[r], t, n);
		for (let r of Object.getOwnPropertySymbols(e)) Object.prototype.propertyIsEnumerable.call(e, r) && pl(e[r], t, n);
	}
	return e;
}
var ml = [];
function hl(e) {
	ml.push(e);
}
function gl() {
	ml.pop();
}
var _l = !1;
function vl(e, ...t) {
	if (_l) return;
	_l = !0, $s();
	let n = ml.length ? ml[ml.length - 1].component : null, r = n && n.appContext.config.warnHandler, i = yl();
	if (r) Tl(r, n, 11, [
		e + t.map((e) => e.toString?.call(e) ?? JSON.stringify(e)).join(""),
		n && n.proxy,
		i.map(({ vnode: e }) => `at <${od(n, e.type)}>`).join("\n"),
		i
	]);
	else {
		let n = [`[Vue warn]: ${e}`, ...t];
		i.length && n.push("\n", ...bl(i)), console.warn(...n);
	}
	ec(), _l = !1;
}
function yl() {
	let e = ml[ml.length - 1];
	if (!e) return [];
	let t = [];
	for (; e;) {
		let n = t[0];
		n && n.vnode === e ? n.recurseCount++ : t.push({
			vnode: e,
			recurseCount: 0
		});
		let r = e.component && e.component.parent;
		e = r && r.vnode;
	}
	return t;
}
function bl(e) {
	let t = [];
	return e.forEach((e, n) => {
		t.push(...n === 0 ? [] : ["\n"], ...xl(e));
	}), t;
}
function xl({ vnode: e, recurseCount: t }) {
	let n = t > 0 ? `... (${t} recursive calls)` : "", r = e.component ? e.component.parent == null : !1, i = ` at <${od(e.component, e.type, r)}`, a = ">" + n;
	return e.props ? [
		i,
		...Sl(e.props),
		a
	] : [i + a];
}
function Sl(e) {
	let t = [], n = Object.keys(e);
	return n.slice(0, 3).forEach((n) => {
		t.push(...Cl(n, e[n]));
	}), n.length > 3 && t.push(" ..."), t;
}
function Cl(e, t, n) {
	return ps(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : /* @__PURE__ */ il(t) ? (t = Cl(e, /* @__PURE__ */ el(t.value), !0), n ? t : [
		`${e}=Ref<`,
		t,
		">"
	]) : fs(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = /* @__PURE__ */ el(t), n ? t : [`${e}=`, t]);
}
var wl = {
	sp: "serverPrefetch hook",
	bc: "beforeCreate hook",
	c: "created hook",
	bm: "beforeMount hook",
	m: "mounted hook",
	bu: "beforeUpdate hook",
	u: "updated",
	bum: "beforeUnmount hook",
	um: "unmounted hook",
	a: "activated hook",
	da: "deactivated hook",
	ec: "errorCaptured hook",
	rtc: "renderTracked hook",
	rtg: "renderTriggered hook",
	0: "setup function",
	1: "render function",
	2: "watcher getter",
	3: "watcher callback",
	4: "watcher cleanup function",
	5: "native event handler",
	6: "component event handler",
	7: "vnode hook",
	8: "directive hook",
	9: "transition hook",
	10: "app errorHandler",
	11: "app warnHandler",
	12: "ref function",
	13: "async component loader",
	14: "scheduler flush",
	15: "component update",
	16: "app unmount cleanup function"
};
function Tl(e, t, n, r) {
	try {
		return r ? e(...r) : e();
	} catch (e) {
		Dl(e, t, n);
	}
}
function El(e, t, n, r) {
	if (fs(e)) {
		let i = Tl(e, t, n, r);
		return i && gs(i) && i.catch((e) => {
			Dl(e, t, n);
		}), i;
	}
	if (ls(e)) {
		let i = [];
		for (let a = 0; a < e.length; a++) i.push(El(e[a], t, n, r));
		return i;
	} else process.env.NODE_ENV !== "production" && vl(`Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`);
}
function Dl(e, t, n, r = !0) {
	let i = t ? t.vnode : null, { errorHandler: a, throwUnhandledErrorInProduction: o } = t && t.appContext.config || ts;
	if (t) {
		let r = t.parent, i = t.proxy, o = process.env.NODE_ENV === "production" ? `https://vuejs.org/error-reference/#runtime-${n}` : wl[n];
		for (; r;) {
			let t = r.ec;
			if (t) {
				for (let n = 0; n < t.length; n++) if (t[n](e, i, o) === !1) return;
			}
			r = r.parent;
		}
		if (a) {
			$s(), Tl(a, null, 10, [
				e,
				i,
				o
			]), ec();
			return;
		}
	}
	Ol(e, n, i, r, o);
}
function Ol(e, t, n, r = !0, i = !1) {
	if (process.env.NODE_ENV !== "production") {
		let i = wl[t];
		if (n && hl(n), vl(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && gl(), r) throw e;
		console.error(e);
	} else if (i) throw e;
	else console.error(e);
}
var kl = [], Al = -1, jl = [], Ml = null, Nl = 0, Pl = /* @__PURE__ */ Promise.resolve(), Fl = null, Il = 100;
function Ll(e) {
	let t = Fl || Pl;
	return e ? t.then(this ? e.bind(this) : e) : t;
}
function Rl(e) {
	let t = Al + 1, n = kl.length;
	for (; t < n;) {
		let r = t + n >>> 1, i = kl[r], a = Ul(i);
		a < e || a === e && i.flags & 2 ? t = r + 1 : n = r;
	}
	return t;
}
function zl(e) {
	if (!(e.flags & 1)) {
		let t = Ul(e), n = kl[kl.length - 1];
		!n || !(e.flags & 2) && t >= Ul(n) ? kl.push(e) : kl.splice(Rl(t), 0, e), e.flags |= 1, Bl();
	}
}
function Bl() {
	Fl ||= Pl.then(Wl);
}
function Vl(e) {
	ls(e) ? jl.push(...e) : Ml && e.id === -1 ? Ml.splice(Nl + 1, 0, e) : e.flags & 1 || (jl.push(e), e.flags |= 1), Bl();
}
function Hl(e) {
	if (jl.length) {
		let t = [...new Set(jl)].sort((e, t) => Ul(e) - Ul(t));
		if (jl.length = 0, Ml) {
			Ml.push(...t);
			return;
		}
		for (Ml = t, process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map()), Nl = 0; Nl < Ml.length; Nl++) {
			let t = Ml[Nl];
			process.env.NODE_ENV !== "production" && Gl(e, t) || (t.flags & 4 && (t.flags &= -2), t.flags & 8 || t(), t.flags &= -2);
		}
		Ml = null, Nl = 0;
	}
}
var Ul = (e) => e.id == null ? e.flags & 2 ? -1 : Infinity : e.id;
function Wl(e) {
	process.env.NODE_ENV !== "production" && (e ||= /* @__PURE__ */ new Map());
	let t = process.env.NODE_ENV === "production" ? ns : (t) => Gl(e, t);
	try {
		for (Al = 0; Al < kl.length; Al++) {
			let e = kl[Al];
			if (e && !(e.flags & 8)) {
				if (process.env.NODE_ENV !== "production" && t(e)) continue;
				e.flags & 4 && (e.flags &= -2), Tl(e, e.i, e.i ? 15 : 14), e.flags & 4 || (e.flags &= -2);
			}
		}
	} finally {
		for (; Al < kl.length; Al++) {
			let e = kl[Al];
			e && (e.flags &= -2);
		}
		Al = -1, kl.length = 0, Hl(e), Fl = null, (kl.length || jl.length) && Wl(e);
	}
}
function Gl(e, t) {
	let n = e.get(t) || 0;
	if (n > Il) {
		let e = t.i, n = e && ad(e.type);
		return Dl(`Maximum recursive updates exceeded${n ? ` in component <${n}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10), !0;
	}
	return e.set(t, n + 1), !1;
}
var Kl = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (Es().__VUE_HMR_RUNTIME__ = {
	createRecord: $l(Jl),
	rerender: $l(Xl),
	reload: $l(Zl)
});
var ql = /* @__PURE__ */ new Map();
function Jl(e, t) {
	return ql.has(e) ? !1 : (ql.set(e, {
		initialDef: Yl(t),
		instances: /* @__PURE__ */ new Set()
	}), !0);
}
function Yl(e) {
	return sd(e) ? e.__vccOpts : e;
}
function Xl(e, t) {
	let n = ql.get(e);
	n && (n.initialDef.render = t, [...n.instances].forEach((e) => {
		t && (e.render = t, Yl(e.type).render = t), e.renderCache = [], e.job.flags & 8 || e.update();
	}));
}
function Zl(e, t) {
	let n = ql.get(e);
	if (!n) return;
	t = Yl(t), Ql(n.initialDef, t);
	let r = [...n.instances];
	for (let e = 0; e < r.length; e++) {
		let i = r[e], a = Yl(i.type), o = Kl.get(a);
		o || (a !== n.initialDef && Ql(a, t), Kl.set(a, o = /* @__PURE__ */ new Set())), o.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (o.add(i), i.ceReload(t.styles), o.delete(i)) : i.parent ? zl(() => {
			i.job.flags & 8 || (i.parent.update(), o.delete(i));
		}) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn("[HMR] Root or manually mounted instance modified. Full reload required."), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(a);
	}
	Vl(() => {
		Kl.clear();
	});
}
function Ql(e, t) {
	as(e, t);
	for (let n in e) n !== "__file" && !(n in t) && delete e[n];
}
function $l(e) {
	return (t, n) => {
		try {
			return e(t, n);
		} catch (e) {
			console.error(e), console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
		}
	};
}
var eu = null, tu = null;
function nu(e, t, n = !1) {
	let r = Zu();
	if (r || Du) {
		let i = Du ? Du._context.provides : r ? r.parent == null || r.ce ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : void 0;
		if (i && e in i) return i[e];
		if (arguments.length > 1) return n && fs(t) ? t.call(r && r.proxy) : t;
		process.env.NODE_ENV !== "production" && vl(`injection "${String(e)}" not found.`);
	} else process.env.NODE_ENV !== "production" && vl("inject() can only be used inside setup() or functional components.");
}
var ru = /* @__PURE__ */ Symbol.for("v-scx"), iu = () => {
	{
		let e = nu(ru);
		return e || process.env.NODE_ENV !== "production" && vl("Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."), e;
	}
};
function au(e, t, n = ts) {
	let { immediate: r, deep: i, flush: a, once: o } = n;
	process.env.NODE_ENV !== "production" && !t && (r !== void 0 && vl("watch() \"immediate\" option is only respected when using the watch(source, callback, options?) signature."), i !== void 0 && vl("watch() \"deep\" option is only respected when using the watch(source, callback, options?) signature."), o !== void 0 && vl("watch() \"once\" option is only respected when using the watch(source, callback, options?) signature."));
	let s = as({}, n);
	process.env.NODE_ENV !== "production" && (s.onWarn = vl);
	let c = t && r || !t && a !== "post", l;
	if (td) {
		if (a === "sync") {
			let e = iu();
			l = e.__watcherHandles ||= [];
		} else if (!c) {
			let e = () => {};
			return e.stop = ns, e.resume = ns, e.pause = ns, e;
		}
	}
	let u = Xu;
	s.call = (e, t, n) => El(e, u, t, n);
	let d = !1;
	a === "post" ? s.scheduler = (e) => {
		Au(e, u && u.suspense);
	} : a !== "sync" && (d = !0, s.scheduler = (e, t) => {
		t ? e() : zl(e);
	}), s.augmentJob = (e) => {
		t && (e.flags |= 4), d && (e.flags |= 2, u && (e.id = u.uid, e.i = u));
	};
	let f = fl(e, t, s);
	return td && (l ? l.push(f) : c && f()), f;
}
function ou(e, t, n) {
	let r = this.proxy, i = ps(e) ? e.includes(".") ? su(r, e) : () => r[e] : e.bind(r, r), a;
	fs(t) ? a = t : (a = t.handler, n = t);
	let o = $u(this), s = au(i, a.bind(r), n);
	return o(), s;
}
function su(e, t) {
	let n = t.split(".");
	return () => {
		let t = e;
		for (let e = 0; e < n.length && t; e++) t = t[n[e]];
		return t;
	};
}
var cu = (e) => e.__isTeleport;
function lu(e, t) {
	e.shapeFlag & 6 && e.component ? (e.transition = t, lu(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
Es().requestIdleCallback, Es().cancelIdleCallback;
var uu = /* @__PURE__ */ Symbol.for("v-ndc"), du = (e) => e ? ed(e) ? nd(e) : du(e.parent) : null, fu = /* @__PURE__ */ as(/* @__PURE__ */ Object.create(null), {
	$: (e) => e,
	$el: (e) => e.vnode.el,
	$data: (e) => e.data,
	$props: (e) => process.env.NODE_ENV === "production" ? e.props : /* @__PURE__ */ Jc(e.props),
	$attrs: (e) => process.env.NODE_ENV === "production" ? e.attrs : /* @__PURE__ */ Jc(e.attrs),
	$slots: (e) => process.env.NODE_ENV === "production" ? e.slots : /* @__PURE__ */ Jc(e.slots),
	$refs: (e) => process.env.NODE_ENV === "production" ? e.refs : /* @__PURE__ */ Jc(e.refs),
	$parent: (e) => du(e.parent),
	$root: (e) => du(e.root),
	$host: (e) => e.ce,
	$emit: (e) => e.emit,
	$options: (e) => _u(e),
	$forceUpdate: (e) => e.f ||= () => {
		zl(e.update);
	},
	$nextTick: (e) => e.n ||= Ll.bind(e.proxy),
	$watch: (e) => ou.bind(e)
}), pu = (e, t) => e !== ts && !e.__isScriptSetup && cs(e, t), mu = {
	get({ _: e }, t) {
		if (t === "__v_skip") return !0;
		let { ctx: n, setupState: r, data: i, props: a, accessCache: o, type: s, appContext: c } = e;
		if (process.env.NODE_ENV !== "production" && t === "__isVue") return !0;
		if (t[0] !== "$") {
			let e = o[t];
			if (e !== void 0) switch (e) {
				case 1: return r[t];
				case 2: return i[t];
				case 4: return n[t];
				case 3: return a[t];
			}
			else if (pu(r, t)) return o[t] = 1, r[t];
			else if (i !== ts && cs(i, t)) return o[t] = 2, i[t];
			else if (cs(a, t)) return o[t] = 3, a[t];
			else if (n !== ts && cs(n, t)) return o[t] = 4, n[t];
			else gu && (o[t] = 0);
		}
		let l = fu[t], u, d;
		if (l) return t === "$attrs" ? (uc(e.attrs, "get", ""), process.env.NODE_ENV) : process.env.NODE_ENV !== "production" && t === "$slots" && uc(e, "get", t), l(e);
		if ((u = s.__cssModules) && (u = u[t])) return u;
		if (n !== ts && cs(n, t)) return o[t] = 4, n[t];
		if (d = c.config.globalProperties, cs(d, t)) return d[t];
		process.env.NODE_ENV;
	},
	set({ _: e }, t, n) {
		let { data: r, setupState: i, ctx: a } = e;
		return pu(i, t) ? (i[t] = n, !0) : process.env.NODE_ENV !== "production" && i.__isScriptSetup && cs(i, t) ? (vl(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : r !== ts && cs(r, t) ? (r[t] = n, !0) : cs(e.props, t) ? (process.env.NODE_ENV !== "production" && vl(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && vl(`Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(a, t, {
			enumerable: !0,
			configurable: !0,
			value: n
		}) : a[t] = n, !0);
	},
	has({ _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: i, props: a, type: o } }, s) {
		let c;
		return !!(n[s] || e !== ts && s[0] !== "$" && cs(e, s) || pu(t, s) || cs(a, s) || cs(r, s) || cs(fu, s) || cs(i.config.globalProperties, s) || (c = o.__cssModules) && c[s]);
	},
	defineProperty(e, t, n) {
		return n.get == null ? cs(n, "value") && this.set(e, t, n.value, null) : e._.accessCache[t] = 0, Reflect.defineProperty(e, t, n);
	}
};
process.env.NODE_ENV !== "production" && (mu.ownKeys = (e) => (vl("Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."), Reflect.ownKeys(e)));
function hu(e) {
	return ls(e) ? e.reduce((e, t) => (e[t] = null, e), {}) : e;
}
var gu = !0;
function _u(e) {
	let t = e.type, { mixins: n, extends: r } = t, { mixins: i, optionsCache: a, config: { optionMergeStrategies: o } } = e.appContext, s = a.get(t), c;
	return s ? c = s : !i.length && !n && !r ? c = t : (c = {}, i.length && i.forEach((e) => vu(c, e, o, !0)), vu(c, t, o)), hs(t) && a.set(t, c), c;
}
function vu(e, t, n, r = !1) {
	let { mixins: i, extends: a } = t;
	a && vu(e, a, n, !0), i && i.forEach((t) => vu(e, t, n, !0));
	for (let i in t) if (r && i === "expose") process.env.NODE_ENV !== "production" && vl("\"expose\" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.");
	else {
		let r = yu[i] || n && n[i];
		e[i] = r ? r(e[i], t[i]) : t[i];
	}
	return e;
}
var yu = {
	data: bu,
	props: Tu,
	emits: Tu,
	methods: wu,
	computed: wu,
	beforeCreate: Cu,
	created: Cu,
	beforeMount: Cu,
	mounted: Cu,
	beforeUpdate: Cu,
	updated: Cu,
	beforeDestroy: Cu,
	beforeUnmount: Cu,
	destroyed: Cu,
	unmounted: Cu,
	activated: Cu,
	deactivated: Cu,
	errorCaptured: Cu,
	serverPrefetch: Cu,
	components: wu,
	directives: wu,
	watch: Eu,
	provide: bu,
	inject: xu
};
function bu(e, t) {
	return t ? e ? function() {
		return as(fs(e) ? e.call(this, this) : e, fs(t) ? t.call(this, this) : t);
	} : t : e;
}
function xu(e, t) {
	return wu(Su(e), Su(t));
}
function Su(e) {
	if (ls(e)) {
		let t = {};
		for (let n = 0; n < e.length; n++) t[e[n]] = e[n];
		return t;
	}
	return e;
}
function Cu(e, t) {
	return e ? [...new Set([].concat(e, t))] : t;
}
function wu(e, t) {
	return e ? as(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function Tu(e, t) {
	return e ? ls(e) && ls(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : as(/* @__PURE__ */ Object.create(null), hu(e), hu(t ?? {})) : t;
}
function Eu(e, t) {
	if (!e) return t;
	if (!t) return e;
	let n = as(/* @__PURE__ */ Object.create(null), e);
	for (let r in t) n[r] = Cu(e[r], t[r]);
	return n;
}
var Du = null, Ou = {}, ku = (e) => Object.getPrototypeOf(e) === Ou, Au = Mu, ju = (e) => e.__isSuspense;
function Mu(e, t) {
	t && t.pendingBranch ? ls(e) ? t.effects.push(...e) : t.effects.push(e) : Vl(e);
}
var Nu = /* @__PURE__ */ Symbol.for("v-fgt"), Pu = /* @__PURE__ */ Symbol.for("v-txt"), Fu = /* @__PURE__ */ Symbol.for("v-cmt");
function Iu(e) {
	return e ? e.__v_isVNode === !0 : !1;
}
var Lu, Ru = (...e) => Uu(...Lu ? Lu(e, eu) : e), zu = ({ key: e }) => e ?? null, Bu = ({ ref: e, ref_key: t, ref_for: n }) => (typeof e == "number" && (e = "" + e), e == null ? null : ps(e) || /* @__PURE__ */ il(e) || fs(e) ? {
	i: eu,
	r: e,
	k: t,
	f: !!n
} : e);
function Vu(e, t = null, n = null, r = 0, i = null, a = e === Nu ? 0 : 1, o = !1, s = !1) {
	let c = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e,
		props: t,
		key: t && zu(t),
		ref: t && Bu(t),
		scopeId: tu,
		slotScopeIds: null,
		children: n,
		component: null,
		suspense: null,
		ssContent: null,
		ssFallback: null,
		dirs: null,
		transition: null,
		el: null,
		anchor: null,
		target: null,
		targetStart: null,
		targetAnchor: null,
		staticCount: 0,
		shapeFlag: a,
		patchFlag: r,
		dynamicProps: i,
		dynamicChildren: null,
		appContext: null,
		ctx: eu
	};
	return s ? (Ju(c, n), a & 128 && e.normalize(c)) : n && (c.shapeFlag |= ps(n) ? 8 : 16), process.env.NODE_ENV !== "production" && c.key !== c.key && vl("VNode created with invalid key (NaN). VNode type:", c.type), c;
}
var Hu = process.env.NODE_ENV === "production" ? Uu : Ru;
function Uu(e, t = null, n = null, r = 0, i = null, a = !1) {
	if ((!e || e === uu) && (process.env.NODE_ENV !== "production" && !e && vl(`Invalid vnode type when creating vnode: ${e}.`), e = Fu), Iu(e)) {
		let r = Gu(e, t, !0);
		return n && Ju(r, n), r.patchFlag = -2, r;
	}
	if (sd(e) && (e = e.__vccOpts), t) {
		t = Wu(t);
		let { class: e, style: n } = t;
		e && !ps(e) && (t.class = Ms(e)), hs(n) && (/* @__PURE__ */ $c(n) && !ls(n) && (n = as({}, n)), t.style = Ds(n));
	}
	let o = ps(e) ? 1 : ju(e) ? 128 : cu(e) ? 64 : hs(e) ? 4 : fs(e) ? 2 : 0;
	return process.env.NODE_ENV !== "production" && o & 4 && /* @__PURE__ */ $c(e) && (e = /* @__PURE__ */ el(e), vl("Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.", "\nComponent that was made reactive: ", e)), Vu(e, t, n, r, i, o, a, !0);
}
function Wu(e) {
	return e ? /* @__PURE__ */ $c(e) || ku(e) ? as({}, e) : e : null;
}
function Gu(e, t, n = !1, r = !1) {
	let { props: i, ref: a, patchFlag: o, children: s, transition: c } = e, l = t ? Yu(i || {}, t) : i, u = {
		__v_isVNode: !0,
		__v_skip: !0,
		type: e.type,
		props: l,
		key: l && zu(l),
		ref: t && t.ref ? n && a ? ls(a) ? a.concat(Bu(t)) : [a, Bu(t)] : Bu(t) : a,
		scopeId: e.scopeId,
		slotScopeIds: e.slotScopeIds,
		children: process.env.NODE_ENV !== "production" && o === -1 && ls(s) ? s.map(Ku) : s,
		target: e.target,
		targetStart: e.targetStart,
		targetAnchor: e.targetAnchor,
		staticCount: e.staticCount,
		shapeFlag: e.shapeFlag,
		patchFlag: t && e.type !== Nu ? o === -1 ? 16 : o | 16 : o,
		dynamicProps: e.dynamicProps,
		dynamicChildren: e.dynamicChildren,
		appContext: e.appContext,
		dirs: e.dirs,
		transition: c,
		component: e.component,
		suspense: e.suspense,
		ssContent: e.ssContent && Gu(e.ssContent),
		ssFallback: e.ssFallback && Gu(e.ssFallback),
		placeholder: e.placeholder,
		el: e.el,
		anchor: e.anchor,
		ctx: e.ctx,
		ce: e.ce
	};
	return c && r && lu(u, c.clone(u)), u;
}
function Ku(e) {
	let t = Gu(e);
	return ls(e.children) && (t.children = e.children.map(Ku)), t;
}
function qu(e = " ", t = 0) {
	return Hu(Pu, null, e, t);
}
function Ju(e, t) {
	let n = 0, { shapeFlag: r } = e;
	if (t == null) t = null;
	else if (ls(t)) n = 16;
	else if (typeof t == "object") if (r & 65) {
		let n = t.default;
		n && (n._c && (n._d = !1), Ju(e, n()), n._c && (n._d = !0));
		return;
	} else n = 32, !t._ && !ku(t) && (t._ctx = eu);
	else if (fs(t)) {
		if (r & 65) {
			Ju(e, { default: t });
			return;
		}
		t = {
			default: t,
			_ctx: eu
		}, n = 32;
	} else t = String(t), r & 64 ? (n = 16, t = [qu(t)]) : n = 8;
	e.children = t, e.shapeFlag |= n;
}
function Yu(...e) {
	let t = {};
	for (let n = 0; n < e.length; n++) {
		let r = e[n];
		for (let e in r) if (e === "class") t.class !== r.class && (t.class = Ms([t.class, r.class]));
		else if (e === "style") t.style = Ds([t.style, r.style]);
		else if (rs(e)) {
			let n = t[e], i = r[e];
			i && n !== i && !(ls(n) && n.includes(i)) ? t[e] = n ? [].concat(n, i) : i : i == null && n == null && !is(e) && (t[e] = i);
		} else e !== "" && (t[e] = r[e]);
	}
	return t;
}
var Xu = null, Zu = () => Xu || eu, Qu;
{
	let e = Es(), t = (t, n) => {
		let r;
		return (r = e[t]) || (r = e[t] = []), r.push(n), (e) => {
			r.length > 1 ? r.forEach((t) => t(e)) : r[0](e);
		};
	};
	Qu = t("__VUE_INSTANCE_SETTERS__", (e) => Xu = e), t("__VUE_SSR_SETTERS__", (e) => td = e);
}
var $u = (e) => {
	let t = Xu;
	return Qu(e), e.scope.on(), () => {
		e.scope.off(), Qu(t);
	};
};
function ed(e) {
	return e.vnode.shapeFlag & 4;
}
var td = !1;
process.env.NODE_ENV;
function nd(e) {
	return e.exposed ? e.exposeProxy ||= new Proxy(sl(tl(e.exposed)), {
		get(t, n) {
			if (n in t) return t[n];
			if (n in fu) return fu[n](e);
		},
		has(e, t) {
			return t in e || t in fu;
		}
	}) : e.proxy;
}
var rd = /(?:^|[-_])\w/g, id = (e) => e.replace(rd, (e) => e.toUpperCase()).replace(/[-_]/g, "");
function ad(e, t = !0) {
	return fs(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function od(e, t, n = !1) {
	let r = ad(t);
	if (!r && t.__file) {
		let e = t.__file.match(/([^/\\]+)\.\w+$/);
		e && (r = e[1]);
	}
	if (!r && e) {
		let n = (e) => {
			for (let n in e) if (e[n] === t) return n;
		};
		r = n(e.components) || e.parent && n(e.parent.type.components) || n(e.appContext.components);
	}
	return r ? id(r) : n ? "App" : "Anonymous";
}
function sd(e) {
	return fs(e) && "__vccOpts" in e;
}
function cd() {
	if (process.env.NODE_ENV === "production" || typeof window > "u") return;
	let e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, r = { style: "color:#eb2f96" }, i = {
		__vue_custom_formatter: !0,
		header(t) {
			if (!hs(t)) return null;
			if (t.__isVue) return [
				"div",
				e,
				"VueInstance"
			];
			if (/* @__PURE__ */ il(t)) {
				$s();
				let n = t.value;
				return ec(), [
					"div",
					{},
					[
						"span",
						e,
						u(t)
					],
					"<",
					s(n),
					">"
				];
			} else if (/* @__PURE__ */ Xc(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ Qc(t) ? "ShallowReactive" : "Reactive"
				],
				"<",
				s(t),
				`>${/* @__PURE__ */ Zc(t) ? " (readonly)" : ""}`
			];
			else if (/* @__PURE__ */ Zc(t)) return [
				"div",
				{},
				[
					"span",
					e,
					/* @__PURE__ */ Qc(t) ? "ShallowReadonly" : "Readonly"
				],
				"<",
				s(t),
				">"
			];
			return null;
		},
		hasBody(e) {
			return e && e.__isVue;
		},
		body(e) {
			if (e && e.__isVue) return [
				"div",
				{},
				...a(e.$)
			];
		}
	};
	function a(e) {
		let t = [];
		e.type.props && e.props && t.push(o("props", /* @__PURE__ */ el(e.props))), e.setupState !== ts && t.push(o("setup", e.setupState)), e.data !== ts && t.push(o("data", /* @__PURE__ */ el(e.data)));
		let n = c(e, "computed");
		n && t.push(o("computed", n));
		let i = c(e, "inject");
		return i && t.push(o("injected", i)), t.push([
			"div",
			{},
			[
				"span",
				{ style: r.style + ";opacity:0.66" },
				"$ (internal): "
			],
			["object", { object: e }]
		]), t;
	}
	function o(e, t) {
		return t = as({}, t), Object.keys(t).length ? [
			"div",
			{ style: "line-height:1.25em;margin-bottom:0.6em" },
			[
				"div",
				{ style: "color:#476582" },
				e
			],
			[
				"div",
				{ style: "padding-left:1.25em" },
				...Object.keys(t).map((e) => [
					"div",
					{},
					[
						"span",
						r,
						e + ": "
					],
					s(t[e], !1)
				])
			]
		] : ["span", {}];
	}
	function s(e, i = !0) {
		return typeof e == "number" ? [
			"span",
			t,
			e
		] : typeof e == "string" ? [
			"span",
			n,
			JSON.stringify(e)
		] : typeof e == "boolean" ? [
			"span",
			r,
			e
		] : hs(e) ? ["object", { object: i ? /* @__PURE__ */ el(e) : e }] : [
			"span",
			n,
			String(e)
		];
	}
	function c(e, t) {
		let n = e.type;
		if (fs(n)) return;
		let r = {};
		for (let i in e.ctx) l(n, i, t) && (r[i] = e.ctx[i]);
		return r;
	}
	function l(e, t, n) {
		let r = e[n];
		if (ls(r) && r.includes(t) || hs(r) && t in r || e.extends && l(e.extends, t, n) || e.mixins && e.mixins.some((e) => l(e, t, n))) return !0;
	}
	function u(e) {
		return /* @__PURE__ */ Qc(e) ? "ShallowRef" : e.effect ? "ComputedRef" : "Ref";
	}
	window.devtoolsFormatters ? window.devtoolsFormatters.push(i) : window.devtoolsFormatters = [i];
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
function ld() {
	cd();
}
process.env.NODE_ENV !== "production" && ld();
//#endregion
//#region ../../services/order-service/dist/index.js
var ud = {
	CommercialGoods: "COMMERCIAL_GOODS",
	CommercialSample: "COMMERCIAL_SAMPLE",
	Documents: "DOCUMENTS",
	Gift: "GIFT",
	ReturnedGoods: "RETURNED_GOODS"
}, dd = (e) => e.type === "BUSINESS" || "company" in e && typeof e.company == "string" && e.company.length > 0, fd = (e) => e.type === "PRIVATE" || "name" in e && typeof e.name == "string";
function pd(e) {
	return e !== void 0 && "barcode" in e;
}
var R = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, z = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
R.Dhl, R.Instabox, R.PostNl, z.PostNl, R.Bpost, z.Bpost, R.CheapCargo, z.CheapCargo, R.Dpd, z.Dpd, R.Instabox, z.Instabox, R.Dhl, z.Dhl, R.Bol, z.Bol, R.Ups, z.Ups, R.DhlForYou, z.DhlForYou, R.DhlParcelConnect, z.DhlParcelConnect, R.DhlEuroPlus, z.DhlEuroPlus, R.UpsStandard, z.UpsStandard, R.UpsExpressSaver, z.UpsExpressSaver, R.Gls, z.Gls, R.Brt, z.Brt, R.Trunkrs, z.Trunkrs, R.InPost, z.InPost, R.PosteItaliane, z.PosteItaliane, R.Spring, z.Spring, R.ViaTim, z.ViaTim, R.PostNl, z.POSTNL, R.Bpost, z.BPOST, R.CheapCargo, z.CHEAP_CARGO, R.Dpd, z.DPD, R.Instabox, z.INSTABOX, R.Dhl, z.DHL, R.Bol, z.BOL, R.Ups, z.UPS, R.DhlForYou, z.DHL_FOR_YOU, R.DhlParcelConnect, z.DHL_PARCEL_CONNECT, R.DhlEuroPlus, z.DHL_EUROPLUS, R.UpsStandard, z.UPS_STANDARD, R.UpsExpressSaver, z.UPS_EXPRESS_SAVER, R.Gls, z.GLS, R.Brt, z.BRT, R.Trunkrs, z.TRUNKRS, R.InPost, z.INPOST, R.PosteItaliane, z.POSTE_ITALIANE, R.Spring, z.SPRING, R.ViaTim, z.VIA_TIM, z.PostNl, R.PostNl, z.POSTNL, R.PostNl, z.Bpost, R.Bpost, z.BPOST, R.Bpost, z.CheapCargo, R.CheapCargo, z.CHEAP_CARGO, R.CheapCargo, z.Dpd, R.Dpd, z.DPD, R.Dpd, z.Instabox, R.Instabox, z.Dhl, R.Dhl, z.BolCom, R.Bol, z.Bol, R.Bol, z.BOL, R.Bol, z.Ups, R.Ups, z.DhlForYou, R.DhlForYou, z.DHL_FOR_YOU, R.DhlForYou, z.DhlParcelConnect, R.DhlParcelConnect, z.DHL_PARCEL_CONNECT, R.DhlParcelConnect, z.DhlEuroPlus, R.DhlEuroPlus, z.DHL_EUROPLUS, R.DhlEuroPlus, z.UpsStandard, R.UpsStandard, z.UPS_STANDARD, R.UpsStandard, z.UpsExpressSaver, R.UpsExpressSaver, z.UPS_EXPRESS_SAVER, R.UpsExpressSaver, z.Gls, R.Gls, z.GLS, R.Gls, z.Brt, R.Brt, z.BRT, R.Brt, z.Trunkrs, R.Trunkrs, z.TRUNKRS, R.Trunkrs, z.InPost, R.InPost, z.INPOST, R.InPost, z.PosteItaliane, R.PosteItaliane, z.POSTE_ITALIANE, R.PosteItaliane, z.Spring, R.Spring, z.SPRING, R.Spring, z.ViaTim, R.ViaTim, z.VIA_TIM, R.ViaTim, R.PostNl, R.Bpost, R.CheapCargo, R.Dpd, R.Instabox, R.Dhl, R.Bol, R.Ups, R.DhlForYou, R.DhlParcelConnect, R.DhlEuroPlus, R.UpsStandard, R.UpsExpressSaver, R.Gls, R.Brt, R.Trunkrs, R.InPost, R.PosteItaliane, R.ViaTim;
var B = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
B.Austria, B.Belgium, B.Bulgaria, B.Croatia, B.Cyprus, B.CzechRepublic, B.Denmark, B.Estonia, B.Finland, B.France, B.Germany, B.Greece, B.Hungary, B.Ireland, B.Italy, B.Latvia, B.Lithuania, B.Luxembourg, B.Malta, B.Netherlands, B.Poland, B.Portugal, B.Romania, B.Slovakia, B.Slovenia, B.Spain, B.Sweden, Object.values(B), B.Angola, B.AntiguaAndBarbuda, B.Aruba, B.Bahamas, B.Belize, B.Benin, B.Bermuda, B.BonaireSintEustatiusAndSaba, B.Botswana, B.BurkinaFaso, B.Burundi, B.Cameroon, B.CanaryIslands, B.CentralAfricanRepublic, B.Comoros, B.CongoBrazzaville, B.CongoKinshasa, B.CoteDIvoire, B.Curacao, B.Djibouti, B.Dominica, B.DutchAntilles, B.EquatorialGuinea, B.Eritrea, B.Fiji, B.Gabon, B.Gambia, B.Ghana, B.Grenada, B.Guyana, B.HongKong, B.Kiribati, B.KoreaPeoplesDemocraticRepublic, B.Macao, B.Malawi, B.Mali, B.Mauritania, B.Nauru, B.Qatar, B.Rwanda, B.SaintKittsAndNevis, B.SaoTomeAndPrincipe, B.Seychelles, B.SierraLeone, B.SintMaarten, B.Suriname, B.SyrianArabRepublic, B.TimorLeste, B.Togo, B.Tonga, B.Tuvalu, B.Uganda, B.UnitedArabEmirates, B.Vanuatu, B.Yemen, B.Zimbabwe, B.Austria, B.Belgium, B.Bulgaria, B.Croatia, B.CzechRepublic, B.Estonia, B.Finland, B.France, B.Germany, B.Greece, B.Hungary, B.Ireland, B.Italy, B.Latvia, B.Lithuania, B.Luxembourg, B.Malta, B.Netherlands, B.Portugal, B.Romania, B.Slovakia, B.Slovenia, B.Spain, B.UnitedKingdom, B.Denmark, B.Germany, B.Sweden;
var md = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, V = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, hd = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
md.EarlyMorning, V.EarlyMorning, md.Morning, V.Morning, md.Standard, V.Standard, md.Evening, V.Evening, md.Pickup, V.Pickup, md.PickupExpress, V.PickupExpress, md.SameDayDelivery, V.SameDayDelivery, md.Express, V.Express, V.EarlyMorning, md.EarlyMorning, V.Morning, md.Morning, V.Standard, md.Standard, V.Evening, md.Evening, V.Pickup, md.Pickup, V.PickupExpress, md.PickupExpress, V.SameDayDelivery, md.SameDayDelivery, V.Express, md.Express, md.EarlyMorning, hd.EarlyMorning, md.Morning, hd.Morning, md.Standard, hd.Standard, md.Evening, hd.Evening, md.Pickup, hd.Pickup, md.PickupExpress, hd.PickupExpress, md.SameDayDelivery, hd.SameDayDelivery, md.Express, hd.Express, hd.EarlyMorning, V.EarlyMorning, hd.Morning, V.Morning, hd.Standard, V.Standard, hd.Evening, V.Evening, hd.Pickup, V.Pickup, hd.PickupExpress, V.PickupExpress, hd.SameDayDelivery, V.SameDayDelivery, hd.Express, V.Express, md.EarlyMorning, md.Morning, md.Standard, md.Evening, md.Pickup, md.PickupExpress, md.SameDayDelivery, md.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var gd = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, _d = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
_d.Sunday, gd.Sunday, _d.Monday, gd.Monday, _d.Tuesday, gd.Tuesday, _d.Wednesday, gd.Wednesday, _d.Thursday, gd.Thursday, _d.Friday, gd.Friday, _d.Saturday, gd.Saturday, gd.Sunday, _d.Sunday, gd.Monday, _d.Monday, gd.Tuesday, _d.Tuesday, gd.Wednesday, _d.Wednesday, gd.Thursday, _d.Thursday, gd.Friday, _d.Friday, gd.Saturday, _d.Saturday;
var vd = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
vd.Bytes, vd.Kilobytes, vd.Megabytes, vd.Gigabytes, vd.Terabytes;
var yd = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, bd = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
yd.Bol, bd.Bol, yd.Exact, bd.Exact, yd.Amazon, bd.Amazon, yd.Wix, bd.Wix, yd.ExactDe, bd.ExactDe, yd.Etsy, bd.Etsy, bd.Bol, yd.Bol, bd.Exact, yd.Exact, bd.Amazon, yd.Amazon, bd.Wix, yd.Wix, bd.ExactDe, yd.ExactDe, bd.Etsy, yd.Etsy;
var H = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, xd = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
H.Unpaid, xd.Unpaid, H.Due, xd.Due, H.DuePrepayment, xd.DuePrepayment, H.Reminder1, xd.Reminder1, H.Reminder2, xd.Reminder2, H.Dun, xd.Dun, H.Collection, xd.Collection, H.Instalments, xd.Instalments, H.PaymentArrangement, xd.PaymentArrangement, H.Dispute, xd.Dispute, H.LegalProcedure, xd.LegalProcedure, H.Insolvency, xd.Insolvency, H.WriteOff, xd.WriteOff, H.Pending, xd.Pending, H.Cancelled, xd.Cancelled, H.Paid, xd.Paid, H.PaidOnline, xd.PaidOnline, H.PaidAutomatic, xd.PaidAutomatic, H.PaidCredit, xd.PaidCredit, H.PaidZeroItems, xd.PaidZeroItems, H.InvoiceWith0InvoiceItemsPaidZeroBalance, xd.PaidZeroBalance, H.Due, H.Reminder1, H.Reminder2, H.Dun, H.Collection, H.Instalments, H.PaymentArrangement, H.Dispute, H.Paid, H.PaidOnline, H.PaidAutomatic, H.PaidCredit, H.PaidZeroItems;
var Sd = {
	Gram: "g",
	Kilogram: "kg"
};
Sd.Gram, Sd.Kilogram;
var Cd = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
Cd.Millimeter, Cd.Centimeter, Cd.Meter;
var wd = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, Td = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
Td.PendingConcept, Td.PendingRegistered, Td.EnRouteHandedToCarrier, Td.EnRouteSorting, Td.EnRouteDistribution, Td.EnRouteCustoms, Td.DeliveredReadyForPickup, Td.DeliveredAtRecipient, Td.DeliveredPackagePickedUp;
var Ed = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, Dd = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
Dd.Light, Ed.Light, Dd.Start, Ed.Start, Dd.Plus, Ed.Plus, Dd.Premium, Ed.Premium, Dd.Max, Ed.Max, Ed.Light, Dd.Light, Ed.Start, Dd.Start, Ed.Plus, Dd.Plus, Ed.Premium, Dd.Premium, Ed.Max, Dd.Max;
var Od = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, kd = {
	Start: Ed.Start,
	Plus: Ed.Plus,
	Premium: Ed.Premium,
	Max: Ed.Max
};
Od.Start, kd.Start, Od.Plus, kd.Plus, Od.Premium, kd.Premium, Od.Max, kd.Max, kd.Start, Od.Start, kd.Plus, Od.Plus, kd.Premium, Od.Premium, kd.Max, Od.Max;
var Ad = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, jd = {
	Start: Ed.Start,
	Plus: Ed.Plus,
	Premium: Ed.Premium,
	Max: Ed.Max
};
Ad.Start, jd.Start, Ad.Plus, jd.Plus, Ad.Premium, jd.Premium, Ad.Max, jd.Max, jd.Start, Ad.Start, jd.Plus, Ad.Plus, jd.Premium, Ad.Premium, jd.Max, Ad.Max;
var Md = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Nd = {
	Light: Ed.Light,
	Start: Ed.Start,
	Plus: Ed.Plus,
	Premium: Ed.Premium,
	Max: Ed.Max
};
Md.Light, Nd.Light, Md.Start, Nd.Start, Md.Plus, Nd.Plus, Md.Premium, Nd.Premium, Md.Max, Nd.Max, Nd.Light, Md.Light, Nd.Start, Md.Start, Nd.Plus, Md.Plus, Nd.Premium, Md.Premium, Nd.Max, Md.Max;
var Pd = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Fd = {
	Start: Ed.Start,
	Plus: Ed.Plus,
	Premium: Ed.Premium,
	Max: Ed.Max
};
Pd.Start, Fd.Start, Pd.Plus, Fd.Plus, Pd.Premium, Fd.Premium, Pd.Max, Fd.Max, Fd.Start, Pd.Start, Fd.Plus, Pd.Plus, Fd.Premium, Pd.Premium, Fd.Max, Pd.Max;
var Id = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Ld = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Rd = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Id.MyParcel, Ld.MyParcel, Id.Flespakket, Ld.Flespakket, Id.SendMyParcel, Ld.SendMyParcel, Id.MyParcelIt, Ld.MyParcelIt, Id.DeliverDutch, Ld.DeliverDutch, Id.PostNlPlugin, Ld.PostNlPlugin, Id.MyParcel, Rd.MyParcelNl, Id.Flespakket, Rd.MyParcelNl, Id.SendMyParcel, Rd.MyParcelBe, Id.MyParcelIt, Rd.MyParcelIt, Id.DeliverDutch, Rd.DeliverDutch, Id.PostNlPlugin, Rd.PostNlPlugin, Rd.MyParcelNl, Id.MyParcel, Rd.MyParcelBe, Id.SendMyParcel, Rd.MyParcelIt, Id.MyParcelIt, Rd.MyParcelNl, wd.HomeCountry, B.Netherlands, wd.Eu, wd.Row, B.Belgium, Rd.MyParcelBe, wd.HomeCountry, B.Belgium, B.Netherlands, wd.Eu, wd.Row, Rd.MyParcelBe, wd.HomeCountry, B.Belgium, wd.Eu, wd.Row, Rd.MyParcelNl, wd.HomeCountry, B.Netherlands, wd.Eu, wd.Row, Rd.MyParcelNl, wd.HomeCountry, B.Netherlands, B.Belgium, B.Luxembourg, R.Bpost, R.PostNl, R.DhlForYou, R.DhlParcelConnect, R.DhlEuroPlus, R.Ups, R.UpsStandard, R.UpsExpressSaver;
var U = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, zd = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
U.Package, zd.Package, U.Mailbox, zd.Mailbox, U.Letter, zd.Letter, U.DigitalStamp, zd.DigitalStamp, U.Pallet, zd.Pallet, U.PackageSmall, zd.PackageSmall, U.Envelope, zd.Envelope, zd.Package, U.Package, zd.Mailbox, U.Mailbox, zd.Letter, U.Letter, zd.DigitalStamp, U.DigitalStamp, zd.Pallet, U.Pallet, zd.PackageSmall, U.PackageSmall, zd.Envelope, U.Envelope;
var Bd = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
U.Package, Bd.PACKAGE, U.Mailbox, Bd.MAILBOX, U.Letter, Bd.UNFRANKED, U.DigitalStamp, Bd.DIGITAL_STAMP, U.Pallet, Bd.PALLET, U.PackageSmall, Bd.SMALL_PACKAGE, U.Envelope, Bd.ENVELOPE, Bd.PACKAGE, U.Package, Bd.MAILBOX, U.Mailbox, Bd.UNFRANKED, U.Letter, Bd.DIGITAL_STAMP, U.DigitalStamp, Bd.PALLET, U.Pallet, Bd.SMALL_PACKAGE, U.PackageSmall, Bd.ENVELOPE, U.Envelope, U.Package, U.Mailbox, U.Letter, U.DigitalStamp, U.Pallet, U.PackageSmall, U.Envelope;
var Vd = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
Vd.PendingConcept, Vd.PendingRegistered, Vd.EnrouteHandedToCarrier, Vd.EnrouteSorting, Vd.EnrouteDistribution, Vd.DeliveredAtCustoms, Vd.DeliveredAtRecipient, Vd.DeliveredPackagePickedUp, Vd.DeliveredReturnShipmentPackagePickedUp, Vd.DeliveredAtAgreedLocation, Vd.PrintedLetter, Vd.PrintedDigitalStamp, Vd.InactiveConcept, Vd.InactiveRegistered, Vd.InactiveEnrouteHandedToCarrier, Vd.InactiveEnrouteSorting, Vd.InactiveEnrouteDistribution, Vd.InactiveEnrouteCustoms, Vd.InactiveDeliveredAtRecipient, Vd.InactiveDeliveredReadyForPickup, Vd.InactiveDeliveredPackagePickedUp, Xo.EVENING_DELIVERY, Xo.EARLY_MORNING_DELIVERY, Xo.MORNING_DELIVERY, Xo.STANDARD_DELIVERY;
var Hd = {
	[V.EarlyMorning]: Xo.EARLY_MORNING_DELIVERY,
	[V.Morning]: Xo.MORNING_DELIVERY,
	[V.Standard]: Xo.STANDARD_DELIVERY,
	[V.Evening]: Xo.EVENING_DELIVERY,
	[V.SameDayDelivery]: Xo.SAME_DAY_DELIVERY,
	[V.Express]: Xo.EXPRESS_DELIVERY,
	[V.Pickup]: Xo.PICKUP_DELIVERY,
	[V.PickupExpress]: Xo.PICKUP_EXPRESS_DELIVERY
};
Xo.EARLY_MORNING_DELIVERY, V.EarlyMorning, Xo.MORNING_DELIVERY, V.Morning, Xo.STANDARD_DELIVERY, V.Standard, Xo.EVENING_DELIVERY, V.Evening, Xo.SAME_DAY_DELIVERY, V.SameDayDelivery, Xo.EXPRESS_DELIVERY, V.Express, Xo.PICKUP_DELIVERY, V.Pickup, Xo.PICKUP_EXPRESS_DELIVERY, V.PickupExpress;
var Ud = (e) => Hd[e], Wd = [Xo.PICKUP_DELIVERY, Xo.PICKUP_EXPRESS_DELIVERY], Gd = (e) => Wd.includes(e), Kd = Object.create, qd = Object.defineProperty, Jd = Object.getOwnPropertyDescriptor, Yd = Object.getOwnPropertyNames, Xd = Object.getPrototypeOf, Zd = Object.prototype.hasOwnProperty, Qd = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), $d = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = Yd(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !Zd.call(e, s) && s !== n && qd(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = Jd(t, s)) || r.enumerable
	});
	return e;
}, ef = (e, t, n) => (n = e == null ? {} : Kd(Xd(e)), $d(t || !e || !e.__esModule ? qd(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), W = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, G = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
W.Dhl, W.Instabox, W.PostNl, G.PostNl, W.Bpost, G.Bpost, W.CheapCargo, G.CheapCargo, W.Dpd, G.Dpd, W.Instabox, G.Instabox, W.Dhl, G.Dhl, W.Bol, G.Bol, W.Ups, G.Ups, W.DhlForYou, G.DhlForYou, W.DhlParcelConnect, G.DhlParcelConnect, W.DhlEuroPlus, G.DhlEuroPlus, W.UpsStandard, G.UpsStandard, W.UpsExpressSaver, G.UpsExpressSaver, W.Gls, G.Gls, W.Brt, G.Brt, W.Trunkrs, G.Trunkrs, W.InPost, G.InPost, W.PosteItaliane, G.PosteItaliane, W.Spring, G.Spring, W.ViaTim, G.ViaTim, W.PostNl, G.POSTNL, W.Bpost, G.BPOST, W.CheapCargo, G.CHEAP_CARGO, W.Dpd, G.DPD, W.Instabox, G.INSTABOX, W.Dhl, G.DHL, W.Bol, G.BOL, W.Ups, G.UPS, W.DhlForYou, G.DHL_FOR_YOU, W.DhlParcelConnect, G.DHL_PARCEL_CONNECT, W.DhlEuroPlus, G.DHL_EUROPLUS, W.UpsStandard, G.UPS_STANDARD, W.UpsExpressSaver, G.UPS_EXPRESS_SAVER, W.Gls, G.GLS, W.Brt, G.BRT, W.Trunkrs, G.TRUNKRS, W.InPost, G.INPOST, W.PosteItaliane, G.POSTE_ITALIANE, W.Spring, G.SPRING, W.ViaTim, G.VIA_TIM, G.PostNl, W.PostNl, G.POSTNL, W.PostNl, G.Bpost, W.Bpost, G.BPOST, W.Bpost, G.CheapCargo, W.CheapCargo, G.CHEAP_CARGO, W.CheapCargo, G.Dpd, W.Dpd, G.DPD, W.Dpd, G.Instabox, W.Instabox, G.Dhl, W.Dhl, G.BolCom, W.Bol, G.Bol, W.Bol, G.BOL, W.Bol, G.Ups, W.Ups, G.DhlForYou, W.DhlForYou, G.DHL_FOR_YOU, W.DhlForYou, G.DhlParcelConnect, W.DhlParcelConnect, G.DHL_PARCEL_CONNECT, W.DhlParcelConnect, G.DhlEuroPlus, W.DhlEuroPlus, G.DHL_EUROPLUS, W.DhlEuroPlus, G.UpsStandard, W.UpsStandard, G.UPS_STANDARD, W.UpsStandard, G.UpsExpressSaver, W.UpsExpressSaver, G.UPS_EXPRESS_SAVER, W.UpsExpressSaver, G.Gls, W.Gls, G.GLS, W.Gls, G.Brt, W.Brt, G.BRT, W.Brt, G.Trunkrs, W.Trunkrs, G.TRUNKRS, W.Trunkrs, G.InPost, W.InPost, G.INPOST, W.InPost, G.PosteItaliane, W.PosteItaliane, G.POSTE_ITALIANE, W.PosteItaliane, G.Spring, W.Spring, G.SPRING, W.Spring, G.ViaTim, W.ViaTim, G.VIA_TIM, W.ViaTim, W.PostNl, W.Bpost, W.CheapCargo, W.Dpd, W.Instabox, W.Dhl, W.Bol, W.Ups, W.DhlForYou, W.DhlParcelConnect, W.DhlEuroPlus, W.UpsStandard, W.UpsExpressSaver, W.Gls, W.Brt, W.Trunkrs, W.InPost, W.PosteItaliane, W.ViaTim;
var K = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
K.Austria, K.Belgium, K.Bulgaria, K.Croatia, K.Cyprus, K.CzechRepublic, K.Denmark, K.Estonia, K.Finland, K.France, K.Germany, K.Greece, K.Hungary, K.Ireland, K.Italy, K.Latvia, K.Lithuania, K.Luxembourg, K.Malta, K.Netherlands, K.Poland, K.Portugal, K.Romania, K.Slovakia, K.Slovenia, K.Spain, K.Sweden, Object.values(K), K.Angola, K.AntiguaAndBarbuda, K.Aruba, K.Bahamas, K.Belize, K.Benin, K.Bermuda, K.BonaireSintEustatiusAndSaba, K.Botswana, K.BurkinaFaso, K.Burundi, K.Cameroon, K.CanaryIslands, K.CentralAfricanRepublic, K.Comoros, K.CongoBrazzaville, K.CongoKinshasa, K.CoteDIvoire, K.Curacao, K.Djibouti, K.Dominica, K.DutchAntilles, K.EquatorialGuinea, K.Eritrea, K.Fiji, K.Gabon, K.Gambia, K.Ghana, K.Grenada, K.Guyana, K.HongKong, K.Kiribati, K.KoreaPeoplesDemocraticRepublic, K.Macao, K.Malawi, K.Mali, K.Mauritania, K.Nauru, K.Qatar, K.Rwanda, K.SaintKittsAndNevis, K.SaoTomeAndPrincipe, K.Seychelles, K.SierraLeone, K.SintMaarten, K.Suriname, K.SyrianArabRepublic, K.TimorLeste, K.Togo, K.Tonga, K.Tuvalu, K.Uganda, K.UnitedArabEmirates, K.Vanuatu, K.Yemen, K.Zimbabwe, K.Austria, K.Belgium, K.Bulgaria, K.Croatia, K.CzechRepublic, K.Estonia, K.Finland, K.France, K.Germany, K.Greece, K.Hungary, K.Ireland, K.Italy, K.Latvia, K.Lithuania, K.Luxembourg, K.Malta, K.Netherlands, K.Portugal, K.Romania, K.Slovakia, K.Slovenia, K.Spain, K.UnitedKingdom, K.Denmark, K.Germany, K.Sweden;
var tf = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, nf = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, rf = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
tf.EarlyMorning, nf.EarlyMorning, tf.Morning, nf.Morning, tf.Standard, nf.Standard, tf.Evening, nf.Evening, tf.Pickup, nf.Pickup, tf.PickupExpress, nf.PickupExpress, tf.SameDayDelivery, nf.SameDayDelivery, tf.Express, nf.Express, nf.EarlyMorning, tf.EarlyMorning, nf.Morning, tf.Morning, nf.Standard, tf.Standard, nf.Evening, tf.Evening, nf.Pickup, tf.Pickup, nf.PickupExpress, tf.PickupExpress, nf.SameDayDelivery, tf.SameDayDelivery, nf.Express, tf.Express, tf.EarlyMorning, rf.EarlyMorning, tf.Morning, rf.Morning, tf.Standard, rf.Standard, tf.Evening, rf.Evening, tf.Pickup, rf.Pickup, tf.PickupExpress, rf.PickupExpress, tf.SameDayDelivery, rf.SameDayDelivery, tf.Express, rf.Express, rf.EarlyMorning, nf.EarlyMorning, rf.Morning, nf.Morning, rf.Standard, nf.Standard, rf.Evening, nf.Evening, rf.Pickup, nf.Pickup, rf.PickupExpress, nf.PickupExpress, rf.SameDayDelivery, nf.SameDayDelivery, rf.Express, nf.Express, tf.EarlyMorning, tf.Morning, tf.Standard, tf.Evening, tf.Pickup, tf.PickupExpress, tf.SameDayDelivery, tf.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var af = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, of = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
of.Sunday, af.Sunday, of.Monday, af.Monday, of.Tuesday, af.Tuesday, of.Wednesday, af.Wednesday, of.Thursday, af.Thursday, of.Friday, af.Friday, of.Saturday, af.Saturday, af.Sunday, of.Sunday, af.Monday, of.Monday, af.Tuesday, of.Tuesday, af.Wednesday, of.Wednesday, af.Thursday, of.Thursday, af.Friday, of.Friday, af.Saturday, of.Saturday;
var sf = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
sf.Bytes, sf.Kilobytes, sf.Megabytes, sf.Gigabytes, sf.Terabytes;
var cf = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, lf = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
cf.Bol, lf.Bol, cf.Exact, lf.Exact, cf.Amazon, lf.Amazon, cf.Wix, lf.Wix, cf.ExactDe, lf.ExactDe, cf.Etsy, lf.Etsy, lf.Bol, cf.Bol, lf.Exact, cf.Exact, lf.Amazon, cf.Amazon, lf.Wix, cf.Wix, lf.ExactDe, cf.ExactDe, lf.Etsy, cf.Etsy;
var q = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, uf = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
q.Unpaid, uf.Unpaid, q.Due, uf.Due, q.DuePrepayment, uf.DuePrepayment, q.Reminder1, uf.Reminder1, q.Reminder2, uf.Reminder2, q.Dun, uf.Dun, q.Collection, uf.Collection, q.Instalments, uf.Instalments, q.PaymentArrangement, uf.PaymentArrangement, q.Dispute, uf.Dispute, q.LegalProcedure, uf.LegalProcedure, q.Insolvency, uf.Insolvency, q.WriteOff, uf.WriteOff, q.Pending, uf.Pending, q.Cancelled, uf.Cancelled, q.Paid, uf.Paid, q.PaidOnline, uf.PaidOnline, q.PaidAutomatic, uf.PaidAutomatic, q.PaidCredit, uf.PaidCredit, q.PaidZeroItems, uf.PaidZeroItems, q.InvoiceWith0InvoiceItemsPaidZeroBalance, uf.PaidZeroBalance, q.Due, q.Reminder1, q.Reminder2, q.Dun, q.Collection, q.Instalments, q.PaymentArrangement, q.Dispute, q.Paid, q.PaidOnline, q.PaidAutomatic, q.PaidCredit, q.PaidZeroItems;
var df = {
	Gram: "g",
	Kilogram: "kg"
};
df.Gram, df.Kilogram;
var ff = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
ff.Millimeter, ff.Centimeter, ff.Meter;
var pf = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, mf = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
mf.PendingConcept, mf.PendingRegistered, mf.EnRouteHandedToCarrier, mf.EnRouteSorting, mf.EnRouteDistribution, mf.EnRouteCustoms, mf.DeliveredReadyForPickup, mf.DeliveredAtRecipient, mf.DeliveredPackagePickedUp;
var hf = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, gf = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
gf.Light, hf.Light, gf.Start, hf.Start, gf.Plus, hf.Plus, gf.Premium, hf.Premium, gf.Max, hf.Max, hf.Light, gf.Light, hf.Start, gf.Start, hf.Plus, gf.Plus, hf.Premium, gf.Premium, hf.Max, gf.Max;
var _f = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, vf = {
	Start: hf.Start,
	Plus: hf.Plus,
	Premium: hf.Premium,
	Max: hf.Max
};
_f.Start, vf.Start, _f.Plus, vf.Plus, _f.Premium, vf.Premium, _f.Max, vf.Max, vf.Start, _f.Start, vf.Plus, _f.Plus, vf.Premium, _f.Premium, vf.Max, _f.Max;
var yf = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, bf = {
	Start: hf.Start,
	Plus: hf.Plus,
	Premium: hf.Premium,
	Max: hf.Max
};
yf.Start, bf.Start, yf.Plus, bf.Plus, yf.Premium, bf.Premium, yf.Max, bf.Max, bf.Start, yf.Start, bf.Plus, yf.Plus, bf.Premium, yf.Premium, bf.Max, yf.Max;
var xf = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, Sf = {
	Light: hf.Light,
	Start: hf.Start,
	Plus: hf.Plus,
	Premium: hf.Premium,
	Max: hf.Max
};
xf.Light, Sf.Light, xf.Start, Sf.Start, xf.Plus, Sf.Plus, xf.Premium, Sf.Premium, xf.Max, Sf.Max, Sf.Light, xf.Light, Sf.Start, xf.Start, Sf.Plus, xf.Plus, Sf.Premium, xf.Premium, Sf.Max, xf.Max;
var Cf = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, wf = {
	Start: hf.Start,
	Plus: hf.Plus,
	Premium: hf.Premium,
	Max: hf.Max
};
Cf.Start, wf.Start, Cf.Plus, wf.Plus, Cf.Premium, wf.Premium, Cf.Max, wf.Max, wf.Start, Cf.Start, wf.Plus, Cf.Plus, wf.Premium, Cf.Premium, wf.Max, Cf.Max;
var Tf = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Ef = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Df = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
Tf.MyParcel, Ef.MyParcel, Tf.Flespakket, Ef.Flespakket, Tf.SendMyParcel, Ef.SendMyParcel, Tf.MyParcelIt, Ef.MyParcelIt, Tf.DeliverDutch, Ef.DeliverDutch, Tf.PostNlPlugin, Ef.PostNlPlugin, Tf.MyParcel, Df.MyParcelNl, Tf.Flespakket, Df.MyParcelNl, Tf.SendMyParcel, Df.MyParcelBe, Tf.MyParcelIt, Df.MyParcelIt, Tf.DeliverDutch, Df.DeliverDutch, Tf.PostNlPlugin, Df.PostNlPlugin, Df.MyParcelNl, Tf.MyParcel, Df.MyParcelBe, Tf.SendMyParcel, Df.MyParcelIt, Tf.MyParcelIt, Df.MyParcelNl, pf.HomeCountry, K.Netherlands, pf.Eu, pf.Row, K.Belgium, Df.MyParcelBe, pf.HomeCountry, K.Belgium, K.Netherlands, pf.Eu, pf.Row, Df.MyParcelBe, pf.HomeCountry, K.Belgium, pf.Eu, pf.Row, Df.MyParcelNl, pf.HomeCountry, K.Netherlands, pf.Eu, pf.Row, Df.MyParcelNl, pf.HomeCountry, K.Netherlands, K.Belgium, K.Luxembourg, W.Bpost, W.PostNl, W.DhlForYou, W.DhlParcelConnect, W.DhlEuroPlus, W.Ups, W.UpsStandard, W.UpsExpressSaver;
var J = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Of = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
J.Package, Of.Package, J.Mailbox, Of.Mailbox, J.Letter, Of.Letter, J.DigitalStamp, Of.DigitalStamp, J.Pallet, Of.Pallet, J.PackageSmall, Of.PackageSmall, J.Envelope, Of.Envelope, Of.Package, J.Package, Of.Mailbox, J.Mailbox, Of.Letter, J.Letter, Of.DigitalStamp, J.DigitalStamp, Of.Pallet, J.Pallet, Of.PackageSmall, J.PackageSmall, Of.Envelope, J.Envelope;
var kf = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
J.Package, kf.PACKAGE, J.Mailbox, kf.MAILBOX, J.Letter, kf.UNFRANKED, J.DigitalStamp, kf.DIGITAL_STAMP, J.Pallet, kf.PALLET, J.PackageSmall, kf.SMALL_PACKAGE, J.Envelope, kf.ENVELOPE, kf.PACKAGE, J.Package, kf.MAILBOX, J.Mailbox, kf.UNFRANKED, J.Letter, kf.DIGITAL_STAMP, J.DigitalStamp, kf.PALLET, J.Pallet, kf.SMALL_PACKAGE, J.PackageSmall, kf.ENVELOPE, J.Envelope, J.Package, J.Mailbox, J.Letter, J.DigitalStamp, J.Pallet, J.PackageSmall, J.Envelope;
var Af = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
Af.PendingConcept, Af.PendingRegistered, Af.EnrouteHandedToCarrier, Af.EnrouteSorting, Af.EnrouteDistribution, Af.DeliveredAtCustoms, Af.DeliveredAtRecipient, Af.DeliveredPackagePickedUp, Af.DeliveredReturnShipmentPackagePickedUp, Af.DeliveredAtAgreedLocation, Af.PrintedLetter, Af.PrintedDigitalStamp, Af.InactiveConcept, Af.InactiveRegistered, Af.InactiveEnrouteHandedToCarrier, Af.InactiveEnrouteSorting, Af.InactiveEnrouteDistribution, Af.InactiveEnrouteCustoms, Af.InactiveDeliveredAtRecipient, Af.InactiveDeliveredReadyForPickup, Af.InactiveDeliveredPackagePickedUp;
var jf = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var ee = "$isDayjsObject", te = function(e) {
			return e instanceof re || !(!e || !e[ee]);
		}, ne = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, x = function(e, t) {
			if (te(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new re(n);
		}, S = v;
		S.l = ne, S.i = te, S.w = function(e, t) {
			return x(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var re = function() {
			function g(e) {
				this.$L = ne(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[ee] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (S.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return S;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = x(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return x(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < x(e);
			}, _.$g = function(e, t, n) {
				return S.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!S.u(t) || t, u = S.p(e), p = function(e, t) {
					var i = S.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return S.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = S.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[S.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = S.p(u), h = function(e) {
					var t = x(p);
					return S.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return S.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return S.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return S.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return S.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return S.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return S.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return S.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return S.s(t.$s, 2, "0");
							case "SSS": return S.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = S.p(f), _ = x(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return S.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : S.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = ne(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return S.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), ie = re.prototype;
		return x.prototype = ie, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			ie[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), x.extend = function(e, t) {
			return e.$i ||= (e(t, re, x), !0), x;
		}, x.locale = ne, x.isDayjs = te, x.unix = function(e) {
			return x(1e3 * e);
		}, x.en = b[y], x.Ls = b, x.p = {}, x;
	}));
})), Mf = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(jf()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Nf = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(jf()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_it = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Pf = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(jf()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Ff = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), If = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, v = c || 0, y = l || 0, b = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, v, y, b + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, v, y, b)) : new Date(h, g, m, _, v, y, b);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), Lf = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), Rf = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), zf = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), Bf = /* @__PURE__ */ Qd(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
Mf(), Nf(), Pf();
var Vf = /* @__PURE__ */ ef(jf(), 1), Hf = /* @__PURE__ */ ef(Ff(), 1), Uf = /* @__PURE__ */ ef(If(), 1), Wf = /* @__PURE__ */ ef(Lf(), 1), Gf = /* @__PURE__ */ ef(Rf(), 1), Kf = /* @__PURE__ */ ef(zf(), 1), qf = /* @__PURE__ */ ef(Bf(), 1);
Vf.default.extend(Uf.default), Vf.default.extend(Gf.default), Vf.default.extend(Hf.default), Vf.default.extend(qf.default), Vf.default.extend(Wf.default), Vf.default.extend(Kf.default), Vf.default.locale("nl"), Vf.default.tz.setDefault("Europe/Amsterdam"), Vf.default, Object.values(Zo).filter((e) => e !== Zo.DISCOVERED);
var Jf = (e) => e === Zo.DISCOVERED || e === Zo.IMPORT_REQUESTED;
Object.values(Zo).filter((e) => !Jf(e));
//#endregion
//#region src/utils/properties/packageType.ts
var Yf = (e) => e === Qo.ENVELOPE, Xf = (e) => e === Qo.PACKAGE, Zf = (e) => e === Qo.SMALL_PACKAGE, Qf = (e) => e === Qo.MAILBOX, $f = (e) => e === Qo.DIGITAL_STAMP, ep = (e) => e === Qo.UNFRANKED, tp = (e) => e === Qo.PALLET, np = (e) => e === L.POSTNL, rp = (e, t) => np(e) && t !== null && t === ft.Cd, ip = (e, t) => np(e) && t !== null && t !== ft.Cd, ap = (e) => e === L.BPOST, op = (e) => e === L.CHEAP_CARGO, sp = (e) => e === L.DPD, cp = (e) => e === L.DHL_PARCEL_CONNECT, lp = (e) => e === L.DHL_FOR_YOU, up = (e) => e === L.DHL_EUROPLUS, dp = (e) => lp(e) || up(e) || cp(e), fp = (e, t) => dp(e) && Zf(t), pp = (e) => e === L.BOL, mp = (e) => e === "UPS", hp = (e) => e === L.UPS_STANDARD, gp = (e) => e === L.UPS_EXPRESS_SAVER, _p = (e) => hp(e) || gp(e), vp = (e) => e === L.GLS, yp = (e) => e === L.BRT, bp = (e) => e === L.TRUNKRS, xp = (e) => e === L.INPOST, Sp = (e) => e === L.POSTE_ITALIANE, Cp = {
	[T.PostNl]: L.POSTNL,
	[T.Bpost]: L.BPOST,
	[T.CheapCargo]: L.CHEAP_CARGO,
	[T.Dpd]: L.DPD,
	[T.Bol]: L.BOL,
	[T.DhlForYou]: L.DHL_FOR_YOU,
	[T.DhlParcelConnect]: L.DHL_PARCEL_CONNECT,
	[T.DhlEuroPlus]: L.DHL_EUROPLUS,
	[T.UpsStandard]: L.UPS_STANDARD,
	[T.UpsExpressSaver]: L.UPS_EXPRESS_SAVER,
	[T.Gls]: L.GLS,
	[T.Brt]: L.BRT,
	[T.Trunkrs]: L.TRUNKRS,
	[T.InPost]: L.INPOST,
	[T.PosteItaliane]: L.POSTE_ITALIANE,
	[T.ViaTim]: L.VIA_TIM
};
T.Ups, T.Dhl, T.Instabox;
var wp = (e) => Cp[e], Tp = {
	[L.POSTNL]: T.PostNl,
	[L.BPOST]: T.Bpost,
	[L.CHEAP_CARGO]: T.CheapCargo,
	[L.DPD]: T.Dpd,
	[L.BOL]: T.Bol,
	[L.DHL_FOR_YOU]: T.DhlForYou,
	[L.DHL_PARCEL_CONNECT]: T.DhlParcelConnect,
	[L.DHL_EUROPLUS]: T.DhlEuroPlus,
	[L.UPS_STANDARD]: T.UpsStandard,
	[L.UPS_EXPRESS_SAVER]: T.UpsExpressSaver,
	[L.GLS]: T.Gls,
	[L.BRT]: T.Brt,
	[L.TRUNKRS]: T.Trunkrs,
	[L.INPOST]: T.InPost,
	[L.POSTE_ITALIANE]: T.PosteItaliane,
	[L.VIA_TIM]: T.ViaTim
}, Ep = (e) => Tp[e];
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.50.0/node_modules/es-toolkit/dist/string/capitalize.mjs
function Dp(e) {
	return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
}
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.50.0/node_modules/es-toolkit/dist/string/words.mjs
var Op = /\p{Lu}?\p{Ll}+|[0-9]+|\p{Lu}+(?!\p{Ll})|\p{Emoji_Presentation}|\p{Extended_Pictographic}|\p{L}+/gu;
function kp(e) {
	return Array.from(e.match(Op) ?? []);
}
//#endregion
//#region ../../node_modules/.pnpm/es-toolkit@1.50.0/node_modules/es-toolkit/dist/string/camelCase.mjs
function Ap(e) {
	let t = kp(e);
	if (t.length === 0) return "";
	let [n, ...r] = t;
	return `${n.toLowerCase()}${r.map((e) => Dp(e)).join("")}`;
}
//#endregion
//#region src/composables/useDeliveryOptions/useDeliveryOptions.ts
var jp = () => ({
	fetchDeliveryOptions: (e) => {
		let { sdk: t } = Pe();
		return t.getDeliveryOptions({ parameters: {
			include: "price",
			monday_delivery: 1,
			dropoff_days: "0;1;2;3;4;5;6",
			...e
		} });
	},
	postponedDeliveryDateMessage: (e, t) => {
		let n;
		if (!(!np(e) && !lp(e)) && (t?.deliveryType && Gr(t.deliveryType) ? n = "morning" : t?.deliveryType && Kr(t.deliveryType) && (n = "evening"), n)) return `shipping.adjustedDelivery.notification.${Ap(e)}.${n}Delivery`;
	},
	postponedNormalMessage: (e) => {
		let t = e?.date;
		if (!t) return;
		let n = Wr(t), r = Wr().add(1, "days");
		return n.isAfter(r, "day") ? "shipping.adjustedDelivery.notification.normal.postponed" : void 0;
	}
});
//#endregion
//#region src/composables/usePickupLocations/usePickupLocations.ts
function Mp() {
	return { fetchPickupLocations: (e) => {
		let { sdk: t } = Pe();
		return t.getPickupLocations({ parameters: e });
	} };
}
//#endregion
//#region src/composables/useAdjustedDelivery/useAdjustedDelivery.ts
function Np() {
	let { fetchDeliveryOptions: e } = jp(), { fetchPickupLocations: t } = Mp(), n = (e) => Xe.includes(e), r = (e) => e === D.Belgium || e === D.Netherlands, i = (e, t) => r(e) ? {
		street: e === D.Belgium && np(t) || cp(t),
		city: ap(t) || sp(t) || cp(t),
		postalCode: !cp(t)
	} : {
		street: !0,
		city: !0,
		postalCode: !0
	};
	return {
		getVisibleFields: i,
		getRequiredFields: (e, t) => {
			if (!r(e)) return {
				postalCode: !1,
				houseNumber: !1,
				street: !1,
				city: !1
			};
			let { street: n, city: a, postalCode: o } = i(e, t);
			return {
				postalCode: o,
				houseNumber: !0,
				street: n,
				city: a
			};
		},
		isPudo: n,
		getAdjustedDeliveryData: (n, r) => {
			let a = { ...n }, o = We(a.carrier), s = i(a.cc, o);
			s.city || delete a.city, s.street || delete a.street, s.postalCode || delete a.postal_code;
			let c = Object.fromEntries(Object.entries(a).filter(([e, t]) => t != null));
			return r === "delivery" ? e(c) : t(c);
		}
	};
}
//#endregion
//#region src/components/AdjustedDeliveryOption/AdjustedDeliveryOption.vue?vue&type=script&setup=true&lang.ts
var Pp = { key: 0 }, Fp = { key: 1 }, Ip = "D MMMM YYYY", Lp = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryOption",
	props: {
		title: {},
		countryCode: {},
		option: {}
	},
	setup(e) {
		let n = e, { t: a, locale: o } = Me(), { isPudo: l } = Np(), u = (e, t) => Wr(e).locale(o.value).format(t), d = t(() => n.option.date ? u(n.option.date, Ip) : ""), p = t(() => !l(n.countryCode) && Jr(n.option.deliveryType));
		return (t, n) => (f(), i("div", null, [
			c(y(ge), {
				class: "text-black",
				level: "4"
			}, {
				default: x(() => [s(v(y(a)(e.title)) + ": ", 1)]),
				_: 1
			}),
			e.option.location?.name ? (f(), i("p", Pp, v(e.option.location.name), 1)) : r("", !0),
			p.value && d.value ? (f(), i("p", Fp, v(d.value) + " - " + v(y(a)(`shipping.deliveryType.${y(rt)(e.option.deliveryType)}`)), 1)) : r("", !0)
		]));
	}
}), Rp = {
	Normal: "0 0 16 16",
	Medium: "0 0 24 24",
	MediumLarge: "0 0 32 32",
	Large: "0 0 48 48",
	Social: "0 0 50 50",
	XLarge: "0 0 88 88",
	XXLarge: "0 0 200 200"
}, zp = {
	Normal: 16,
	Medium: 24,
	MediumLarge: 32,
	Large: 48,
	Social: 50,
	XLarge: 88,
	XXLarge: 200
}, Bp = [
	"aria-label",
	"height",
	"role",
	"viewBox",
	"width"
], Vp = /* @__PURE__ */ l({
	__name: "IconBase",
	props: {
		width: { default: void 0 },
		height: { default: void 0 },
		viewbox: { default: void 0 },
		size: { default: zp.Normal },
		ariaLabel: { default: void 0 }
	},
	setup(e) {
		let n = b(), r = e, a = Object.entries(zp).find(([, e]) => e === r.size)[0], o = t(() => String(r.height ?? zp[a])), s = t(() => String(r.width ?? zp[a])), c = t(() => String(r.viewbox ?? Rp[a])), l = t(() => r.ariaLabel ? "img" : "presentation");
		return (t, r) => (f(), i("svg", {
			"aria-label": e.ariaLabel,
			class: d(y(zn)("align-baseline inline-block overflow-visible", y(n).class)),
			height: o.value,
			role: l.value,
			viewBox: c.value,
			width: s.value,
			xmlns: "http://www.w3.org/2000/svg"
		}, [g(t.$slots, "default")], 10, Bp));
	}
}), Hp = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, Up = {};
function Wp(t, n) {
	return f(), i(e, null, [n[0] ||= a("path", {
		d: "M16.2347 18.7383C16.2347 18.7383 21.2379 17.4919 22 18C22.7621 18.5081 23.254 18.9919 23 19.5C22.746 20.0081 15.5405 23.5 13 23.5C10.4595 23.5 7.52428 22.5 6 22.5C5.09633 22.5 3.85827 22.5 2.99991 22.5C2.44763 22.5 2 22.0523 2 21.5V17.3015C2 16.8331 2.32352 16.428 2.78153 16.3298C4.11303 16.0443 6.75027 15.5 7.5 15.5C8.51619 15.5 11.4919 17.5 12 17.5C12.5081 17.5 13.9838 17.5 15 17.5C16.0162 17.5 16.2347 18.7383 16.2347 18.7383ZM16.2347 18.7383C16.2347 18.7383 14.0162 20.5 13 20.5C11.9838 20.5 10 19.5 10 19.5",
		fill: "none",
		stroke: "currentColor",
		"stroke-linecap": "round"
	}, null, -1), n[1] ||= a("path", {
		"clip-rule": "evenodd",
		d: "M16.1286 0.23944C15.7297 0.0553592 15.2703 0.055359 14.8714 0.23944L9.37141 2.7779C8.84019 3.02308 8.5 3.55476 8.5 4.13984V11.8602C8.5 12.4453 8.84019 12.9769 9.37141 13.2221L14.8714 15.7606C15.2703 15.9447 15.7297 15.9447 16.1286 15.7606L21.6286 13.2221C22.1598 12.9769 22.5 12.4453 22.5 11.8602V4.13984C22.5 3.55476 22.1598 3.02308 21.6286 2.7779L16.1286 0.23944ZM15.2905 1.1474C15.4234 1.08604 15.5766 1.08604 15.7095 1.1474L20.8069 3.50003L18.8493 4.40352C18.7802 4.35602 18.7064 4.31394 18.6286 4.27801L13.568 1.94237L15.2905 1.1474ZM12.3749 2.49306L10.1931 3.50003L15.2905 5.85267C15.4234 5.91403 15.5766 5.91403 15.7095 5.85267L17.6818 4.9424L12.3749 2.49306ZM18.5 5.66613L16.1286 6.76063C16.0864 6.78012 16.0434 6.79755 16 6.81291V14.7186L21.2095 12.3142C21.3866 12.2324 21.5 12.0552 21.5 11.8602V4.28151L19.4432 5.23081C19.4804 5.36196 19.5 5.49942 19.5 5.63995V7.50012C19.5 7.77626 19.2761 8.00012 19 8.00012C18.7239 8.00012 18.5 7.77626 18.5 7.50012V5.66613ZM9.5 4.28151V11.8602C9.5 12.0552 9.6134 12.2324 9.79047 12.3142L15 14.7186V6.81291C14.9566 6.79755 14.9136 6.78012 14.8714 6.76063L9.5 4.28151Z",
		fill: "currentColor",
		"fill-rule": "evenodd"
	}, null, -1)], 64);
}
var Gp = /*#__PURE__*/ Hp(Up, [["render", Wp]]), Kp = {}, qp = {
	d: "M3.97679 22.3652C3.17927 22.3652 2.54585 22.0468 2.07653 21.4099C1.60741 20.7728 1.46849 20.0676 1.65976 19.2943L3.92425 10.5398C3.28277 10.3146 2.73274 9.88471 2.27417 9.25006C1.8156 8.61541 1.58631 7.88474 1.58631 7.05806C1.58631 6.04466 1.93711 5.17713 2.6387 4.45547C3.34029 3.73381 4.18369 3.37298 5.1689 3.37298H13.5283C14.2497 3.37298 14.7949 3.68714 15.1637 4.31544C15.5325 4.94375 15.5561 5.58863 15.2345 6.2501L13.5811 9.65173C13.4048 9.98257 13.1684 10.2472 12.872 10.4456C12.5757 10.6439 12.2433 10.7431 11.8749 10.7431H8.81357L8.37023 12.4674H8.45293C8.71466 12.4832 8.93708 12.5839 9.12018 12.7696C9.3031 12.9553 9.39455 13.1853 9.39455 13.4596V15.1606C9.39455 15.4417 9.3021 15.6773 9.1172 15.8675C8.9323 16.0575 8.70321 16.1525 8.42994 16.1525H7.41488L6.28965 20.5841C6.14336 21.1105 5.85755 21.5389 5.43222 21.8693C5.00688 22.1999 4.52174 22.3652 3.97679 22.3652ZM3.9747 21.1369C4.25335 21.1369 4.49219 21.055 4.69122 20.8912C4.89025 20.7274 5.02957 20.5125 5.10919 20.2463L7.57579 10.7431H5.09784L2.81036 19.6014C2.71085 19.9904 2.78051 20.3436 3.01935 20.6609C3.25819 20.9782 3.57664 21.1369 3.9747 21.1369ZM5.1689 9.51477H11.8749C12.0126 9.51477 12.1427 9.47536 12.2651 9.39654C12.3877 9.31793 12.4796 9.21557 12.5407 9.08945L14.1943 5.68782C14.3167 5.43601 14.3052 5.19198 14.1597 4.95572C14.0144 4.71947 13.8039 4.60134 13.5283 4.60134H5.1689C4.51209 4.60134 3.94982 4.8419 3.4821 5.323C3.01437 5.80411 2.78051 6.38246 2.78051 7.05806C2.78051 7.73365 3.01437 8.31201 3.4821 8.79311C3.94982 9.27422 4.51209 9.51477 5.1689 9.51477ZM18.282 4.17602L17.8112 3.10827L21.5431 1.36523L22.007 2.44005L18.282 4.17602ZM21.5431 12.7509L17.8112 11.0385L18.282 9.96374L22.007 11.7068L21.5431 12.7509ZM18.443 7.64859V6.46753H22.5767V7.64859H18.443Z",
	fill: "currentColor"
};
function Jp(e, t) {
	return f(), i("path", qp);
}
var Yp = /*#__PURE__*/ Hp(Kp, [["render", Jp]]), Xp = {}, Zp = {
	"clip-rule": "evenodd",
	d: "M0.169434 5.54443C0.169434 4.78504 0.785042 4.16943 1.54443 4.16943H12.6339C13.3491 4.16943 13.9368 4.71543 14.0028 5.41333C14.1918 5.3155 14.4064 5.26024 14.6339 5.26024H17.4309C17.9139 5.26024 18.3614 5.51365 18.6099 5.92781L21.4412 10.6466C21.5023 10.7485 21.5913 10.8309 21.6976 10.884L23.0659 11.5682C23.5318 11.8011 23.826 12.2772 23.826 12.798V16.634C23.826 17.3933 23.2104 18.009 22.451 18.009H21.6172C21.4358 19.2431 20.3725 20.1905 19.088 20.1905C17.7854 20.1905 16.7104 19.2164 16.5516 17.9569C16.4957 17.99 16.4305 18.009 16.3609 18.009H13.6339L13.6302 18.0089H8.52778C8.34637 19.2431 7.28308 20.1905 5.99851 20.1905C4.71395 20.1905 3.65065 19.2431 3.46924 18.0089L1.54443 18.0089C0.785042 18.0089 0.169434 17.3933 0.169434 16.6339V5.54443ZM16.5516 17.311C16.7103 16.0515 17.7854 15.0773 19.088 15.0773C20.3726 15.0773 21.4359 16.0248 21.6173 17.259H22.451C22.7962 17.259 23.076 16.9791 23.076 16.634V12.798C23.076 12.5613 22.9423 12.3449 22.7305 12.239L21.3622 11.5548C21.3083 11.5279 21.2565 11.4976 21.207 11.4641H16.8156C16.0562 11.4641 15.4406 10.8485 15.4406 10.0891V8.81673C15.4406 8.05734 16.0562 7.44173 16.8156 7.44173H18.6436L17.9668 6.31368C17.8539 6.12543 17.6504 6.01024 17.4309 6.01024H14.6339C14.2913 6.01024 14.013 6.28594 14.0089 6.6276V17.259H16.3609C16.4305 17.259 16.4957 17.2779 16.5516 17.311ZM20.8945 17.6254C20.89 16.6316 20.0829 15.8273 19.088 15.8273C18.0902 15.8273 17.2814 16.6362 17.2814 17.6339C17.2814 18.6317 18.0902 19.4405 19.088 19.4405C20.0829 19.4405 20.8899 18.6363 20.8945 17.6425C20.8945 17.6396 20.8944 17.6368 20.8944 17.634C20.8944 17.6311 20.8945 17.6283 20.8945 17.6254ZM7.80498 17.6339L7.80507 17.6254C7.80047 16.6316 6.99341 15.8273 5.99851 15.8273C5.00076 15.8273 4.19193 16.6362 4.19193 17.6339C4.19193 18.6317 5.00076 19.4405 5.99851 19.4405C6.9934 19.4405 7.80045 18.6363 7.80507 17.6425L7.80498 17.6339ZM13.2589 17.2589H8.52779C8.34639 16.0247 7.28309 15.0773 5.99851 15.0773C4.71393 15.0773 3.65063 16.0247 3.46923 17.2589L1.54443 17.2589C1.19926 17.2589 0.919434 16.9791 0.919434 16.6339V5.54443C0.919434 5.19926 1.19926 4.91943 1.54443 4.91943H12.6339C12.9791 4.91943 13.2589 5.19926 13.2589 5.54443V6.6239L13.2589 6.63524V17.2589ZM19.0936 8.19169L19.088 8.19173H16.8156C16.4705 8.19173 16.1906 8.47156 16.1906 8.81673V10.0891C16.1906 10.4343 16.4705 10.7141 16.8156 10.7141H20.6071L19.0936 8.19169Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function Qp(e, t) {
	return f(), i("path", Zp);
}
var $p = /*#__PURE__*/ Hp(Xp, [["render", Qp]]), em = {};
function tm(t, n) {
	return f(), i(e, null, [
		n[0] ||= a("path", {
			"clip-rule": "evenodd",
			d: "M13.1286 1.23944C12.7297 1.05536 12.2703 1.05536 11.8714 1.23944L6.37141 3.7779C5.84019 4.02308 5.5 4.55476 5.5 5.13984V12.8602C5.5 13.4453 5.84019 13.9769 6.37141 14.2221L11.8714 16.7606C12.2703 16.9447 12.7297 16.9447 13.1286 16.7606L18.6286 14.2221C19.1598 13.9769 19.5 13.4453 19.5 12.8602V5.13984C19.5 4.55476 19.1598 4.02308 18.6286 3.7779L13.1286 1.23944ZM12.2905 2.1474C12.4234 2.08604 12.5766 2.08604 12.7095 2.1474L17.8069 4.50003L15.8493 5.40352C15.7802 5.35602 15.7064 5.31394 15.6286 5.27801L10.568 2.94237L12.2905 2.1474ZM9.37488 3.49306L7.1931 4.50003L12.2905 6.85267C12.4234 6.91403 12.5766 6.91403 12.7095 6.85267L14.6818 5.9424L9.37488 3.49306ZM15.5 6.66613L13.1286 7.76063C13.0864 7.78012 13.0434 7.79755 13 7.81291V15.7186L18.2095 13.3142C18.3866 13.2324 18.5 13.0552 18.5 12.8602V5.28151L16.4432 6.23081C16.4804 6.36196 16.5 6.49942 16.5 6.63995V8.50012C16.5 8.77626 16.2761 9.00012 16 9.00012C15.7239 9.00012 15.5 8.77626 15.5 8.50012V6.66613ZM6.5 5.28151V12.8602C6.5 13.0552 6.6134 13.2324 6.79047 13.3142L12 15.7186V7.81291C11.9566 7.79755 11.9136 7.78012 11.8714 7.76063L6.5 5.28151Z",
			fill: "currentColor",
			"fill-rule": "evenodd"
		}, null, -1),
		n[1] ||= a("path", {
			d: "M1 8C0.723858 8 0.5 8.22386 0.5 8.5C0.5 8.77614 0.723858 9 1 9V8ZM5 9H5.5V8H5V9ZM1 9H5V8H1V9Z",
			fill: "currentColor"
		}, null, -1),
		n[2] ||= a("path", {
			d: "M20 8H19.5V9H20V8ZM23 9C23.2761 9 23.5 8.77614 23.5 8.5C23.5 8.22386 23.2761 8 23 8V9ZM20 9H23V8H20V9Z",
			fill: "currentColor"
		}, null, -1),
		n[3] ||= a("path", {
			d: "M1 18.5H23",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[4] ||= a("path", {
			d: "M3 21.5C3 22.0523 2.55228 22.5 2 22.5C1.44772 22.5 1 22.0523 1 21.5C1 20.9477 1.44772 20.5 2 20.5C2.55228 20.5 3 20.9477 3 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[5] ||= a("path", {
			d: "M7 21.5C7 22.0523 6.55228 22.5 6 22.5C5.44772 22.5 5 22.0523 5 21.5C5 20.9477 5.44772 20.5 6 20.5C6.55228 20.5 7 20.9477 7 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[6] ||= a("path", {
			d: "M11 21.5C11 22.0523 10.5523 22.5 10 22.5C9.44772 22.5 9 22.0523 9 21.5C9 20.9477 9.44772 20.5 10 20.5C10.5523 20.5 11 20.9477 11 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[7] ||= a("path", {
			d: "M15 21.5C15 22.0523 14.5523 22.5 14 22.5C13.4477 22.5 13 22.0523 13 21.5C13 20.9477 13.4477 20.5 14 20.5C14.5523 20.5 15 20.9477 15 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[8] ||= a("path", {
			d: "M19 21.5C19 22.0523 18.5523 22.5 18 22.5C17.4477 22.5 17 22.0523 17 21.5C17 20.9477 17.4477 20.5 18 20.5C18.5523 20.5 19 20.9477 19 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1),
		n[9] ||= a("path", {
			d: "M23 21.5C23 22.0523 22.5523 22.5 22 22.5C21.4477 22.5 21 22.0523 21 21.5C21 20.9477 21.4477 20.5 22 20.5C22.5523 20.5 23 20.9477 23 21.5Z",
			fill: "none",
			stroke: "currentColor",
			"stroke-linecap": "round",
			"stroke-linejoin": "round"
		}, null, -1)
	], 64);
}
var nm = /*#__PURE__*/ Hp(em, [["render", tm]]), rm = {}, im = {
	"clip-rule": "evenodd",
	d: "M5.5 6.5C5.5 5.67157 6.17157 5 7 5H10C10.2761 5 10.5 4.77614 10.5 4.5C10.5 4.22386 10.2761 4 10 4H7C5.61929 4 4.5 5.11929 4.5 6.5V17.5C4.5 18.8807 5.61929 20 7 20H18C19.3807 20 20.5 18.8807 20.5 17.5V14.5C20.5 14.2239 20.2761 14 20 14C19.7239 14 19.5 14.2239 19.5 14.5V17.5C19.5 18.3284 18.8284 19 18 19H7C6.17157 19 5.5 18.3284 5.5 17.5V6.5ZM15 4C14.7239 4 14.5 4.22386 14.5 4.5C14.5 4.77614 14.7239 5 15 5H18.7929L11.6464 12.1464C11.4512 12.3417 11.4512 12.6583 11.6464 12.8536C11.8417 13.0488 12.1583 13.0488 12.3536 12.8536L19.5 5.70711V9.5C19.5 9.77614 19.7239 10 20 10C20.2761 10 20.5 9.77614 20.5 9.5V4.5C20.5 4.22386 20.2761 4 20 4H15Z",
	fill: "currentColor",
	"fill-rule": "evenodd"
};
function am(e, t) {
	return f(), i("path", im);
}
var om = /*#__PURE__*/ Hp(rm, [["render", am]]), sm = {}, cm = {
	fill: "none",
	height: "24",
	width: "24",
	xmlns: "http://www.w3.org/2000/svg"
};
function lm(e, t) {
	return f(), i("svg", cm, [...t[0] ||= [a("mask", {
		id: "a",
		height: "24",
		maskUnits: "userSpaceOnUse",
		style: { "mask-type": "alpha" },
		width: "24",
		x: "0",
		y: "0"
	}, [a("path", {
		d: "M0 0h24v24H0z",
		fill: "#D9D9D9"
	})], -1), a("g", { mask: "url(#a)" }, [a("path", {
		d: "m10.562 15.908 6.396-6.396-.708-.708-5.688 5.688-2.85-2.85-.708.708 3.558 3.558ZM12.003 21a8.772 8.772 0 0 1-3.51-.709 9.095 9.095 0 0 1-2.859-1.922 9.081 9.081 0 0 1-1.925-2.857A8.752 8.752 0 0 1 3 12.003c0-1.244.236-2.414.708-3.51a9.096 9.096 0 0 1 1.923-2.859 9.081 9.081 0 0 1 2.857-1.925A8.752 8.752 0 0 1 11.997 3c1.244 0 2.414.236 3.51.708a9.096 9.096 0 0 1 2.859 1.923 9.082 9.082 0 0 1 1.925 2.857A8.752 8.752 0 0 1 21 11.997a8.772 8.772 0 0 1-.709 3.51 9.095 9.095 0 0 1-1.922 2.859 9.082 9.082 0 0 1-2.857 1.925 8.752 8.752 0 0 1-3.509.709ZM12 20c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z",
		fill: "#1C1B1F"
	})], -1)]]);
}
var um = /*#__PURE__*/ Hp(sm, [["render", lm]]), dm = { class: "flex gap-x-2 items-center my-2" }, fm = { class: "first-letter:capitalize font-bold px-4 block" }, pm = { class: "flex justify-between leading-none w-full" }, mm = { class: "w-1/3" }, hm = { class: "w-1/3" }, gm = { class: "w-1/3" }, _m = /* @__PURE__ */ l({
	__name: "DeliveryOptionRadioGroup",
	props: /*@__PURE__*/ u({
		name: {},
		deliveryOptions: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let n = e, { t: r, locale: o } = Me(), s = (e) => `${Wr(e[0].date_time.date).format()} - ${Wr(e[1].date_time.date).format()}`, l = (e) => `${Wr(e[0].date_time.date).locale(o.value).format("HH:mm")} - ${Wr(e[1].date_time.date).locale(o.value).format("HH:mm")}`, u = (e) => d.value.find((t) => s(t.delivery_time_frames) === e), d = t(() => n.deliveryOptions.flatMap((e) => e.possibilities)), p = t(() => n.deliveryOptions.reduce((e, t) => {
			let n = [{
				isGroupLabel: !0,
				label: Wr(t.date.date).locale(o.value).format("dddd D MMMM"),
				value: t.date.date
			}], r = t.possibilities.map((e) => {
				let t = l(e.delivery_time_frames), n = s(e.delivery_time_frames);
				return {
					label: "",
					time: t,
					type: e.type,
					price: ai.currency.format(e?.price.amount),
					value: n
				};
			});
			return e.push(...n, ...r), e;
		}, [])), h = ee(e, "modelValue"), g = m("");
		return ne(h, (e) => {
			e ? g.value = s(e.deliveryTimeFrame) : g.value = "";
		}, { immediate: !0 }), ne(g, (e) => {
			let t = u(e);
			if (!t) {
				h.value = void 0;
				return;
			}
			h.value && s(h.value.deliveryTimeFrame) === e || (h.value = {
				deliveryTimeFrame: t.delivery_time_frames,
				type: t.type
			});
		}), (t, n) => (f(), i("div", null, [c(y(Te), {
			modelValue: g.value,
			"onUpdate:modelValue": n[0] ||= (e) => g.value = e,
			"active-class": "bg-gray-100",
			class: "gap-y-0 shrink border-0 border-b-1 rounded-none",
			name: e.name,
			options: p.value,
			"radio-class": "p-4 shrink items-start! border-b hover:bg-gray-100 focus:z-10"
		}, {
			groupLabel: x(({ option: e }) => [a("div", dm, [a("p", fm, v(e.label), 1)])]),
			default: x(({ option: e }) => [a("div", pm, [
				a("div", mm, v(e.time), 1),
				a("div", hm, v(y(r)(`shipping.adjustedDelivery.deliveryMoments.${y(Ap)(e.type)}`)), 1),
				a("div", gm, v(e.price), 1)
			])]),
			_: 1
		}, 8, [
			"modelValue",
			"name",
			"options"
		])]));
	}
}), vm = { class: "flex grow" }, ym = { class: "flex flex-col" }, bm = { class: "flex gap-x-2 items-center" }, xm = { class: "font-bold leading-none" }, Sm = { class: "font-normal text-xs w-40" }, Cm = { class: "text-left" }, wm = { class: "mb-1 text-black-light" }, Tm = { class: "ml-auto self-center shrink-0 text-black-light" }, Em = /* @__PURE__ */ l({
	__name: "PickupLocationOption",
	props: { option: {} },
	setup(o) {
		let s = o, { t: c } = Me(), l = t(() => {
			let e = oi.transformMetersToKilometers(s.option.location.distance);
			return `${s.option.location.location_name} (${e} km)`;
		}), u = t(() => s.option.location.location_name), d = t(() => Object.entries(s.option.location.opening_hours).reduce((e, [t, n]) => {
			e[t] = {
				start: "-",
				end: "-"
			};
			let r = n[0];
			return r?.start && (e[t].start = Wr(r.start.date).format("HH:mm")), r?.end && (e[t].end = Wr(r.end.date).format("HH:mm")), e;
		}, {})), p = t(() => `${s.option.address.street} ${s.option.address.number}${s.option.address.number_suffix ?? ""}, ${s.option.address.postal_code} ${s.option.address.city}`), m = t(() => s.option.possibilities.map((e) => {
			if (!e.moment?.start?.date) return "";
			let { date: t } = e.moment.start;
			return Wr(t).format(`dddd D MMMM [${c("from")}] HH:mm`);
		})), g = t(() => s.option.possibilities[0].price ? ai.currency.format(s.option.possibilities[0].price) : ai.currency.format(0));
		return (t, s) => (f(), i("div", vm, [a("div", ym, [
			a("div", bm, [a("h4", xm, v(l.value), 1), o.option.location.opening_hours ? (f(), n(y(we), {
				key: 0,
				class: "pointer-events-auto"
			}, {
				default: x(() => [a("table", Sm, [a("thead", Cm, [a("tr", null, [
					a("th", null, v(y(c)("calendar.index.day")), 1),
					a("th", null, v(y(c)("from")), 1),
					a("th", null, v(y(c)("to")), 1)
				])]), a("tbody", null, [(f(!0), i(e, null, h(d.value, (e, t) => (f(), i("tr", { key: `${u.value}-${t}` }, [
					a("td", null, v(y(c)(`calendar.day.${t}`)), 1),
					a("td", null, v(e.start), 1),
					a("td", null, v(e.end), 1)
				]))), 128))])])]),
				_: 1
			})) : r("", !0)]),
			a("span", wm, v(p.value), 1),
			(f(!0), i(e, null, h(m.value, (e) => (f(), i("span", {
				key: e,
				class: "first-letter:capitalize"
			}, v(e), 1))), 128))
		]), a("span", Tm, v(g.value), 1)]));
	}
}), Dm = /* @__PURE__ */ l({
	__name: "PickupLocationRadioGroup",
	props: /*@__PURE__*/ u({
		pickupLocations: {},
		name: {}
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let r = e, i = ee(e, "modelValue"), a = m(""), o = (e) => `[${e.address.postal_code}][${e.address.number}][${e.address.street}][${e.address.number_suffix ?? ""}]`, s = (e) => {
			let [t, n, i, a] = e.slice(1, -1).split("][");
			return r.pickupLocations.find((e) => e.address.street === i && e.address.postal_code === t && e.address.number === n && (e.address.number_suffix ?? "") === a);
		}, l = t(() => r.pickupLocations.map((e) => ({
			...e,
			value: o(e),
			label: ""
		})));
		return ne(i, (e) => {
			e ? a.value = o(e) : a.value = "";
		}, { immediate: !0 }), ne(a, (e) => {
			if (!e) {
				i.value = void 0;
				return;
			}
			i.value = s(e);
		}), (t, r) => (f(), n(y(Te), {
			modelValue: a.value,
			"onUpdate:modelValue": r[0] ||= (e) => a.value = e,
			"active-class": "bg-gray-100",
			class: "py-0! gap-y-0 border-0!",
			name: e.name,
			options: l.value,
			"radio-class": "p-4! items-start! hover:bg-gray-100 focus:z-10"
		}, {
			default: x(({ option: e }) => [c(Em, { option: e }, null, 8, ["option"])]),
			_: 1
		}, 8, [
			"modelValue",
			"name",
			"options"
		]));
	}
}), Om = {
	key: 0,
	class: "flex flex-col gap-y-4"
}, km = {
	key: 0,
	class: "px-4 block"
}, Am = { class: "flex flex-col gap-y-1" }, jm = {
	key: 1,
	class: "text-center"
}, Mm = { class: "px-4 block mb-4" }, Nm = {
	key: 1,
	class: "text-center"
}, Pm = {
	key: 1,
	class: "flex flex-col items-center justify-center"
}, Fm = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryResults",
	props: {
		activeTab: {},
		pickupLocations: {},
		deliveryOptions: {},
		selectedOption: {},
		initialSelection: {},
		hasDeliveryData: { type: Boolean },
		hasPickupData: { type: Boolean },
		isLoading: { type: Boolean },
		userHasSearched: { type: Boolean }
	},
	emits: ["selectPickupOption", "selectDeliveryOption"],
	setup(t, { emit: o }) {
		let s = t, l = o, { t: u } = Me(), d = m(!1), p = m(), h = m();
		return ne(h, () => {
			if (h.value) {
				if (d.value) {
					d.value = !1;
					return;
				}
				l("selectDeliveryOption", h.value), p.value = void 0;
			}
		}), ne(p, () => {
			if (p.value) {
				if (d.value) {
					d.value = !1;
					return;
				}
				l("selectPickupOption", p.value), h.value = void 0;
			}
		}), ne(() => s.initialSelection, (e) => {
			e && (d.value = !0, "location" in e ? p.value = e : h.value = {
				deliveryTimeFrame: e.delivery_time_frames,
				type: e.type
			});
		}), ne(() => s.selectedOption, (e) => {
			if (!e) {
				h.value = void 0, p.value = void 0;
				return;
			}
		}, { immediate: !0 }), (o, s) => (f(), i("div", null, [t.userHasSearched ? (f(), i(e, { key: 0 }, [t.isLoading ? (f(), n(y(De), {
			key: 1,
			class: "flex justify-center mt-6",
			size: "small"
		})) : (f(), i(e, { key: 0 }, [t.activeTab === "delivery" ? (f(), i("div", Om, [
			t.hasDeliveryData ? (f(), i("p", km, v(y(u)("shipping.adjustedDelivery.choose.delivery")), 1)) : r("", !0),
			a("div", Am, [c(_m, {
				modelValue: h.value,
				"onUpdate:modelValue": s[0] ||= (e) => h.value = e,
				"delivery-options": t.deliveryOptions,
				name: "delivery_options"
			}, null, 8, ["modelValue", "delivery-options"])]),
			t.hasDeliveryData ? r("", !0) : (f(), i("p", jm, v(y(u)("shipping.adjustedDelivery.noDeliveriesFound")), 1))
		])) : r("", !0), t.activeTab === "pickup" ? (f(), i(e, { key: 1 }, [t.hasPickupData ? (f(), i(e, { key: 0 }, [a("p", Mm, v(y(u)("shipping.adjustedDelivery.choose.pickup")), 1), c(Dm, {
			modelValue: p.value,
			"onUpdate:modelValue": s[1] ||= (e) => p.value = e,
			name: "pickup_locations",
			"pickup-locations": t.pickupLocations
		}, null, 8, ["modelValue", "pickup-locations"])], 64)) : r("", !0), t.hasPickupData ? r("", !0) : (f(), i("p", Nm, v(y(u)("shipping.adjustedDelivery.noPickupsFound")), 1))], 64)) : r("", !0)], 64))], 64)) : (f(), i("div", Pm, [c(y(Vp), {
			class: "text-secondary-200",
			size: y(ve).Large
		}, {
			default: x(() => [c(y(le))]),
			_: 1
		}, 8, ["size"]), a("p", null, v(y(u)("shipping.adjustedDelivery.empty")), 1)]))]));
	}
}), Im = (e, t, n, r, i, a) => Ne.object({
	postalCode: Re.schema.handleEmptyAndNullAsUndefined(Re.schema.requiredIf(t, Ne.string().min(Jo.properties.postalCode.minLength).max(Jo.properties.postalCode.maxLength).refine((e) => a(e), { message: e("errors.specificField.postalCode.invalid") }))),
	houseNumber: Re.schema.handleEmptyAndNullAsUndefined(Re.schema.requiredIf(n, Ne.string().min(Jo.properties.houseNumber.minLength))),
	street: Re.schema.handleEmptyAndNullAsUndefined(Re.schema.requiredIf(r, Ne.string())),
	city: Re.schema.handleEmptyAndNullAsUndefined(Re.schema.requiredIf(i, Ne.string()))
}), Lm = { class: "flex gap-2" }, Rm = /* @__PURE__ */ l({
	__name: "AdjustedDeliverySearchForm",
	props: {
		address: {},
		type: {},
		carrierId: {},
		isLoading: { type: Boolean },
		isSearchable: { type: Boolean }
	},
	emits: ["search"],
	setup(e, { emit: i }) {
		let o = e, l = i, { t: u } = Me(), { getVisibleFields: d, getRequiredFields: p } = Np(), m = t(() => We(o.carrierId)), h = t(() => d(o.address.countryCode, m.value)), g = t(() => p(o.address.countryCode, m.value)), _ = {
			...o.address.postalCode && { postalCode: o.address.postalCode },
			...o.address.houseNumber && { houseNumber: o.address.houseNumber },
			...o.address.street && { street: o.address.street },
			...o.address.city && { city: o.address.city }
		}, { handleSubmit: b, values: ee, meta: te, resetForm: S, setValues: re } = ze({
			validationSchema: t(() => Im(u, g.value.postalCode, g.value.houseNumber, g.value.street, g.value.city, (e) => Fe(e, o.address.countryCode))),
			initialValues: _,
			validateOnMount: !1
		}), ie = b((e) => l("search", e)), C = t(() => !!(ee.postalCode || ee.houseNumber || ee.street || ee.city));
		return ne(() => o.type, async () => {
			!o.isSearchable || !te.value.valid || !C.value || (await ie(), S({ values: ee }));
		}), ne(() => o.isSearchable, async (e) => {
			if (!e) {
				S({ values: {
					postalCode: o.address.postalCode,
					houseNumber: o.address.houseNumber,
					street: o.address.street,
					city: o.address.city
				} });
				return;
			}
			!(await Im(u, g.value.postalCode, g.value.houseNumber, g.value.street, g.value.city, () => !0).safeParseAsync(ee)).success || !C.value || await ie();
		}, { immediate: !0 }), ne(() => [
			o.address.postalCode,
			o.address.houseNumber,
			o.address.street,
			o.address.city
		], () => {
			re({
				postalCode: o.address.postalCode,
				houseNumber: o.address.houseNumber,
				street: o.address.street,
				city: o.address.city
			}, !1);
		}, { immediate: !0 }), (t, i) => (f(), n(y(Ie), { onSubmit: y(ie) }, {
			default: x(() => [a("div", Lm, [
				h.value.postalCode ? (f(), n(y(Le), {
					key: 0,
					class: "flex flex-col grow",
					"hide-label": "",
					label: y(u)("location.address.postalCode"),
					name: "postalCode",
					placeholder: y(u)("location.address.postalCode"),
					"preserve-label-gap": !1
				}, null, 8, ["label", "placeholder"])) : r("", !0),
				c(y(Le), {
					class: "flex flex-col grow",
					"hide-label": "",
					label: y(u)("location.address.houseNumber"),
					name: "houseNumber",
					placeholder: y(u)("location.address.houseNumber"),
					"preserve-label-gap": !1
				}, null, 8, ["label", "placeholder"]),
				h.value.street ? (f(), n(y(Le), {
					key: 1,
					class: "flex flex-col grow",
					"hide-label": "",
					label: y(u)("location.address.street"),
					name: "street",
					placeholder: y(u)("location.address.street"),
					"preserve-label-gap": !1
				}, null, 8, ["label", "placeholder"])) : r("", !0),
				h.value.city ? (f(), n(y(Le), {
					key: 2,
					class: "flex flex-col grow",
					"hide-label": "",
					label: y(u)("location.address.city"),
					name: "city",
					placeholder: y(u)("location.address.city"),
					"preserve-label-gap": !1
				}, null, 8, ["label", "placeholder"])) : r("", !0),
				c(y(he), {
					"hide-label": "",
					"preserve-label-gap": !1
				}, {
					default: x(() => [c(y(se), {
						"is-loading": e.isLoading,
						type: "submit"
					}, {
						default: x(() => [s(v(y(u)("search.label")), 1)]),
						_: 1
					}, 8, ["is-loading"])]),
					_: 1
				})
			])]),
			_: 1
		}, 8, ["onSubmit"]));
	}
}), zm = {
	Pickup: "pickup",
	Delivery: "delivery"
}, Bm = { class: "border-b flex gap-4 px-4" }, Vm = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryTabs",
	props: /*@__PURE__*/ u({
		hasAdjustedDelivery: { type: Boolean },
		hasAdjustedPickup: { type: Boolean },
		pickupRequired: { type: Boolean }
	}, {
		modelValue: { required: !0 },
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e) {
		let o = e, { t: c } = Me(), l = ee(e, "modelValue"), u = (e) => {
			o.pickupRequired || e === l.value || (l.value = e);
		}, p = t(() => l.value === zm.Pickup), m = t(() => l.value === zm.Delivery);
		return (t, o) => (f(), i("nav", null, [a("ul", Bm, [e.hasAdjustedDelivery ? (f(), n(y(Oe), {
			key: 0,
			active: m.value,
			"aria-label": y(c)("shipping.adjustedDelivery.delivery"),
			class: d({ "cursor-not-allowed!": e.pickupRequired }),
			onClick: o[0] ||= () => u("delivery")
		}, {
			default: x(() => [s(v(y(c)("shipping.adjustedDelivery.delivery")), 1)]),
			_: 1
		}, 8, [
			"active",
			"aria-label",
			"class"
		])) : r("", !0), e.hasAdjustedPickup ? (f(), n(y(Oe), {
			key: 1,
			active: p.value,
			"aria-label": y(c)("shipping.adjustedDelivery.pickup"),
			onClick: o[1] ||= () => u("pickup")
		}, {
			default: x(() => [s(v(y(c)("shipping.adjustedDelivery.pickup")), 1)]),
			_: 1
		}, 8, ["active", "aria-label"])) : r("", !0)])]));
	}
}), Hm = (e, t) => e.flatMap((e) => e.possibilities).find((e) => t?.deliveryType && e.type === t.deliveryType && Wr(e.delivery_time_frames[0].date_time.date).isSame(t.date, "day")), Um = (e, t) => e.find((e) => e.location.location_code === t?.location?.code), Wm = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryModal",
	props: {
		address: {},
		carrier: {},
		platform: {},
		dropOffDays: { default: () => [] },
		selectedOption: { default: void 0 },
		mondayDelivery: { type: Boolean },
		hasAdjustedDelivery: { type: Boolean },
		hasAdjustedPickup: { type: Boolean },
		isPickupRequired: { type: Boolean }
	},
	emits: ["selectPickupOption", "selectDeliveryOption"],
	setup(e, { expose: i, emit: a }) {
		let o = e, l = a, u = p({
			postalCode: "",
			houseNumber: "",
			street: "",
			city: ""
		}), { t: d } = Me(), { addNotification: h } = re(), { getAdjustedDeliveryData: g } = Np(), _ = m(!0), b = m(zm.Pickup), ee = m(!1), ie = m([]), C = m([]), ae = te("adjustedDeliveryModal"), oe = t(() => Ke(o.carrier)), se = t(() => C.value.length > 0), ce = t(() => ie.value.length > 0), le = t(() => qr(o.selectedOption?.deliveryType)), ue = t(() => Jr(o.selectedOption?.deliveryType)), de = t(() => le.value ? "shipping.adjustedDelivery.chosen.pickup" : "shipping.adjustedDelivery.chosen.delivery"), fe = () => {
			ie.value = [], C.value = [], ee.value = !1, _.value = !0;
		}, pe = async (e) => {
			u.postalCode = e.postalCode, u.houseNumber = e.houseNumber, u.street = e.street, u.city = e.city, ee.value = !0, ie.value = [], C.value = [], await ve(e);
		}, me = () => {
			fe(), he.value = void 0;
		}, he = m(), ge = m(!1), { isLoading: _e, executeImmediate: ve } = je(async (e) => {
			let { postalCode: t, houseNumber: n, street: r, city: i } = e;
			return g({
				cc: o.address.countryCode,
				postal_code: t,
				number: Number(n),
				city: i,
				street: r,
				carrier: oe.value,
				monday_delivery: o.mondayDelivery,
				dropoff_days: o.dropOffDays.join(";"),
				platform: o.platform
			}, b.value);
		}, [], {
			onSuccess: (e) => {
				if (_.value = !0, b.value === zm.Pickup) {
					ie.value = e, ge.value &&= (he.value = Um(ie.value, o.selectedOption), !1);
					return;
				}
				C.value = e, ge.value &&= (he.value = Hm(C.value, o.selectedOption), !1);
			},
			onError: (e) => {
				if (e?.data?.errors?.[0]?.code === 3501) _.value = !1, h({
					variant: "alert",
					body: d("apiError.3501")
				});
				else {
					let e = b.value === zm.Delivery ? "deliveryOptions" : "pickupLocations";
					h({
						variant: "alert",
						body: d(`shipping.adjustedDelivery.notification.${e}.error`)
					});
				}
				ie.value = [], C.value = [];
			},
			immediate: !1
		});
		/* c8 ignore end */
		return ne(() => [o.isPickupRequired, o.hasAdjustedDelivery], () => {
			b.value = o.isPickupRequired || !o.hasAdjustedDelivery ? zm.Pickup : zm.Delivery;
		}, { immediate: !0 }), ne(() => o.address.countryCode, () => {
			fe();
		}), i({
			show: () => {
				le.value ? (b.value = zm.Pickup, ge.value = !0) : ue.value && o.hasAdjustedDelivery && (b.value = zm.Delivery, ge.value = !0), he.value = void 0, ae.value?.show();
			},
			confirm: () => {
				ae.value?.confirm();
			},
			cancel: () => {
				ae.value?.cancel();
			}
		}), (t, i) => (f(), n(y(be), {
			ref: "adjustedDeliveryModal",
			"body-class": "flex flex-col gap-4",
			"full-width-content": "",
			"hide-confirm": "",
			"show-cancel": "",
			title: y(d)("shipping.adjustedDelivery.deliveryOption", 2),
			onClose: me
		}, {
			default: x(() => [
				_.value ? r("", !0) : (f(), n(y(S), {
					key: 0,
					id: "invalid-address",
					class: "mx-4 mb-0!",
					variant: "alert"
				}, {
					default: x(() => [s(v(y(d)("shipping.adjustedDelivery.notification.provideValidAddress")), 1)]),
					_: 1
				})),
				c(Rm, {
					address: e.address,
					"carrier-id": oe.value,
					class: "px-4",
					"is-loading": y(_e),
					"is-searchable": ae.value?.isOpen,
					type: b.value,
					onSearch: pe
				}, null, 8, [
					"address",
					"carrier-id",
					"is-loading",
					"is-searchable",
					"type"
				]),
				e.selectedOption ? (f(), n(Lp, {
					key: 1,
					class: "px-4",
					"country-code": e.address.countryCode,
					option: e.selectedOption,
					title: de.value
				}, null, 8, [
					"country-code",
					"option",
					"title"
				])) : r("", !0),
				c(Vm, {
					modelValue: b.value,
					"onUpdate:modelValue": i[0] ||= (e) => b.value = e,
					"has-adjusted-delivery": e.hasAdjustedDelivery,
					"has-adjusted-pickup": e.hasAdjustedPickup,
					"pickup-required": e.isPickupRequired
				}, null, 8, [
					"modelValue",
					"has-adjusted-delivery",
					"has-adjusted-pickup",
					"pickup-required"
				]),
				c(Fm, {
					"active-tab": b.value,
					"delivery-options": C.value,
					"has-delivery-data": se.value,
					"has-pickup-data": ce.value,
					"initial-selection": he.value,
					"is-loading": y(_e),
					"pickup-locations": ie.value,
					"selected-option": e.selectedOption,
					"user-has-searched": ee.value,
					onSelectDeliveryOption: i[1] ||= (e) => l("selectDeliveryOption", e),
					onSelectPickupOption: i[2] ||= (e) => l("selectPickupOption", e)
				}, null, 8, [
					"active-tab",
					"delivery-options",
					"has-delivery-data",
					"has-pickup-data",
					"initial-selection",
					"is-loading",
					"pickup-locations",
					"selected-option",
					"user-has-searched"
				])
			]),
			_: 1
		}, 8, ["title"]));
	}
}), Gm = Yo.properties.groups.items.properties.hsCode.maxLength, Km = 6, qm = [10], Jm = [8, 10], Ym = [
	6,
	8,
	10
], Xm = [
	6,
	8,
	10
], Zm = [6, 8], Qm = [L.DPD, L.BPOST], $m = (e, t) => !Qm.includes(e) && Er.countryCode.isUnitedStatesOfAmerica(t) ? { allowed: qm } : _p(e) ? {
	min: 6,
	max: Gm
} : dp(e) ? { allowed: Jm } : ap(e) ? { allowed: Zm } : np(e) ? { allowed: Xm } : { allowed: Ym }, eh = (e) => !("barcode" in e), th = (e) => "barcode" in e, nh = (e) => e.shipping?.recipient ?? e.packages?.find((e) => e.shipment?.recipient)?.shipment?.recipient, rh = {
	[Qo.PACKAGE]: 1e3,
	[Qo.PALLET]: 5e4,
	[Qo.DIGITAL_STAMP]: 10,
	[Qo.MAILBOX]: 50,
	[Qo.SMALL_PACKAGE]: 125,
	[Qo.ENVELOPE]: 250
}, ih = (e) => e in rh, ah = (e) => ih(e) ? rh[e] : rh[Qo.PACKAGE], oh = (e, t, n) => {
	let r = _p(t), i = (Er.countryCode.isUnitedKingdom(e) || Er.countryCode.isIreland(e)) && up(t);
	return r ? {
		required: !1,
		visible: !0
	} : i && n ? {
		required: !0,
		visible: !0
	} : {
		required: !1,
		visible: !1
	};
}, sh = (e, t, n) => {
	let r = _p(t), i = (Er.countryCode.isUnitedKingdom(e) || Er.countryCode.isIreland(e)) && up(t);
	return r ? {
		required: !1,
		visible: !0
	} : i && n ? {
		required: !0,
		visible: !0
	} : {
		required: !1,
		visible: !1
	};
}, ch = (e, t, n) => fp(e, t) || ip(e, n), lh = (e, t) => Er.countryCode.isBelgium(e) && Zf(t) ? !1 : !ep(t), uh = (e) => {
	let { hasDeliveryOptions: t, countryParam: n, carrier: r, packageType: i } = e, a = cp(r), o = lp(r), s = mp(r), c = Er.countryCode.isIreland(n), l = Qf(i);
	return !(!t || s || a && c || o && l);
}, dh = (e) => up(e), fh = (e) => _p(e), ph = (e) => {
	if (e.direction === $o.INBOUND || ep(e.packageType)) return !1;
	let t = up(e.carrier) || cp(e.carrier), n = Er.countryCode.isIreland(e.countryCode);
	return t && n ? !0 : !Ye.includes(e.countryCode);
}, mh = (e) => [
	ud.CommercialGoods,
	ud.CommercialSample,
	ud.ReturnedGoods
].includes(e), hh = (e, t) => {
	let n = [ud.Documents, ud.Gift];
	return !((Er.countryCode.isUnitedStatesOfAmerica(e) || Er.countryCode.isPuertoRico(e)) && n.includes(t));
}, gh = (e) => e.status === Zo.OPEN && !e.assignedUserId, _h = (e) => e.status === Zo.OPEN, vh = (e) => e.status === Zo.OPEN, yh = (e) => e.status !== Zo.CANCELED, bh = (e) => !e.packages?.length || e.packages.every((e) => !e.shipment) ? !1 : e.packages.some((e) => e.lines?.length && e.shipment?.direction !== $o.INBOUND), xh = (e) => !!(e.lines && e.lines.length > 0), Sh = (e) => e.status === Zo.OPEN && !!e.assignedUserId, Ch = (e) => e.status === Zo.OPEN && !!e.assignedUserId, wh = (e, t) => e.every((e) => {
	if (!t) return !0;
	let n = e.packageType, r = Zf(n) || Qf(n);
	return np(e.carrier) && r;
}), Th = {
	GRAM: "g",
	KILOGRAM: "kg"
}, Eh = {
	[Th.GRAM]: 1,
	[Th.KILOGRAM]: 1e3
}, Dh = ({ value: e, unit: t }, n) => {
	let r = Eh[t], i = Eh[n];
	return !r || !i ? e : e * r / i;
}, Oh = {
	MILLIMETER: "mm",
	CENTIMETER: "cm",
	DECIMETER: "dm",
	METER: "m",
	KILOMETER: "km"
}, kh = {
	[Oh.MILLIMETER]: 1,
	[Oh.CENTIMETER]: 10,
	[Oh.DECIMETER]: 100,
	[Oh.METER]: 1e3,
	[Oh.KILOMETER]: 1e6
}, Ah = {
	[Oh.MILLIMETER]: "unit.millimeter.short",
	[Oh.CENTIMETER]: "unit.centimeter.short",
	[Oh.DECIMETER]: "unit.decimeter.short",
	[Oh.METER]: "unit.meter.short",
	[Oh.KILOMETER]: "unit.kilometer.short",
	[Th.GRAM]: "unit.gram.short",
	[Th.KILOGRAM]: "unit.kilogram.short"
}, jh = (e) => Ah[e], Mh = ({ value: e, unit: t }, n) => {
	let r = kh[t], i = kh[n];
	return !r || !i ? e : e * r / i;
}, Nh = { class: "flex flex-col w-full" }, Ph = { class: "border border-gray-200 flex items-center justify-between p-4 rounded-lg w-full" }, Fh = { class: "flex items-center" }, Ih = {
	key: 0,
	class: "flex flex-col mt-3"
}, Lh = {
	key: 2,
	class: "text-gray-900 text-sm"
}, Rh = /* @__PURE__ */ l({
	__name: "AdjustedDeliveryCard",
	props: {
		carrier: {},
		selectedOption: {},
		countryCode: {}
	},
	emits: ["editAdjustedDelivery", "removeAdjustedDelivery"],
	setup(e, { emit: o }) {
		let s = e, l = o, { t: u } = Me(), { postponedDeliveryDateMessage: d, postponedNormalMessage: p } = jp(), { isPudo: m } = Np(), h = t(() => p(s.selectedOption)), g = t(() => d(s.carrier, s.selectedOption)), _ = t(() => Sp(s.carrier) && Gd(Ud(s.selectedOption?.deliveryType))), b = t(() => h.value || g.value || _.value), ee = t(() => s.selectedOption?.deliveryType === Qe.Pickup || s.selectedOption?.deliveryType === Qe.PickupExpress ? "shipping.adjustedDelivery.deliverToPickupLocation" : "shipping.adjustedDelivery.deliverAtDifferentTime");
		return (t, o) => (f(), i("div", Nh, [a("div", Ph, [e.selectedOption ? (f(), n(Lp, {
			key: 0,
			"country-code": e.countryCode,
			option: e.selectedOption,
			title: ee.value
		}, null, 8, [
			"country-code",
			"option",
			"title"
		])) : r("", !0), a("div", Fh, [c(y(C), null, {
			default: x(() => [c(y(ie), {
				title: y(u)("edit", 1),
				"with-tooltip": "",
				onClick: o[0] ||= (e) => l("editAdjustedDelivery")
			}, {
				default: x(() => [c(y(_e), { class: "text-primary" }, {
					default: x(() => [c(y(pe))]),
					_: 1
				})]),
				_: 1
			}, 8, ["title"]), c(y(ie), {
				title: y(u)("delete", 1),
				"with-tooltip": "",
				onClick: o[1] ||= (e) => l("removeAdjustedDelivery")
			}, {
				default: x(() => [c(y(_e), { class: "text-red" }, {
					default: x(() => [c(y(Ae))]),
					_: 1
				})]),
				_: 1
			}, 8, ["title"])]),
			_: 1
		})])]), b.value ? (f(), i("div", Ih, [
			h.value && y(m)(e.countryCode) ? (f(), n(y(Se), {
				key: 0,
				id: "postponed-delivery-date-message",
				variant: "warning"
			}, {
				default: x(() => [a("p", null, v(y(u)(`${h.value}`)), 1)]),
				_: 1
			})) : r("", !0),
			_.value ? (f(), n(y(Se), {
				key: 1,
				id: "poste-italiane-pickup-dimensions-warning",
				variant: "warning"
			}, {
				default: x(() => [a("p", null, v(y(u)("shipping.adjustedDelivery.notification.posteItaliane.dimensions")), 1)]),
				_: 1
			})) : r("", !0),
			g.value ? (f(), i("p", Lh, v(y(u)(`${g.value}`)), 1)) : r("", !0)
		])) : r("", !0)]));
	}
}), zh = { class: "flex flex-col" }, Bh = ["title"], Vh = { key: 0 }, Hh = ["title"], Uh = ["title"], Wh = {
	key: 0,
	class: "truncate"
}, Gh = {
	key: 1,
	class: "truncate"
}, Kh = {
	key: 2,
	class: "truncate"
}, qh = {
	key: 3,
	class: "truncate"
}, Jh = /* @__PURE__ */ l({
	__name: "Address",
	props: {
		address: {},
		contact: {},
		showFullCountryName: { type: Boolean }
	},
	setup(e) {
		let n = e, { t: o } = Me(), c = t(() => n.contact && dd(n.contact) ? n.contact : null), l = t(() => n.contact && fd(n.contact) ? n.contact : null), u = t(() => [
			n.address?.street,
			n.address?.houseNumber,
			n.address?.houseNumberSuffix
		].filter(Boolean).join(" ")), d = t(() => [
			n.address?.city,
			n.address?.region,
			n.address?.state
		].filter(Boolean).join(", ")), p = t(() => [n.address?.postalCode, d.value].filter(Boolean).join(" ")), m = t(() => n.showFullCountryName ? o(`location.countries.${n.address?.countryCode}`) : n.address?.countryCode), h = t(() => n.address ? [
			u.value,
			n.address.additionalInformation,
			p.value,
			m.value
		].filter(Boolean).join(", ") : ""), g = t(() => {
			if (c.value) return [c.value.company, c.value.attention].filter(Boolean).join(" ");
		});
		return (t, n) => (f(), i("div", zh, [
			c.value ? (f(), i("p", {
				key: 0,
				class: "truncate",
				title: g.value
			}, [s(v(c.value.company) + " ", 1), c.value.attention ? (f(), i("span", Vh, v(c.value.attention), 1)) : r("", !0)], 8, Bh)) : r("", !0),
			l.value ? (f(), i("p", {
				key: 1,
				class: "truncate",
				title: l.value.name
			}, v(l.value.name), 9, Hh)) : r("", !0),
			a("p", {
				class: "inline-flex flex-col",
				title: h.value
			}, [
				u.value ? (f(), i("span", Wh, v(u.value), 1)) : r("", !0),
				e.address?.additionalInformation ? (f(), i("span", Gh, v(e.address.additionalInformation), 1)) : r("", !0),
				p.value ? (f(), i("span", Kh, v(p.value), 1)) : r("", !0),
				e.address?.countryCode ? (f(), i("span", qh, v(m.value), 1)) : r("", !0)
			], 8, Uh)
		]));
	}
}), Yh = { class: "flex items-center max-w-full gap-x-1" }, Xh = { class: "text-gray-900 truncate" }, Zh = /* @__PURE__ */ l({
	__name: "EcommercePlatform",
	props: {
		ecommercePlatform: {},
		name: {}
	},
	setup(e) {
		return (t, n) => (f(), i("div", Yh, [c(y(fe), {
			name: e.ecommercePlatform,
			size: y(Ve).Medium
		}, null, 8, ["name", "size"]), a("div", Xh, v(e.name), 1)]));
	}
}), Qh = { class: "flex items-center max-w-full gap-x-1" }, $h = { class: "text-gray-900 truncate" }, eg = /* @__PURE__ */ l({
	__name: "MyParcelShopExternalReference",
	setup(e) {
		let { t } = Me();
		return (e, n) => (f(), i("div", Qh, [c(y(xe), { "data-test": "external-reference-myparcel-shop" }), a("div", $h, v(y(t)("webshop.myParcelShop")), 1)]));
	}
}), tg = /* @__PURE__ */ l({
	__name: "Price",
	props: { price: {} },
	setup(e) {
		let n = e, r = t(() => ai.currency.format(ai.currency.fromMoney(n.price), { currency: n.price?.currency }));
		return (e, t) => (f(), i("span", null, v(r.value), 1));
	}
}), ng = /* @__PURE__ */ l({
	__name: "Barcode",
	props: {
		barcode: {},
		trackTraceLink: { default: void 0 }
	},
	setup(t) {
		let { t: a } = Me();
		return (o, l) => (f(), i(e, null, [c(y(ue), {
			class: "p-0!",
			"copy-confirmation": y(a)("orders.table.row.barcodeCopied"),
			"copy-content": t.barcode
		}, {
			default: x(() => [s(v(t.barcode), 1)]),
			_: 1
		}, 8, ["copy-confirmation", "copy-content"]), t.trackTraceLink ? (f(), n(y(me), {
			key: 0,
			class: "text-primary",
			href: t.trackTraceLink,
			target: "_blank"
		}, {
			default: x(() => [s(v(y(a)("trackTracePanel.details.viewOnCarrierWebsite")) + " ", 1), c(y(Be), null, {
				default: x(() => [c(y(om))]),
				_: 1
			})]),
			_: 1
		}, 8, ["href"])) : r("", !0)], 64));
	}
}), rg = { class: "border-b border-gray-400 py-2 last:border-b-0" }, ig = /* @__PURE__ */ l({
	__name: "TrackTraceDetail",
	props: {
		title: {},
		detail: {}
	},
	setup(e) {
		return (t, n) => (f(), i("div", rg, [a("strong", null, v(e.title), 1), g(t.$slots, "default", {}, () => [a("p", null, v(e.detail), 1)])]));
	}
}), ag = /* @__PURE__ */ l({
	__name: "BarcodeDetails",
	props: {
		package: {},
		trackTrace: {}
	},
	setup(a) {
		let o = a, { t: s } = Me(), l = t(() => pd(o.package.shipment?.label) ? o.package.shipment?.label : void 0);
		return (t, o) => (f(), i(e, null, [l.value ? (f(), n(ig, {
			key: 0,
			title: y(s)("barcode")
		}, {
			default: x(() => [c(ng, {
				barcode: l.value.barcode,
				"track-trace-link": a.trackTrace?.link_tracktrace
			}, null, 8, ["barcode", "track-trace-link"])]),
			_: 1
		}, 8, ["title"])) : r("", !0), a.trackTrace?.partner_tracktraces.length ? (f(), n(ig, {
			key: 1,
			title: y(s)("trackTracePanel.details.partnerBarcode")
		}, {
			default: x(() => [(f(!0), i(e, null, h(a.trackTrace.partner_tracktraces, (e) => (f(), i("div", {
				key: e.barcode,
				class: "border-b border-b-gray-400 last:border-b-0 py-2 first:pt-0 last:pb-0"
			}, [c(ng, {
				barcode: e.barcode,
				"track-trace-link": e.uri
			}, null, 8, ["barcode", "track-trace-link"])]))), 128))]),
			_: 1
		}, 8, ["title"])) : r("", !0)], 64));
	}
}), og = { key: 0 }, sg = { key: 1 }, cg = { key: 2 }, lg = { key: 1 }, ug = /* @__PURE__ */ l({
	__name: "DeliveryDetails",
	props: { package: {} },
	setup(a) {
		let o = a, { t: s } = Me(), c = t(() => o.package?.shipment?.delivery?.type ? [Xo.MORNING_DELIVERY, Xo.EVENING_DELIVERY].includes(o.package.shipment.delivery.type) : !1), l = t(() => o.package?.shipment?.pickup || c.value || o.package?.shipment?.options?.saturdayDelivery);
		return (t, u) => l.value || a.package.shipment?.dropOff?.date ? (f(), n(ig, {
			key: 0,
			title: y(s)("trackTracePanel.details.delivery")
		}, {
			default: x(() => [l.value ? (f(), i(e, { key: 0 }, [
				a.package.shipment?.pickup ? (f(), i("p", og, v(y(s)("trackTracePanel.details.pickupAtPostalPoint", { locationName: a.package.shipment.pickup.location.name })), 1)) : r("", !0),
				c.value ? (f(), i("p", sg, v(o.package.shipment.delivery.type), 1)) : r("", !0),
				a.package.shipment?.options?.saturdayDelivery ? (f(), i("p", cg, v(y(s)("shipping.shipmentOption.saturdayDelivery")), 1)) : r("", !0)
			], 64)) : r("", !0), a.package.shipment?.dropOff?.date ? (f(), i("p", lg, v(y(s)("trackTracePanel.details.deliverOnDate", { date: a.package.shipment.dropOff.date })), 1)) : r("", !0)]),
			_: 1
		}, 8, ["title"])) : r("", !0);
	}
}), dg = { key: 0 }, fg = { key: 1 }, pg = /* @__PURE__ */ l({
	__name: "InsuranceDetails",
	props: { package: {} },
	setup(e) {
		let r = e, { t: a } = Me(), o = t(() => {
			if (r.package.shipment?.options?.insurance !== void 0) return r.package.shipment.options.insurance.amount;
		});
		return (e, t) => (f(), n(ig, { title: y(a)("shipping.shipmentOption.insurance") }, {
			default: x(() => [o.value ? (f(), i("p", dg, [c(tg, { price: o.value }, null, 8, ["price"])])) : (f(), i("p", fg, v(y(a)("trackTracePanel.details.notInsured")), 1))]),
			_: 1
		}, 8, ["title"]));
	}
}), mg = { key: 0 }, hg = { key: 1 }, gg = { key: 2 }, _g = { key: 3 }, vg = { key: 0 }, yg = { key: 1 }, bg = { key: 2 }, xg = { key: 3 }, Sg = /* @__PURE__ */ l({
	__name: "PhysicalDetails",
	props: {
		package: {},
		carrierPhysicalProperties: {}
	},
	setup(n) {
		let r = n, { t: a } = Me(), o = (e) => `${e.value} ${a(jh(e.unit))}`, s = (e) => {
			let t = e?.weight;
			if (!t) return;
			let n = Dh(t, Th.GRAM);
			if (n >= 1e3) {
				let e = Dh(t, Th.KILOGRAM);
				return o({
					value: Math.round(e),
					unit: Th.KILOGRAM
				});
			}
			return o({
				value: n,
				unit: Th.GRAM
			});
		}, l = (e) => {
			let t = e;
			if (!(!t || !t.length || !t.width || !t.height)) return [
				Math.round(Mh(t.length, Oh.CENTIMETER)),
				Math.round(Mh(t.width, Oh.CENTIMETER)),
				Math.round(Mh(t.height, Oh.CENTIMETER))
			].join(" x ").concat(" ", a("unit.centimeter.short"));
		}, u = t(() => s(r.package.physicalProperties)), d = t(() => s(r.carrierPhysicalProperties)), p = t(() => l(r.package.physicalProperties)), m = t(() => l(r.carrierPhysicalProperties));
		return (t, n) => (f(), i(e, null, [c(ig, { title: y(a)("shipping.dimensions.weight") }, {
			default: x(() => [u.value ? (f(), i("p", mg, v(y(a)("trackTracePanel.details.dimensions.user")) + " " + v(u.value), 1)) : (f(), i("p", hg, v(y(a)("trackTracePanel.details.dimensions.user")) + " " + v(y(a)("trackTracePanel.details.noWeightSpecified")), 1)), d.value ? (f(), i("p", gg, v(y(a)("trackTracePanel.details.dimensions.carrier")) + " " + v(d.value), 1)) : (f(), i("p", _g, v(y(a)("trackTracePanel.details.dimensions.carrier")) + " " + v(y(a)("trackTracePanel.details.noWeightSpecified")), 1))]),
			_: 1
		}, 8, ["title"]), c(ig, { title: y(a)("trackTracePanel.details.dimensions.title") }, {
			default: x(() => [p.value ? (f(), i("p", vg, v(y(a)("trackTracePanel.details.dimensions.user")) + " " + v(p.value), 1)) : (f(), i("p", yg, v(y(a)("trackTracePanel.details.dimensions.user")) + " " + v(y(a)("trackTracePanel.details.dimensions.notSpecified")), 1)), m.value ? (f(), i("p", bg, v(y(a)("trackTracePanel.details.dimensions.carrier")) + " " + v(m.value), 1)) : (f(), i("p", xg, v(y(a)("trackTracePanel.details.dimensions.carrier")) + " " + v(y(a)("trackTracePanel.details.dimensions.notSpecified")), 1))]),
			_: 1
		}, 8, ["title"])], 64));
	}
}), Cg = { class: "flex flex-col" }, wg = { class: "flex flex-row gap-2" }, Tg = { class: "basis-1/3" }, Eg = { class: "basis-2/3" }, Dg = { key: 0 }, Og = { key: 1 }, kg = { class: "flex flex-row gap-2" }, Ag = { class: "basis-1/3" }, jg = { class: "basis-2/3" }, Mg = { key: 1 }, Ng = /* @__PURE__ */ l({
	__name: "RecipientDetails",
	props: {
		address: {},
		contact: {}
	},
	setup(t) {
		let { t: n } = Me();
		return (r, o) => (f(), i(e, null, [c(ig, { title: y(n)("location.address.address") }, {
			default: x(() => [c(Jh, {
				address: t.address,
				contact: t.contact,
				"show-full-country-name": ""
			}, null, 8, ["address", "contact"])]),
			_: 1
		}, 8, ["title"]), c(ig, { title: y(n)("trackTracePanel.details.contact") }, {
			default: x(() => [a("dl", Cg, [a("div", wg, [a("dt", Tg, v(y(n)("trackTracePanel.details.phone")), 1), a("dd", Eg, [t.contact.phoneNumber ? (f(), i("span", Dg, v(t.contact.phoneNumber), 1)) : (f(), i("span", Og, v(y(n)("trackTracePanel.details.noPhoneNumber")), 1))])]), a("div", kg, [a("dt", Ag, v(y(n)("trackTracePanel.details.email", t.contact.emailAddresses?.length)), 1), a("div", jg, [t.contact.emailAddresses?.length ? (f(!0), i(e, { key: 0 }, h(t.contact.emailAddresses, (e) => (f(), i("dd", { key: e }, v(e), 1))), 128)) : (f(), i("div", Mg, v(y(n)("trackTracePanel.details.noEmailAddress")), 1))])])])]),
			_: 1
		}, 8, ["title"])], 64));
	}
}), Y = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20
}, X = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM"
};
Y.Dhl, Y.Instabox, Y.PostNl, X.PostNl, Y.Bpost, X.Bpost, Y.CheapCargo, X.CheapCargo, Y.Dpd, X.Dpd, Y.Instabox, X.Instabox, Y.Dhl, X.Dhl, Y.Bol, X.Bol, Y.Ups, X.Ups, Y.DhlForYou, X.DhlForYou, Y.DhlParcelConnect, X.DhlParcelConnect, Y.DhlEuroPlus, X.DhlEuroPlus, Y.UpsStandard, X.UpsStandard, Y.UpsExpressSaver, X.UpsExpressSaver, Y.Gls, X.Gls, Y.Brt, X.Brt, Y.Trunkrs, X.Trunkrs, Y.InPost, X.InPost, Y.PosteItaliane, X.PosteItaliane, Y.Spring, X.Spring, Y.ViaTim, X.ViaTim, Y.PostNl, X.POSTNL, Y.Bpost, X.BPOST, Y.CheapCargo, X.CHEAP_CARGO, Y.Dpd, X.DPD, Y.Instabox, X.INSTABOX, Y.Dhl, X.DHL, Y.Bol, X.BOL, Y.Ups, X.UPS, Y.DhlForYou, X.DHL_FOR_YOU, Y.DhlParcelConnect, X.DHL_PARCEL_CONNECT, Y.DhlEuroPlus, X.DHL_EUROPLUS, Y.UpsStandard, X.UPS_STANDARD, Y.UpsExpressSaver, X.UPS_EXPRESS_SAVER, Y.Gls, X.GLS, Y.Brt, X.BRT, Y.Trunkrs, X.TRUNKRS, Y.InPost, X.INPOST, Y.PosteItaliane, X.POSTE_ITALIANE, Y.Spring, X.SPRING, Y.ViaTim, X.VIA_TIM, X.PostNl, Y.PostNl, X.POSTNL, Y.PostNl, X.Bpost, Y.Bpost, X.BPOST, Y.Bpost, X.CheapCargo, Y.CheapCargo, X.CHEAP_CARGO, Y.CheapCargo, X.Dpd, Y.Dpd, X.DPD, Y.Dpd, X.Instabox, Y.Instabox, X.Dhl, Y.Dhl, X.BolCom, Y.Bol, X.Bol, Y.Bol, X.BOL, Y.Bol, X.Ups, Y.Ups, X.DhlForYou, Y.DhlForYou, X.DHL_FOR_YOU, Y.DhlForYou, X.DhlParcelConnect, Y.DhlParcelConnect, X.DHL_PARCEL_CONNECT, Y.DhlParcelConnect, X.DhlEuroPlus, Y.DhlEuroPlus, X.DHL_EUROPLUS, Y.DhlEuroPlus, X.UpsStandard, Y.UpsStandard, X.UPS_STANDARD, Y.UpsStandard, X.UpsExpressSaver, Y.UpsExpressSaver, X.UPS_EXPRESS_SAVER, Y.UpsExpressSaver, X.Gls, Y.Gls, X.GLS, Y.Gls, X.Brt, Y.Brt, X.BRT, Y.Brt, X.Trunkrs, Y.Trunkrs, X.TRUNKRS, Y.Trunkrs, X.InPost, Y.InPost, X.INPOST, Y.InPost, X.PosteItaliane, Y.PosteItaliane, X.POSTE_ITALIANE, Y.PosteItaliane, X.Spring, Y.Spring, X.SPRING, Y.Spring, X.ViaTim, Y.ViaTim, X.VIA_TIM, Y.ViaTim, Y.PostNl, Y.Bpost, Y.CheapCargo, Y.Dpd, Y.Instabox, Y.Dhl, Y.Bol, Y.Ups, Y.DhlForYou, Y.DhlParcelConnect, Y.DhlEuroPlus, Y.UpsStandard, Y.UpsExpressSaver, Y.Gls, Y.Brt, Y.Trunkrs, Y.InPost, Y.PosteItaliane, Y.ViaTim;
var Z = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
Z.Austria, Z.Belgium, Z.Bulgaria, Z.Croatia, Z.Cyprus, Z.CzechRepublic, Z.Denmark, Z.Estonia, Z.Finland, Z.France, Z.Germany, Z.Greece, Z.Hungary, Z.Ireland, Z.Italy, Z.Latvia, Z.Lithuania, Z.Luxembourg, Z.Malta, Z.Netherlands, Z.Poland, Z.Portugal, Z.Romania, Z.Slovakia, Z.Slovenia, Z.Spain, Z.Sweden, Object.values(Z), Z.Angola, Z.AntiguaAndBarbuda, Z.Aruba, Z.Bahamas, Z.Belize, Z.Benin, Z.Bermuda, Z.BonaireSintEustatiusAndSaba, Z.Botswana, Z.BurkinaFaso, Z.Burundi, Z.Cameroon, Z.CanaryIslands, Z.CentralAfricanRepublic, Z.Comoros, Z.CongoBrazzaville, Z.CongoKinshasa, Z.CoteDIvoire, Z.Curacao, Z.Djibouti, Z.Dominica, Z.DutchAntilles, Z.EquatorialGuinea, Z.Eritrea, Z.Fiji, Z.Gabon, Z.Gambia, Z.Ghana, Z.Grenada, Z.Guyana, Z.HongKong, Z.Kiribati, Z.KoreaPeoplesDemocraticRepublic, Z.Macao, Z.Malawi, Z.Mali, Z.Mauritania, Z.Nauru, Z.Qatar, Z.Rwanda, Z.SaintKittsAndNevis, Z.SaoTomeAndPrincipe, Z.Seychelles, Z.SierraLeone, Z.SintMaarten, Z.Suriname, Z.SyrianArabRepublic, Z.TimorLeste, Z.Togo, Z.Tonga, Z.Tuvalu, Z.Uganda, Z.UnitedArabEmirates, Z.Vanuatu, Z.Yemen, Z.Zimbabwe, Z.Austria, Z.Belgium, Z.Bulgaria, Z.Croatia, Z.CzechRepublic, Z.Estonia, Z.Finland, Z.France, Z.Germany, Z.Greece, Z.Hungary, Z.Ireland, Z.Italy, Z.Latvia, Z.Lithuania, Z.Luxembourg, Z.Malta, Z.Netherlands, Z.Portugal, Z.Romania, Z.Slovakia, Z.Slovenia, Z.Spain, Z.UnitedKingdom, Z.Denmark, Z.Germany, Z.Sweden;
var Pg = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, Fg = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, Ig = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
Pg.EarlyMorning, Fg.EarlyMorning, Pg.Morning, Fg.Morning, Pg.Standard, Fg.Standard, Pg.Evening, Fg.Evening, Pg.Pickup, Fg.Pickup, Pg.PickupExpress, Fg.PickupExpress, Pg.SameDayDelivery, Fg.SameDayDelivery, Pg.Express, Fg.Express, Fg.EarlyMorning, Pg.EarlyMorning, Fg.Morning, Pg.Morning, Fg.Standard, Pg.Standard, Fg.Evening, Pg.Evening, Fg.Pickup, Pg.Pickup, Fg.PickupExpress, Pg.PickupExpress, Fg.SameDayDelivery, Pg.SameDayDelivery, Fg.Express, Pg.Express, Pg.EarlyMorning, Ig.EarlyMorning, Pg.Morning, Ig.Morning, Pg.Standard, Ig.Standard, Pg.Evening, Ig.Evening, Pg.Pickup, Ig.Pickup, Pg.PickupExpress, Ig.PickupExpress, Pg.SameDayDelivery, Ig.SameDayDelivery, Pg.Express, Ig.Express, Ig.EarlyMorning, Fg.EarlyMorning, Ig.Morning, Fg.Morning, Ig.Standard, Fg.Standard, Ig.Evening, Fg.Evening, Ig.Pickup, Fg.Pickup, Ig.PickupExpress, Fg.PickupExpress, Ig.SameDayDelivery, Fg.SameDayDelivery, Ig.Express, Fg.Express, Pg.EarlyMorning, Pg.Morning, Pg.Standard, Pg.Evening, Pg.Pickup, Pg.PickupExpress, Pg.SameDayDelivery, Pg.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var Lg = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, Rg = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
Rg.Sunday, Lg.Sunday, Rg.Monday, Lg.Monday, Rg.Tuesday, Lg.Tuesday, Rg.Wednesday, Lg.Wednesday, Rg.Thursday, Lg.Thursday, Rg.Friday, Lg.Friday, Rg.Saturday, Lg.Saturday, Lg.Sunday, Rg.Sunday, Lg.Monday, Rg.Monday, Lg.Tuesday, Rg.Tuesday, Lg.Wednesday, Rg.Wednesday, Lg.Thursday, Rg.Thursday, Lg.Friday, Rg.Friday, Lg.Saturday, Rg.Saturday;
var zg = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
zg.Bytes, zg.Kilobytes, zg.Megabytes, zg.Gigabytes, zg.Terabytes;
var Bg = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, Vg = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
Bg.Bol, Vg.Bol, Bg.Exact, Vg.Exact, Bg.Amazon, Vg.Amazon, Bg.Wix, Vg.Wix, Bg.ExactDe, Vg.ExactDe, Bg.Etsy, Vg.Etsy, Vg.Bol, Bg.Bol, Vg.Exact, Bg.Exact, Vg.Amazon, Bg.Amazon, Vg.Wix, Bg.Wix, Vg.ExactDe, Bg.ExactDe, Vg.Etsy, Bg.Etsy;
var Hg = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, Ug = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
Hg.Unpaid, Ug.Unpaid, Hg.Due, Ug.Due, Hg.DuePrepayment, Ug.DuePrepayment, Hg.Reminder1, Ug.Reminder1, Hg.Reminder2, Ug.Reminder2, Hg.Dun, Ug.Dun, Hg.Collection, Ug.Collection, Hg.Instalments, Ug.Instalments, Hg.PaymentArrangement, Ug.PaymentArrangement, Hg.Dispute, Ug.Dispute, Hg.LegalProcedure, Ug.LegalProcedure, Hg.Insolvency, Ug.Insolvency, Hg.WriteOff, Ug.WriteOff, Hg.Pending, Ug.Pending, Hg.Cancelled, Ug.Cancelled, Hg.Paid, Ug.Paid, Hg.PaidOnline, Ug.PaidOnline, Hg.PaidAutomatic, Ug.PaidAutomatic, Hg.PaidCredit, Ug.PaidCredit, Hg.PaidZeroItems, Ug.PaidZeroItems, Hg.InvoiceWith0InvoiceItemsPaidZeroBalance, Ug.PaidZeroBalance, Hg.Due, Hg.Reminder1, Hg.Reminder2, Hg.Dun, Hg.Collection, Hg.Instalments, Hg.PaymentArrangement, Hg.Dispute, Hg.Paid, Hg.PaidOnline, Hg.PaidAutomatic, Hg.PaidCredit, Hg.PaidZeroItems;
var Wg = {
	Gram: "g",
	Kilogram: "kg"
};
Wg.Gram, Wg.Kilogram;
var Gg = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
Gg.Millimeter, Gg.Centimeter, Gg.Meter;
var Kg = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, qg = {
	Delivered: "delivered",
	Dispatching: "dispatching",
	Distributing: "distributing",
	PickingAndPacking: "pickingAndPacking",
	Sorting: "sorting",
	Untraceable: "untraceable"
}, Q = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
Q.PendingConcept, Q.PendingRegistered, Q.EnRouteHandedToCarrier, Q.EnRouteSorting, Q.EnRouteDistribution, Q.EnRouteCustoms, Q.DeliveredReadyForPickup, Q.DeliveredAtRecipient, Q.DeliveredPackagePickedUp;
var Jg = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, Yg = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
Yg.Light, Jg.Light, Yg.Start, Jg.Start, Yg.Plus, Jg.Plus, Yg.Premium, Jg.Premium, Yg.Max, Jg.Max, Jg.Light, Yg.Light, Jg.Start, Yg.Start, Jg.Plus, Yg.Plus, Jg.Premium, Yg.Premium, Jg.Max, Yg.Max;
var Xg = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, Zg = {
	Start: Jg.Start,
	Plus: Jg.Plus,
	Premium: Jg.Premium,
	Max: Jg.Max
};
Xg.Start, Zg.Start, Xg.Plus, Zg.Plus, Xg.Premium, Zg.Premium, Xg.Max, Zg.Max, Zg.Start, Xg.Start, Zg.Plus, Xg.Plus, Zg.Premium, Xg.Premium, Zg.Max, Xg.Max;
var Qg = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, $g = {
	Start: Jg.Start,
	Plus: Jg.Plus,
	Premium: Jg.Premium,
	Max: Jg.Max
};
Qg.Start, $g.Start, Qg.Plus, $g.Plus, Qg.Premium, $g.Premium, Qg.Max, $g.Max, $g.Start, Qg.Start, $g.Plus, Qg.Plus, $g.Premium, Qg.Premium, $g.Max, Qg.Max;
var e_ = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, t_ = {
	Light: Jg.Light,
	Start: Jg.Start,
	Plus: Jg.Plus,
	Premium: Jg.Premium,
	Max: Jg.Max
};
e_.Light, t_.Light, e_.Start, t_.Start, e_.Plus, t_.Plus, e_.Premium, t_.Premium, e_.Max, t_.Max, t_.Light, e_.Light, t_.Start, e_.Start, t_.Plus, e_.Plus, t_.Premium, e_.Premium, t_.Max, e_.Max;
var n_ = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, r_ = {
	Start: Jg.Start,
	Plus: Jg.Plus,
	Premium: Jg.Premium,
	Max: Jg.Max
};
n_.Start, r_.Start, n_.Plus, r_.Plus, n_.Premium, r_.Premium, n_.Max, r_.Max, r_.Start, n_.Start, r_.Plus, n_.Plus, r_.Premium, n_.Premium, r_.Max, n_.Max;
var i_ = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, a_ = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, o_ = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
i_.MyParcel, a_.MyParcel, i_.Flespakket, a_.Flespakket, i_.SendMyParcel, a_.SendMyParcel, i_.MyParcelIt, a_.MyParcelIt, i_.DeliverDutch, a_.DeliverDutch, i_.PostNlPlugin, a_.PostNlPlugin, i_.MyParcel, o_.MyParcelNl, i_.Flespakket, o_.MyParcelNl, i_.SendMyParcel, o_.MyParcelBe, i_.MyParcelIt, o_.MyParcelIt, i_.DeliverDutch, o_.DeliverDutch, i_.PostNlPlugin, o_.PostNlPlugin, o_.MyParcelNl, i_.MyParcel, o_.MyParcelBe, i_.SendMyParcel, o_.MyParcelIt, i_.MyParcelIt, o_.MyParcelNl, Kg.HomeCountry, Z.Netherlands, Kg.Eu, Kg.Row, Z.Belgium, o_.MyParcelBe, Kg.HomeCountry, Z.Belgium, Z.Netherlands, Kg.Eu, Kg.Row, o_.MyParcelBe, Kg.HomeCountry, Z.Belgium, Kg.Eu, Kg.Row, o_.MyParcelNl, Kg.HomeCountry, Z.Netherlands, Kg.Eu, Kg.Row, o_.MyParcelNl, Kg.HomeCountry, Z.Netherlands, Z.Belgium, Z.Luxembourg, Y.Bpost, Y.PostNl, Y.DhlForYou, Y.DhlParcelConnect, Y.DhlEuroPlus, Y.Ups, Y.UpsStandard, Y.UpsExpressSaver;
var $ = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, s_ = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
$.Package, s_.Package, $.Mailbox, s_.Mailbox, $.Letter, s_.Letter, $.DigitalStamp, s_.DigitalStamp, $.Pallet, s_.Pallet, $.PackageSmall, s_.PackageSmall, $.Envelope, s_.Envelope, s_.Package, $.Package, s_.Mailbox, $.Mailbox, s_.Letter, $.Letter, s_.DigitalStamp, $.DigitalStamp, s_.Pallet, $.Pallet, s_.PackageSmall, $.PackageSmall, s_.Envelope, $.Envelope;
var c_ = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
$.Package, c_.PACKAGE, $.Mailbox, c_.MAILBOX, $.Letter, c_.UNFRANKED, $.DigitalStamp, c_.DIGITAL_STAMP, $.Pallet, c_.PALLET, $.PackageSmall, c_.SMALL_PACKAGE, $.Envelope, c_.ENVELOPE, c_.PACKAGE, $.Package, c_.MAILBOX, $.Mailbox, c_.UNFRANKED, $.Letter, c_.DIGITAL_STAMP, $.DigitalStamp, c_.PALLET, $.Pallet, c_.SMALL_PACKAGE, $.PackageSmall, c_.ENVELOPE, $.Envelope, $.Package, $.Mailbox, $.Letter, $.DigitalStamp, $.Pallet, $.PackageSmall, $.Envelope;
var l_ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
l_.PendingConcept, l_.PendingRegistered, l_.EnrouteHandedToCarrier, l_.EnrouteSorting, l_.EnrouteDistribution, l_.DeliveredAtCustoms, l_.DeliveredAtRecipient, l_.DeliveredPackagePickedUp, l_.DeliveredReturnShipmentPackagePickedUp, l_.DeliveredAtAgreedLocation, l_.PrintedLetter, l_.PrintedDigitalStamp, l_.InactiveConcept, l_.InactiveRegistered, l_.InactiveEnrouteHandedToCarrier, l_.InactiveEnrouteSorting, l_.InactiveEnrouteDistribution, l_.InactiveEnrouteCustoms, l_.InactiveDeliveredAtRecipient, l_.InactiveDeliveredReadyForPickup, l_.InactiveDeliveredPackagePickedUp, Q.PendingConcept, Q.PendingRegistered, Q.EnRouteHandedToCarrier, Q.EnRouteSorting, Q.EnRouteDistribution, Q.EnRouteCustoms, Q.DeliveredAtRecipient, Q.DeliveredReadyForPickup, Q.DeliveredPackagePickedUp, Q.DeliveredReturnShipmentReadyForPickup, Q.DeliveredReturnShipmentPackagePickedUp, Q.PrintedLetter, Q.InactiveCredited, Q.PrintedDigitalStamp, Q.Expired, Q.Cancelled, Q.InactiveConcept, Q.InactiveRegistered, Q.InactiveEnRouteHandedToCarrier, Q.InactiveEnRouteSorting, Q.InactiveEnRouteDistribution, Q.InactiveEnRouteCustoms, Q.InactiveDeliveredAtRecipient, Q.InactiveDeliveredReadyForPickup, Q.InactiveDeliveredPackagePickedUp, qg.Dispatching, Q.PendingConcept, Q.PendingRegistered, Q.EnRouteHandedToCarrier, Q.Cancelled, qg.Sorting, Q.EnRouteSorting, qg.Distributing, Q.EnRouteDistribution, Q.EnRouteCustoms, Q.DeliveredReadyForPickup, Q.DeliveredReturnShipmentPackagePickedUp, qg.PickingAndPacking, qg.Delivered, Q.DeliveredAtRecipient, Q.DeliveredPackagePickedUp, Q.DeliveredReturnShipmentReadyForPickup, qg.Untraceable, Q.PrintedLetter, Q.PrintedDigitalStamp;
function u_(e) {
	return e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
}
var d_ = /\p{Lu}?\p{Ll}+|[0-9]+|\p{Lu}+(?!\p{Ll})|\p{Emoji_Presentation}|\p{Extended_Pictographic}|\p{L}+/gu;
function f_(e) {
	return Array.from(e.match(d_) ?? []);
}
function p_(e) {
	let t = f_(e);
	if (t.length === 0) return "";
	let [n, ...r] = t;
	return `${n.toLowerCase()}${r.map((e) => u_(e)).join("")}`;
}
var m_ = (e, t) => {
	let n = e(t);
	return typeof n == "string" ? n.length > 0 : !!n && typeof n == "object" && Object.keys(n).length > 0;
}, h_ = (e, t, n) => {
	let r = n ? p_(n) : void 0, i = p_(t), a = `shipping.shipmentOption.${i}`, o;
	return r && m_(e, `shipping.shipmentOption.exceptions.${r}.${i}`) && (a = `shipping.shipmentOption.exceptions.${r}.${i}`), m_(e, `shipmentOption.${i}.note`) && (o = `shipmentOption.${i}.note`), r && m_(e, `shipmentOption.exceptions.${r}.${i}.note`) && (o = `shipmentOption.exceptions.${r}.${i}.note`), {
		label: a,
		note: o ? { keypath: o } : void 0
	};
}, g_ = { key: 1 }, __ = /* @__PURE__ */ l({
	__name: "ShipmentOptionDetails",
	props: { package: {} },
	setup(r) {
		let a = r, { t: o, tm: s } = Me(), c = [
			"insurance",
			"returnContributionFee",
			"customLabelText"
		], l = t(() => Object.keys(a.package.shipment?.options || {}).reduce((e, t) => (c.includes(t) || e.push(t), e), []));
		return (t, a) => (f(), n(ig, { title: y(o)("shipping.options") }, {
			default: x(() => [l.value.length ? (f(!0), i(e, { key: 0 }, h(l.value, (e) => (f(), i("div", { key: e }, v(y(o)(y(h_)(y(s), e, r.package.shipment?.carrier).label)), 1))), 128)) : (f(), i("p", g_, v(y(o)("trackTracePanel.details.noShipmentOptions")), 1))]),
			_: 1
		}, 8, ["title"]));
	}
}), v_ = ["alt", "src"], y_ = { key: 1 }, b_ = /* @__PURE__ */ l({
	__name: "SignatureDetails",
	props: { trackTrace: {} },
	setup(e) {
		let { t } = Me();
		return (r, a) => (f(), n(ig, { title: y(t)("shipping.shipmentOption.requiresSignature") }, {
			default: x(() => [e.trackTrace.signature ? (f(), i("img", {
				key: 0,
				alt: y(t)("shipping.shipmentOption.requiresSignature"),
				src: `data:image/png;base64,${e.trackTrace.signature}`
			}, null, 8, v_)) : (f(), i("p", y_, v(y(t)("trackTracePanel.details.noSignature")), 1))]),
			_: 1
		}, 8, ["title"]));
	}
}), x_ = { class: "flex flex-row gap-4 py-2 px-4 justify-between" }, S_ = { class: "leading-5 text-center" }, C_ = /* @__PURE__ */ l({
	__name: "TraceStatusBlocks",
	props: {
		packageStatus: {},
		disabled: { type: Boolean }
	},
	setup(r) {
		let o = r, { t: s } = Me(), l = [
			"DISPATCHING",
			"SORTING",
			"DISTRIBUTING",
			"DELIVERED"
		], u = t(() => o.packageStatus.group === "DISPATCHING" && o.packageStatus.name === "READY_TO_SHIP"), p = (e) => o.disabled || u.value ? !1 : l.indexOf(o.packageStatus.group) >= l.indexOf(e), m = t(() => [
			{
				label: s("trackTracePanel.status.dispatching"),
				icon: Yp,
				active: p("DISPATCHING")
			},
			{
				label: s("trackTracePanel.status.sorting"),
				icon: nm,
				active: p("SORTING")
			},
			{
				label: s("trackTracePanel.status.distributing"),
				icon: $p,
				active: p("DISTRIBUTING")
			},
			{
				label: s("trackTracePanel.status.delivered"),
				icon: Gp,
				active: p("DELIVERED")
			}
		]);
		return (t, r) => (f(), i("ul", x_, [(f(!0), i(e, null, h(m.value, (e) => (f(), i("li", {
			key: e.label,
			class: d(["text-xs flex flex-col items-center", {
				"text-gray-500": !e.active,
				"text-primary font-bold": e.active
			}])
		}, [c(y(Be), { size: 24 }, {
			default: x(() => [(f(), n(_(e.icon)))]),
			_: 2
		}, 1024), a("p", S_, v(e.label), 1)], 2))), 128))]));
	}
}), w_ = { class: "px-4 py-6 bg-white" }, T_ = { class: "bg-gray-100 border-t border-gray-400 px-4 py-6 h-full" }, E_ = { class: "flex flex-row justify-between items-center" }, D_ = { class: "flex gap-2 items-center" }, O_ = { class: "flex gap-2 items-center" }, k_ = /* @__PURE__ */ l({
	__name: "ShipmentTrackTraceSidePanel",
	props: {
		package: {},
		trackTrace: { default: void 0 },
		returnReasons: { default: () => [] },
		withCaseCreate: { type: Boolean },
		withMarkAsDelivered: { type: Boolean },
		userAgent: { default: void 0 },
		origin: { default: void 0 },
		carrierPhysicalProperties: { default: void 0 },
		loading: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["createCase", "markAsDelivered"],
	setup(l, { expose: u, emit: d }) {
		let p = l, m = d, { t: g } = Me(), { getFormattedTrackAndTrace: _ } = He(), b = te("shipmentTrackTracePanel"), ee = t(() => p.trackTrace ? _(p.trackTrace) : []), ne = t(() => p.package.shipment?.options?.customLabelText?.text), S = (e) => pd(e) ? e.barcode : "", re = () => m("createCase", S(p.package.shipment?.label));
		/* c8 ignore end */
		return u({
			openTrackTracePanel() {
				b.value?.openSidePanel();
			},
			closeTrackTracePanel() {
				b.value?.closeSidePanel();
			}
		}), (t, u) => (f(), n(y(Ee), {
			ref: "shipmentTrackTracePanel",
			"aria-label": y(g)("trackTracePanel.title"),
			"body-class": "p-0 bg-gray-100",
			title: y(g)("trackTracePanel.title")
		}, o({
			default: x(() => [a("div", null, [
				c(C_, {
					class: "border-t border-b bg-white sticky top-0 z-20",
					disabled: !!l.package.shipment?.options?.noTracking,
					"package-status": l.package.status
				}, null, 8, ["disabled", "package-status"]),
				a("div", w_, [l.loading ? (f(), n(y(De), {
					key: 0,
					class: "flex justify-center",
					size: "small"
				})) : ee.value.length ? ee.value.length <= 3 ? (f(), n(y(ke), {
					key: 2,
					items: ee.value
				}, null, 8, ["items"])) : (f(), n(y(ye), {
					key: 3,
					"close-text": y(g)("trackTracePanel.events.showLess"),
					"initial-height": 200,
					"open-text": y(g)("trackTracePanel.events.showMore")
				}, {
					default: x(() => [c(y(ke), { items: ee.value }, null, 8, ["items"])]),
					_: 1
				}, 8, ["close-text", "open-text"])) : (f(), n(y(ae), {
					key: 1,
					variant: "warning"
				}, {
					default: x(() => [s(v(y(g)("trackTracePanel.events.noEvents")), 1)]),
					_: 1
				}))]),
				a("div", T_, [a("div", E_, [c(y(ge), {
					class: "m-0",
					level: "2"
				}, {
					default: x(() => [s(v(y(g)("trackTracePanel.details.title")), 1)]),
					_: 1
				}), l.withCaseCreate ? (f(), n(y(oe), {
					key: 0,
					onClick: re
				}, {
					default: x(() => [s(v(y(g)("trackTracePanel.createCase")), 1)]),
					_: 1
				})) : r("", !0)]), a("div", null, [
					c(ig, {
						detail: l.package.shipment?.id,
						title: y(g)("trackTracePanel.details.shipmentId")
					}, null, 8, ["detail", "title"]),
					l.userAgent ? (f(), n(ig, {
						key: 0,
						class: "max-w-md break-all",
						detail: l.userAgent,
						title: y(g)("trackTracePanel.details.userAgent")
					}, null, 8, ["detail", "title"])) : r("", !0),
					l.origin ? (f(), n(ig, {
						key: 1,
						detail: l.origin,
						title: y(g)("trackTracePanel.details.origin")
					}, null, 8, ["detail", "title"])) : r("", !0),
					c(ag, {
						package: l.package,
						"track-trace": l.trackTrace
					}, null, 8, ["package", "track-trace"]),
					c(ig, { title: y(g)("trackTracePanel.details.createdDate") }, {
						default: x(() => [a("p", null, [c(y(de), { date: l.package.shipment?.createdAt }, null, 8, ["date"])])]),
						_: 1
					}, 8, ["title"]),
					c(ig, { title: y(g)("trackTracePanel.details.packageType") }, {
						default: x(() => [a("div", D_, [c(y(Ce), {
							class: "text-secondary",
							"package-type-id": l.package.shipment?.packageType
						}, null, 8, ["package-type-id"]), a("p", null, v(y(g)(`shipping.packageType.${y(Ap)(l.package.shipment?.packageType ?? "")}`)), 1)])]),
						_: 1
					}, 8, ["title"]),
					c(ig, { title: y(g)("shipping.carrier") }, {
						default: x(() => [a("div", O_, [c(y(ce), { carrier: l.package?.shipment?.carrier }, null, 8, ["carrier"]), a("p", null, v(y(g)(`shipping.carriers.${y(Je)(l.package?.shipment?.carrier ?? "")}`)), 1)])]),
						_: 1
					}, 8, ["title"]),
					c(__, { package: l.package }, null, 8, ["package"]),
					c(pg, { package: l.package }, null, 8, ["package"]),
					ne.value ? (f(), n(ig, {
						key: 2,
						detail: ne.value,
						title: y(g)("trackTracePanel.details.labelDescription")
					}, null, 8, ["detail", "title"])) : r("", !0),
					l.package.shipment?.recipient.address && l.package.shipment.recipient.contact ? (f(), n(Ng, {
						key: 3,
						address: l.package.shipment.recipient.address,
						contact: l.package.shipment.recipient.contact
					}, null, 8, ["address", "contact"])) : r("", !0),
					c(Sg, {
						"carrier-physical-properties": l.carrierPhysicalProperties,
						package: l.package
					}, null, 8, ["carrier-physical-properties", "package"]),
					c(ug, { package: l.package }, null, 8, ["package"]),
					l.trackTrace && l.package.shipment?.options?.requiresSignature ? (f(), n(b_, {
						key: 4,
						"track-trace": l.trackTrace
					}, null, 8, ["track-trace"])) : r("", !0),
					l.package.shipment?.direction === "INBOUND" && l.returnReasons.length ? (f(), n(ig, {
						key: 5,
						title: y(g)("trackTracePanel.details.returnReason")
					}, {
						default: x(() => [(f(!0), i(e, null, h(l.returnReasons, (e) => (f(), i("p", { key: e.name }, v(e.human), 1))), 128))]),
						_: 1
					}, 8, ["title"])) : r("", !0)
				])])
			])]),
			_: 2
		}, [l.withMarkAsDelivered ? {
			name: "subheader",
			fn: x(() => [c(y(oe), {
				class: "flex items-center gap-2 text-black",
				variant: "gray",
				onClick: u[0] ||= (e) => m("markAsDelivered")
			}, {
				default: x(() => [c(y(Be), { size: 24 }, {
					default: x(() => [c(y(um))]),
					_: 1
				}), a("span", null, v(y(g)("trackTracePanel.markAsDelivered")), 1)]),
				_: 1
			})]),
			key: "0"
		} : void 0]), 1032, ["aria-label", "title"]));
	}
});
//#endregion
export { Jh as Address, Rh as AdjustedDeliveryCard, Wm as AdjustedDeliveryModal, Zm as BPOST_CLASSIFICATION_LENGTHS, Qm as CARRIERS_WITHOUT_SUPPORT_FOR_MAX_CLASSIFICATION_LENGTH, Gm as CLASSIFICATION_MAX_LENGTH, Cp as CarrierIdToName, Tp as CarrierNameToId, Ym as DEFAULT_CLASSIFICATION_LENGTHS, Jm as DHL_CLASSIFICATION_LENGTHS, Zh as EcommercePlatform, Oh as LengthUnit, kh as LengthUnitConversions, Th as MassUnit, Eh as MassUnitConversions, eg as MyParcelShopExternalReference, Xm as POSTNL_CLASSIFICATION_LENGTHS, tg as Price, k_ as ShipmentTrackTraceSidePanel, Km as UPS_CLASSIFICATION_MIN_LENGTH, qm as USA_CLASSIFICATION_LENGTHS, gh as allowedToAssignUser, _h as allowedToCancel, vh as allowedToCreateShipment, yh as allowedToDownloadLabel, bh as allowedToPrintPackingSlip, xh as allowedToPrintPickList, Sh as allowedToReassignUser, Ch as allowedToUnassignUser, wh as canChoosePaperSize, Mh as convertLengthUnit, Dh as convertMassUnit, rh as defaultWeightsInGram, $m as getAllowedGoodsCodeLength, ah as getDefaultWeight, sh as getEoriFieldState, nh as getOrderRecipient, jh as getUnitTranslationKey, oh as getVatFieldState, pp as isBol, ap as isBpost, yp as isBrt, op as isCheapCargo, hh as isContentsAllowedForCountry, up as isDhlEuroPlus, lp as isDhlForYou, dp as isDhlNetwork, cp as isDhlParcelConnect, fp as isDhlSmallPackage, $f as isDigitalStamp, sp as isDpd, Yf as isEnvelope, vp as isGls, xp as isInPost, th as isLabelWithBarcode, eh as isLabelWithoutBarcode, Qf as isMailbox, Xf as isPackage, tp as isPallet, np as isPostNl, ip as isPostNlAndNotRow, rp as isPostNlAndRow, Sp as isPosteItaliane, dh as isRequiredBusinessContact, fh as isRequiredState, Zf as isSmallPackage, bp as isTrunkrs, ep as isUnfranked, mp as isUps, gp as isUpsExpressSaver, _p as isUpsNetwork, hp as isUpsStandard, Ep as toCarrierId, wp as toCarrierName, uh as withAdjustedDeliveryField, ph as withCustomsFields, mh as withCustomsInvoiceField, ch as withVolumeField, lh as withWeightField };
